webpackJsonp([1],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.modifyCurrencyCheckRule = exports.getCurrencyCheckRulePage = exports.deleteCurrencyCheckRule = exports.addCurrencyCheckRule = exports.selectExColumnValueBynSelectId = exports.getUploadResultDetail = exports.addRoleTemplate = exports.getTemplateByRoleList = exports.getTemplateByOppsiteRoleList = exports.selectColumnValueBynSelectId = exports.addFieldAuthority = exports.addRoleValueAuthority = exports.delFieldAuthority = exports.delRoleValueAuthority = exports.selectRoleFieldAuthorityBynSelectId = exports.selectRoleValueAuthorityBynSelectId = exports.selectRoleVisitAuthorityBynRoleId = exports.importWellness = exports.importTemplate = exports.selectTemplateLogPage = exports.modifyTemplate = exports.saveTemplate = exports.selectTemplateFieldList = exports.getUploadTemplateByRoleListPage = exports.selectUploadTemplatePage = exports.getRoleAuthorityList = exports.updateDetailRoleInfo = exports.addRoleAuthority = exports.getLock = exports.selectDynamicSP = exports.selectPSpConditionList = exports.updateProcedure = exports.addProcedure = exports.selectDynamic = exports.updateFavorite = exports.deleteSelectView = exports.simpleDownloadExport = exports.updateUserPwd = exports.reloadDownloadExport = exports.deleteSelect = exports.deleteTableRelevance = exports.updateTableRelevance = exports.updateSelect = exports.getSelectThirdTableList = exports.getSelectSecondTableList = exports.getDynamicColumnList = exports.getTableRelevanceListBySelectList = exports.addTableRelevance = exports.getTableRelevanceList = exports.addSelect = exports.getSelectList = exports.getReportColumns = exports.getReport = exports.getDynamicSQL = exports.getOptionByPermission2 = exports.getFormItemsList = exports.getSchemaNameList = exports.getDownloadExportList = exports.addDownloadExport = exports.updateSelectView = exports.addSelectView = exports.getSelectViewList = exports.getDatabaseInfoList = exports.modifyDatabaseInfo = exports.addDatabaseInfo = exports.selectBysTableName = exports.getBehaviorListt = exports.getSelectColumnList = exports.getSelectByRoleList = exports.getSelectByOppositeRoleList = exports.addDataBaseByRole = exports.updateRoleInfo = exports.addRoleInfo = exports.getRoleInfoList = exports.getUserInfoByRoleList = exports.getUserInfoByOppositeRoleList = exports.addUserRole = exports.addUserInfo = exports.updateUserInfo = exports.getUserInfoList = exports.loginOut = exports.loginSSO = exports.login = undefined;

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(84);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(268);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(165);

var _qs = __webpack_require__(614);

var _qs2 = _interopRequireDefault(_qs);

var _jsonp = __webpack_require__(607);

var _jsonp2 = _interopRequireDefault(_jsonp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function utf8ToBase64(str) {
	return window.btoa(unescape(encodeURIComponent(str)));
}

var service = _axios2.default.create({
	baseURL: "",
	timeout: 30 * 60 * 1000,
	headers: {
		'Content-Type': 'application/json;charset=UTF-8'
	}
});

service.interceptors.request.use(function (config) {
	if (!!sessionStorage.getItem('token')) {
		config['headers']['token'] = sessionStorage.getItem('token');
	}
	return config;
}, function (error) {
	_promise2.default.reject(error);
});

service.interceptors.response.use(function (response) {
	var res = response.data;
	if (res.code == "403") {
		sessionStorage.clear();
		window.location.reload();
	} else if (res.code == 0) {
		return response.data;
	} else {
		(0, _elementUi.Message)({
			message: res.message,
			type: 'error',
			duration: 5 * 1000
		});
		return _promise2.default.reject();
	}
}, function (error) {
	if (error.response.status == 403) {
		sessionStorage.clear();
		window.location.reload();
	}
	(0, _elementUi.Message)({
		message: error,
		type: 'error',
		duration: 5 * 1000
	});
	return _promise2.default.reject(error);
});

var service2 = _axios2.default.create({
	baseURL: "",
	timeout: 30 * 60 * 1000,
	headers: {
		"Content-Type": "multipart/form-data"
	}
});

service2.interceptors.request.use(function (config) {
	if (!!sessionStorage.getItem('token')) {
		config['headers']['token'] = sessionStorage.getItem('token');
	}
	return config;
}, function (error) {
	_promise2.default.reject(error);
});

service2.interceptors.response.use(function (response) {
	var res = response.data;
	if (res.code == "403") {
		sessionStorage.clear();
		window.location.reload();
	} else if (res.code == 0) {
		return response.data;
	} else {
		(0, _elementUi.Message)({
			message: res.message,
			type: 'error',
			duration: 5 * 1000
		});
		return _promise2.default.reject();
	}
}, function (error) {
	(0, _elementUi.Message)({
		message: error,
		type: 'error',
		duration: 5 * 1000
	});
	return _promise2.default.reject(error);
});

var login = exports.login = function login(params) {
	return service({
		url: '/dataportal/manager/login/login',
		method: "post",
		data: params
	});
};

var loginSSO = exports.loginSSO = function loginSSO(params) {
	return service({
		url: '/dataportal/manager/login/sso',
		method: "post",
		data: params
	});
};
var loginOut = exports.loginOut = function loginOut(params) {
	return service({
		url: '/dataportal/manager/login/loginOut',
		method: "post",
		data: params
	});
};

var getUserInfoList = exports.getUserInfoList = function getUserInfoList(params) {
	return service({
		url: '/dataportal/manager/userInfo/getUserInfoList',
		method: "post",
		data: params
	});
};

var updateUserInfo = exports.updateUserInfo = function updateUserInfo(params) {
	return service({
		url: '/dataportal/manager/userInfo/updateUserInfo',
		method: "post",
		data: params
	});
};

var addUserInfo = exports.addUserInfo = function addUserInfo(params) {
	return service({
		url: '/dataportal/manager/userInfo/addUserInfo',
		method: "post",
		data: params
	});
};
var addUserRole = exports.addUserRole = function addUserRole(params) {
	return service({
		url: '/dataportal/manager/userInfo/addUserRole',
		method: "post",
		data: params
	});
};

var getUserInfoByOppositeRoleList = exports.getUserInfoByOppositeRoleList = function getUserInfoByOppositeRoleList(params) {
	return service({
		url: '/dataportal/manager/userInfo/getUserInfoByOppositeRoleList',
		method: "post",
		data: params
	});
};
var getUserInfoByRoleList = exports.getUserInfoByRoleList = function getUserInfoByRoleList(params) {
	return service({
		url: '/dataportal/manager/userInfo/getUserInfoByRoleList',
		method: "post",
		data: params
	});
};

var getRoleInfoList = exports.getRoleInfoList = function getRoleInfoList(params) {
	return service({
		url: '/dataportal/manager/roleInfo/getRoleInfoList',
		method: "post",
		data: params
	});
};

var addRoleInfo = exports.addRoleInfo = function addRoleInfo(params) {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleInfo',
		method: "post",
		data: params
	});
};

var updateRoleInfo = exports.updateRoleInfo = function updateRoleInfo(params) {
	return service({
		url: '/dataportal/manager/roleInfo/updateRoleInfo',
		method: "post",
		data: params
	});
};
var addDataBaseByRole = exports.addDataBaseByRole = function addDataBaseByRole(params) {
	return service({
		url: '/dataportal/manager/roleInfo/addDataBaseByRole',
		method: "post",
		data: params
	});
};

var getSelectByOppositeRoleList = exports.getSelectByOppositeRoleList = function getSelectByOppositeRoleList(params) {
	return service({
		url: '/dataportal/manager/select/getSelectByOppositeRoleList',
		method: "post",
		data: params
	});
};
var getSelectByRoleList = exports.getSelectByRoleList = function getSelectByRoleList(params) {
	return service({
		url: '/dataportal/manager/select/getSelectByRoleList',
		method: "post",
		data: params
	});
};
var getSelectColumnList = exports.getSelectColumnList = function getSelectColumnList(params) {
	return service({
		url: '/dataportal/manager/select/getSelectColumnList',
		method: "post",
		data: params
	});
};
var getBehaviorListt = exports.getBehaviorListt = function getBehaviorListt(params) {
	return service({
		url: '/dataportal/manager/behaviorLog/getBehaviorList',
		method: "post",
		data: params
	});
};
var selectBysTableName = exports.selectBysTableName = function selectBysTableName(params) {
	return service({
		url: '/dataportal/manager/selectColumn/selectBysTableName',
		method: "post",
		data: params
	});
};

var addDatabaseInfo = exports.addDatabaseInfo = function addDatabaseInfo(params) {
	return service({
		url: '/dataportal/manager/databaseInfo/addDatabaseInfo',
		method: "post",
		data: params
	});
};
var modifyDatabaseInfo = exports.modifyDatabaseInfo = function modifyDatabaseInfo(params) {
	return service({
		url: '/dataportal/manager/databaseInfo/modifyDatabaseInfo',
		method: "post",
		data: params
	});
};
var getDatabaseInfoList = exports.getDatabaseInfoList = function getDatabaseInfoList(params) {
	return service({
		url: '/dataportal/manager/databaseInfo/getDatabaseInfoList',
		method: "post",
		data: params
	});
};
var getSelectViewList = exports.getSelectViewList = function getSelectViewList(params) {
	return service({
		url: '/dataportal/manager/selectView/getSelectViewList',
		method: "post",
		data: params
	});
};
var addSelectView = exports.addSelectView = function addSelectView(params) {
	return service({
		url: '/dataportal/manager/selectView/addSelectView',
		method: "post",
		data: params
	});
};
var updateSelectView = exports.updateSelectView = function updateSelectView(params) {
	return service({
		url: '/dataportal/manager/selectView/updateSelectView',
		method: "post",
		data: params
	});
};
var addDownloadExport = exports.addDownloadExport = function addDownloadExport(params) {
	if (params.extBody && params.extBody === 1) {
		params.extBody = utf8ToBase64((0, _stringify2.default)(params));
		delete params.sSelectFilter;
		delete params.sSelectFieldName;
	}
	return service({
		url: '/dataportal/manager/downloadExport/addDownloadExport',
		method: "post",
		data: params
	});
};
var getDownloadExportList = exports.getDownloadExportList = function getDownloadExportList(params) {
	return service({
		url: '/dataportal/manager/downloadExport/getDownloadExportList',
		method: "post",
		data: params
	});
};
var getSchemaNameList = exports.getSchemaNameList = function getSchemaNameList(params) {
	return service({
		url: '/dataportal/manager/select/getSchemaNameList',
		method: "post",
		data: params
	});
};

var getFormItemsList = exports.getFormItemsList = function getFormItemsList(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/getSelect',
		method: "post",
		data: params
	});
};

var getOptionByPermission2 = exports.getOptionByPermission2 = function getOptionByPermission2(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/getOptionByPermission2',
		method: "post",
		data: params
	});
};

var getDynamicSQL = exports.getDynamicSQL = function getDynamicSQL(params) {
	if (params.extBody && params.extBody === 1) {
		params.extBody = utf8ToBase64((0, _stringify2.default)(params));
		delete params.sSelectFilter;
		delete params.sSelectFieldName;
	}
	return service({
		url: '/dataportal/manager/dynamicInfo/getDynamicSQL',
		method: "post",
		data: params
	});
};

var getReport = exports.getReport = function getReport(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/getReport',
		method: "get",
		data: params
	});
};
var getReportColumns = exports.getReportColumns = function getReportColumns(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/getReportColumns',
		method: "post",
		data: params
	});
};
var getSelectList = exports.getSelectList = function getSelectList(params) {
	return service({
		url: '/dataportal/manager/select/getSelectList',
		method: "post",
		data: params
	});
};
var addSelect = exports.addSelect = function addSelect(params) {
	return service({
		url: '/dataportal/manager/select/addSelect',
		method: "post",
		data: params
	});
};

var getTableRelevanceList = exports.getTableRelevanceList = function getTableRelevanceList(params) {
	return service({
		url: '/dataportal/manager/tableRelevance/getTableRelevanceList',
		method: "post",
		data: params
	});
};

var addTableRelevance = exports.addTableRelevance = function addTableRelevance(params) {
	return service({
		url: '/dataportal/manager/tableRelevance/addTableRelevance',
		method: "post",
		data: params
	});
};
var getTableRelevanceListBySelectList = exports.getTableRelevanceListBySelectList = function getTableRelevanceListBySelectList(params) {
	return service({
		url: '/dataportal/manager/tableRelevance/getTableRelevanceListBySelectList',
		method: "post",
		data: params
	});
};

var getDynamicColumnList = exports.getDynamicColumnList = function getDynamicColumnList(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/getDynamicColumnList',
		method: "post",
		data: params
	});
};

var getSelectSecondTableList = exports.getSelectSecondTableList = function getSelectSecondTableList(params) {
	return service({
		url: '/dataportal/manager/select/getSelectSecondTableList',
		method: "post",
		data: params
	});
};

var getSelectThirdTableList = exports.getSelectThirdTableList = function getSelectThirdTableList(params) {
	return service({
		url: '/dataportal/manager/select/getSelectThirdTableList',
		method: "post",
		data: params
	});
};

var updateSelect = exports.updateSelect = function updateSelect(params) {
	return service({
		url: '/dataportal/manager/select/updateSelect',
		method: "post",
		data: params
	});
};
var updateTableRelevance = exports.updateTableRelevance = function updateTableRelevance(params) {
	return service({
		url: '/dataportal/manager/tableRelevance/updateTableRelevance',
		method: "post",
		data: params
	});
};

var deleteTableRelevance = exports.deleteTableRelevance = function deleteTableRelevance(params) {
	return service({
		url: '/dataportal/manager/tableRelevance/deleteTableRelevance',
		method: "post",
		data: params
	});
};
var deleteSelect = exports.deleteSelect = function deleteSelect(params) {
	return service({
		url: '/dataportal/manager/select/deleteSelect',
		method: "post",
		data: params
	});
};

var reloadDownloadExport = exports.reloadDownloadExport = function reloadDownloadExport(params) {
	return service({
		url: '/dataportal/manager/downloadExport/reloadDownloadExport',
		method: "post",
		data: params
	});
};

var updateUserPwd = exports.updateUserPwd = function updateUserPwd(params) {
	return service({
		url: '/dataportal/manager/userInfo/updateUserPwd',
		method: "post",
		data: params
	});
};

var simpleDownloadExport = exports.simpleDownloadExport = function simpleDownloadExport(params) {
	return service({
		url: '/dataportal/manager/downloadExport/simpleDownloadExport',
		method: "post",
		data: params
	});
};

var deleteSelectView = exports.deleteSelectView = function deleteSelectView(params) {
	return service({
		url: '/dataportal/manager/selectView/deleteSelectView',
		method: "post",
		data: params
	});
};
var updateFavorite = exports.updateFavorite = function updateFavorite(params) {
	return service({
		url: '/dataportal/manager/downloadExport/updateFavorite',
		method: "post",
		data: params
	});
};
var selectDynamic = exports.selectDynamic = function selectDynamic(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/selectDynamic',
		method: "post",
		data: params
	});
};
var addProcedure = exports.addProcedure = function addProcedure(params) {
	return service({
		url: '/dataportal/manager/select/addProcedure',
		method: "post",
		data: params
	});
};
var updateProcedure = exports.updateProcedure = function updateProcedure(params) {
	return service({
		url: '/dataportal/manager/select/updateProcedure',
		method: "post",
		data: params
	});
};

var selectPSpConditionList = exports.selectPSpConditionList = function selectPSpConditionList(params) {
	return service({
		url: '/dataportal/manager/select/selectPSpConditionList',
		method: "post",
		data: params
	});
};

var selectDynamicSP = exports.selectDynamicSP = function selectDynamicSP(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/selectDynamicSP',
		method: "post",
		data: params
	});
};

var getLock = exports.getLock = function getLock(params) {
	return service({
		url: '/dataportal/manager/dynamicInfo/getLock',
		method: "post",
		data: params
	});
};

var addRoleAuthority = exports.addRoleAuthority = function addRoleAuthority(params) {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleAuthority',
		method: "post",
		data: params
	});
};

var updateDetailRoleInfo = exports.updateDetailRoleInfo = function updateDetailRoleInfo(params) {
	return service({
		url: '/dataportal/manager/roleInfo/updateDetailRoleInfo',
		method: "post",
		data: params
	});
};

var getRoleAuthorityList = exports.getRoleAuthorityList = function getRoleAuthorityList(params) {
	return service({
		url: '/dataportal/manager/roleInfo/getRoleAuthorityList',
		method: "post",
		data: params
	});
};

var selectUploadTemplatePage = exports.selectUploadTemplatePage = function selectUploadTemplatePage(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/selectUploadTemplatePage',
		method: "post",
		data: params
	});
};

var getUploadTemplateByRoleListPage = exports.getUploadTemplateByRoleListPage = function getUploadTemplateByRoleListPage(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/getUploadTemplateByRoleListPage',
		method: "post",
		data: params
	});
};

var selectTemplateFieldList = exports.selectTemplateFieldList = function selectTemplateFieldList(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/selectTemplateFieldList',
		method: "post",
		data: params
	});
};

var saveTemplate = exports.saveTemplate = function saveTemplate(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/saveTemplate',
		method: "post",
		data: params
	});
};

var modifyTemplate = exports.modifyTemplate = function modifyTemplate(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/modifyTemplate',
		method: "post",
		data: params
	});
};

var selectTemplateLogPage = exports.selectTemplateLogPage = function selectTemplateLogPage(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/selectTemplateLogPage',
		method: "post",
		data: params
	});
};

var importTemplate = exports.importTemplate = function importTemplate(params) {
	return service2({
		url: '/dataportal/manager/uploadTemplate/importTemplate',
		method: 'post',
		data: params
	});
};

var importWellness = exports.importWellness = function importWellness(params) {
	return service2({
		url: '/dataportal/manager/uploadTemplate/importWellness',
		method: 'post',
		data: params
	});
};

var selectRoleVisitAuthorityBynRoleId = exports.selectRoleVisitAuthorityBynRoleId = function selectRoleVisitAuthorityBynRoleId(params) {
	return service({
		url: '/dataportal/manager/roleInfo/selectRoleVisitAuthorityBynRoleId',
		method: 'post',
		data: params
	});
};
var selectRoleValueAuthorityBynSelectId = exports.selectRoleValueAuthorityBynSelectId = function selectRoleValueAuthorityBynSelectId(params) {
	return service({
		url: '/dataportal/manager/roleInfo/selectRoleValueAuthorityBynSelectId',
		method: 'post',
		data: params
	});
};
var selectRoleFieldAuthorityBynSelectId = exports.selectRoleFieldAuthorityBynSelectId = function selectRoleFieldAuthorityBynSelectId(params) {
	return service({
		url: '/dataportal/manager/select/selectRoleFieldAuthorityBynSelectId',
		method: 'post',
		data: params
	});
};

var delRoleValueAuthority = exports.delRoleValueAuthority = function delRoleValueAuthority(params) {
	return service({
		url: '/dataportal/manager/roleInfo/delRoleValueAuthority',
		method: 'post',
		data: params
	});
};
var delFieldAuthority = exports.delFieldAuthority = function delFieldAuthority(params) {
	return service({
		url: '/dataportal/manager/roleInfo/delFieldAuthority',
		method: 'post',
		data: params
	});
};

var addRoleValueAuthority = exports.addRoleValueAuthority = function addRoleValueAuthority(params) {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleValueAuthority',
		method: 'post',
		data: params
	});
};
var addFieldAuthority = exports.addFieldAuthority = function addFieldAuthority(params) {
	return service({
		url: '/dataportal/manager/roleInfo/addFieldAuthority',
		method: 'post',
		data: params
	});
};
var selectColumnValueBynSelectId = exports.selectColumnValueBynSelectId = function selectColumnValueBynSelectId(params) {
	return service({
		url: '/dataportal/manager/roleInfo/selectColumnValueBynSelectId',
		method: 'post',
		data: params
	});
};

var getTemplateByOppsiteRoleList = exports.getTemplateByOppsiteRoleList = function getTemplateByOppsiteRoleList(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/getTemplateByOppositeRoleList',
		method: 'post',
		data: params
	});
};

var getTemplateByRoleList = exports.getTemplateByRoleList = function getTemplateByRoleList(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/getTemplateByRoleList',
		method: 'post',
		data: params
	});
};

var addRoleTemplate = exports.addRoleTemplate = function addRoleTemplate(params) {
	return service({
		url: '/dataportal/manager/roleInfo/addRoleTemplate',
		method: 'post',
		data: params
	});
};

var getUploadResultDetail = exports.getUploadResultDetail = function getUploadResultDetail(params) {
	return service({
		url: '/dataportal/manager/uploadTemplate/getUploadResultList',
		method: 'post',
		data: params
	});
};

var selectExColumnValueBynSelectId = exports.selectExColumnValueBynSelectId = function selectExColumnValueBynSelectId(params) {
	return service({
		url: '/dataportal/manager/roleInfo/selectExColumnValueBynSelectId',
		method: 'post',
		data: params
	});
};

var addCurrencyCheckRule = exports.addCurrencyCheckRule = function addCurrencyCheckRule(params) {
	return service({
		url: '/dataportal/manager/currencyCheckRule/addCurrencyCheckRule',
		method: 'post',
		data: params
	});
};
var deleteCurrencyCheckRule = exports.deleteCurrencyCheckRule = function deleteCurrencyCheckRule(params) {
	return service({
		url: '/dataportal/manager/currencyCheckRule/deleteCurrencyCheckRule',
		method: 'post',
		data: params
	});
};

var getCurrencyCheckRulePage = exports.getCurrencyCheckRulePage = function getCurrencyCheckRulePage(params) {
	return service({
		url: '/dataportal/manager/currencyCheckRule/getCurrencyCheckRulePage',
		method: 'post',
		data: params
	});
};

var modifyCurrencyCheckRule = exports.modifyCurrencyCheckRule = function modifyCurrencyCheckRule(params) {
	return service({
		url: '/dataportal/manager/currencyCheckRule/modifyCurrencyCheckRule',
		method: 'post',
		data: params
	});
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRouter = exports.rolesRouters = undefined;

var _Login = __webpack_require__(640);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(638);

var _2 = _interopRequireDefault(_);

var _3 = __webpack_require__(637);

var _4 = _interopRequireDefault(_3);

var _Home = __webpack_require__(639);

var _Home2 = _interopRequireDefault(_Home);

var _data = __webpack_require__(643);

var _data2 = _interopRequireDefault(_data);

var _role = __webpack_require__(644);

var _role2 = _interopRequireDefault(_role);

var _user = __webpack_require__(646);

var _user2 = _interopRequireDefault(_user);

var _template = __webpack_require__(645);

var _template2 = _interopRequireDefault(_template);

var _view = __webpack_require__(647);

var _view2 = _interopRequireDefault(_view);

var _check = __webpack_require__(642);

var _check2 = _interopRequireDefault(_check);

var _download = __webpack_require__(652);

var _download2 = _interopRequireDefault(_download);

var _favorite = __webpack_require__(653);

var _favorite2 = _interopRequireDefault(_favorite);

var _multi = __webpack_require__(655);

var _multi2 = _interopRequireDefault(_multi);

var _single = __webpack_require__(657);

var _single2 = _interopRequireDefault(_single);

var _select = __webpack_require__(656);

var _select2 = _interopRequireDefault(_select);

var _stored = __webpack_require__(658);

var _stored2 = _interopRequireDefault(_stored);

var _sso = __webpack_require__(648);

var _sso2 = _interopRequireDefault(_sso);

var _template3 = __webpack_require__(650);

var _template4 = _interopRequireDefault(_template3);

var _tupload = __webpack_require__(651);

var _tupload2 = _interopRequireDefault(_tupload);

var _result = __webpack_require__(649);

var _result2 = _interopRequireDefault(_result);

var _Nodata = __webpack_require__(641);

var _Nodata2 = _interopRequireDefault(_Nodata);

var _help = __webpack_require__(654);

var _help2 = _interopRequireDefault(_help);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rolesRouters = exports.rolesRouters = [{
  path: '/',
  component: _Home2.default,
  id: 1,
  meta: 1,
  name: '报告中心',
  children: [{
    path: '/select',
    component: _select2.default,
    meta: 1,
    name: '报告查看'
  }, {
    path: '/down',
    component: _download2.default,
    meta: 1,
    name: '报告下载'
  }]
}, {
  path: '/',
  component: _Home2.default,
  name: 'Admin',
  meta: 2,
  id: 2,
  children: [{
    path: '/user',
    component: _user2.default,
    meta: 2,
    name: 'User'
  }, {
    path: '/role',
    component: _role2.default,
    meta: 2,
    name: 'Role'
  }, {
    path: '/data',
    component: _data2.default,
    meta: 2,
    name: 'Data Source'
  }, {
    path: '/aTemplate',
    component: _template2.default,
    meta: 2,
    name: 'Upload Template'
  }, {
    path: '/view',
    component: _view2.default,
    meta: 2,
    name: 'View Log'
  }, {
    path: '/check',
    component: _check2.default,
    meta: 2,
    name: 'Check Rule'
  }]
}, {
  path: '/',
  component: _Home2.default,
  name: '上传中心',
  id: 3,
  meta: 3,
  children: [{
    path: '/tUpload',
    component: _tupload2.default,
    meta: 3,
    name: '文件上传'
  }, {
    path: '/template',
    component: _template4.default,
    meta: 3,
    name: '模板导入'
  }, {
    path: '/result',
    component: _result2.default,
    meta: 3,
    name: '上传日志'
  }]
}, {
  path: '/',
  component: _Home2.default,
  name: '帮助中心',
  id: 4,
  meta: 4,
  children: [{
    path: '/help',
    component: _help2.default,
    meta: 4,
    name: '帮助中心'
  }]
}, {
  path: '/',
  component: _Home2.default,
  name: 'Admin',
  id: 5,
  meta: 5,
  children: [{
    path: '/no',
    component: _Nodata2.default,
    meta: 5,
    name: ''
  }]
}];

var defaultRouter = exports.defaultRouter = [{
  path: '/sso',
  component: _sso2.default,
  name: 'login',
  hidden: true
}, {
  path: '/login_t',
  component: _Login2.default,
  name: 'login',
  hidden: true
}, {
  path: '/404',
  component: _2.default,
  name: '',
  hidden: true
}, {
  path: '/403',
  component: _4.default,
  name: '',
  hidden: true
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(166);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(308);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(309);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(664),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(12);

var _routes = __webpack_require__(164);

exports.default = {
  data: function data() {
    return {
      sysName: " Portal",
      sName: "",
      changeFlag: false,
      form: {
        oldPwd: "",
        newPwd: ""
      },
      dLastLogin: "",
      currentIndex: 0,
      tabIndex: 0
    };
  },

  computed: {
    routersList: function routersList() {
      var _arr = [];
      for (var i = 0, len = _routes.rolesRouters.length; i < len; i++) {
        if (sessionStorage.getItem("sRole").indexOf("Data") > -1 && _routes.rolesRouters[i].id == 1) {
          _arr.push(_routes.rolesRouters[i]);
        } else if (sessionStorage.getItem("sRole").indexOf("Admin") > -1 && _routes.rolesRouters[i].id == 2) {
          _arr.push(_routes.rolesRouters[i]);
        } else if (sessionStorage.getItem("sRole").indexOf("Upload") > -1 && _routes.rolesRouters[i].id == 3) {
          _arr.push(_routes.rolesRouters[i]);
        } else if (_routes.rolesRouters[i].id == 4) {
          _arr.push(_routes.rolesRouters[i]);
        }
      }

      return _arr;
    }
  },
  watch: {},
  methods: {
    clickMenuItem: function clickMenuItem(index, item) {
      this.currentIndex = index;
      this.tabIndex = 0;
      this.$router.push(item.children[0].path);
    },
    clickTab: function clickTab(index2, item2) {
      this.tabIndex = index2;
      this.$router.push(item2.path);
    },
    change: function change() {
      this.changeFlag = true;
    },
    save: function save() {
      var _this2 = this;

      if (!this.form.oldPwd) {
        this.$message.error("please enter old Password");
        return;
      }
      if (!this.form.newPwd) {
        this.$message.error("please enter new Password");
        return;
      }
      (0, _api.updateUserPwd)(this.form).then(function (res) {
        _this2.$refs.form.resetFields();
        _this2.changeFlag = false;
        _this2.$message("Change Success");
      });
    },

    logout: function logout() {
      var _this = this;
      this.$confirm("Confirm Exit?", "Tips", {
        type: "warning",
        customClass: 'customConfimClass'
      }).then(function () {
        (0, _api.loginOut)({}).then(function (res) {
          sessionStorage.clear();
          _this.$router.push("/login");
        });
      }).catch(function () {});
    },
    routerAClass: function routerAClass(item, index) {
      var data = {};
      data["one_" + item.meta + "_" + (index + 1)] = true;
      data["on"] = this.$route.path == item.path;
      return data;
    }
  },
  mounted: function mounted() {
    this.sName = sessionStorage.getItem("sName");
    this.dLastLogin = sessionStorage.getItem("dLastLogin");
  }
};

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			logining: false,
			ruleForm: {
				username: '',
				password: ''
			},
			rules: {
				username: [{
					required: true,
					message: 'Please enter the domain account',
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: 'Please enter the password',
					trigger: 'blur'
				}]
			},
			checked: true
		};
	},

	methods: {
		handleSubmit: function handleSubmit() {
			var _this2 = this;

			var _this = this;
			this.$refs.ruleForm.validate(function (valid) {
				if (valid) {
					_this2.logining = true;
					var loginParams = (0, _assign2.default)({}, _this2.ruleForm);

					(0, _api.login)({
						sAccount: loginParams.username,
						userPwd: loginParams.password
					}).then(function (res) {
						sessionStorage.setItem('userId', res.data.nUserId);
						sessionStorage.setItem('token', res.data.token);
						sessionStorage.setItem('sName', res.data.sName);
						sessionStorage.setItem('dLastLogin', res.data.dLastLogin);
						sessionStorage.setItem('sRole', res.data.sAuthority);
						sessionStorage.setItem('sRoleName', res.data.sRole);
						if (res.data.sAuthority == "") {
							_this2.$router.replace('/no');
						} else if (res.data.sAuthority.indexOf('Data') > -1) {
							var id = sessionStorage.getItem('id');
							if (id == null) {
								_this2.$router.replace({ path: '/select' });
							} else {
								_this2.$router.replace({ path: '/select?id=' + id });
								sessionStorage.removeItem('id');
							}
						} else if (res.data.sAuthority.indexOf('Admin') > -1) {
							_this2.$router.replace('/user');
						} else if (res.data.sAuthority.indexOf('Upload') > -1) {
							_this2.$router.replace('/template');
						}
					}).catch(function (res) {
						_this2.logining = false;
					});
				}
			});
		}
	}
};

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			addTableFlag: false,
			viewTableFlag: false,
			editTableFlag: false,
			form: {
				sDesc: '',
				sFieldName: '',
				sRuleName: '',
				sSchema: '',
				sTableName: ''
			},
			activeName: 'first',
			tableData1: [],
			tableData2: [],
			filters: {
				pageSize: 10,
				currentPage: 1
			},
			total: 0,
			tableData: []
		};
	},

	watch: {
		'form.sSchema': function formSSchema(newV, oldV) {
			var _this2 = this;

			if (newV != oldV) {
				this.form.sTableName = '';
				this.tableData2 = [];
				(0, _api.getSelectList)({
					currentPage: 1,
					nSelectType: 1,
					sSchema: newV,
					pageSize: 9999
				}).then(function (res) {
					_this2.tableData2 = res.data;
				});
			}
		}
	},
	mounted: function mounted() {
		var _this3 = this;

		this.getList();
		(0, _api.getDatabaseInfoList)({
			currentPage: 1,
			pageSize: 9999
		}).then(function (res) {
			_this3.tableData1 = res.data;
		});
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},
		toDetail: function toDetail(row) {
			this.form = row;
			this.viewTableFlag = true;
		},
		toEdit: function toEdit() {
			this.editTableFlag = true;
			this.viewTableFlag = false;
		},
		toDelete: function toDelete() {
			var _this4 = this;

			var _this = this;
			this.$confirm('Confirm to Delete ?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.deleteCurrencyCheckRule)(_this4.form).then(function (res) {
					_this4.viewTableFlag = false;
					_this4.getList();
				});
			}).catch(function () {});
		},

		toAdd: function toAdd() {
			this.form = {
				sDesc: '',
				sFieldName: '',
				sRuleName: '',
				sSchema: '',
				sTableName: ''
			};
			this.addTableFlag = true;
		},
		saveEditTable: function saveEditTable() {
			var _this5 = this;

			if (!this.form.sRuleName) {
				return this.$message.error('Please enter the rule name');
			}
			if (!this.form.sSchema) {
				return this.$message.error('Please select the schema');
			}
			if (!this.form.sTableName) {
				return this.$message.error('Please select the table');
			}
			if (!this.form.sFieldName) {
				return this.$message.error('Please enter the column name');
			}
			(0, _api.modifyCurrencyCheckRule)(this.form).then(function (res) {
				_this5.editTableFlag = false;
				_this5.getList();
			});
		},
		saveTable: function saveTable() {
			var _this6 = this;

			if (!this.form.sRuleName) {
				return this.$message.error('Please enter the rule name');
			}
			if (!this.form.sSchema) {
				return this.$message.error('Please select the schema');
			}
			if (!this.form.sTableName) {
				return this.$message.error('Please select the table');
			}
			if (!this.form.sFieldName) {
				return this.$message.error('Please enter the column name');
			}
			(0, _api.addCurrencyCheckRule)(this.form).then(function (res) {
				_this6.addTableFlag = false;
				_this6.getList();
			});
		},

		getList: function getList() {
			var _this7 = this;

			var param = (0, _assign2.default)({}, this.filters);
			(0, _api.getCurrencyCheckRulePage)(param).then(function (res) {
				_this7.tableData = res.data;
				_this7.total = res.page.totalCount * 1;
			});
		}
	}
};

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(12);

exports.default = {
	data: function data() {
		return {
			addSPFlag: false,
			viewSPFlag: false,
			spData: [],
			editDataBaseFlag: false,
			form3: {
				nSelectType: 2,
				sName: '',
				sSchemaName: '',
				sSelectName: '',
				spConditionList: [{
					sParameterName: '',
					sParameterType: '',
					sParameterCode: '',
					nSequence: 0,
					sRequired: '0'
				}],
				selectColumnList: [{
					sColumnCode: '',
					sColumnName: '',
					sColumnType: ''
				}]
			},
			view3: {
				spConditionList: [],
				list: []
			},
			addDataBaseFlag: false,
			addDataBaseForm: {
				sDatabaseIp: '',
				sUsername: '',
				sPassword: '',
				sSchema: ''
			},
			editDataBaseForm: {
				sDatabaseIp: '',
				sUsername: '',
				sPassword: '',
				sSchema: ''
			},
			tableData3: [],
			addTableFlag: false,
			viewTableFlag: false,
			tableData1: [],
			options: [{
				id: 1,
				name: 'Table'
			}],
			options2: [{
				id: '',
				name: 'Select Type'
			}, {
				id: 'Number',
				name: 'Number'
			}, {
				id: 'String',
				name: 'String'
			}, {
				id: 'Datetime',
				name: 'Datetime'
			}],
			options3: [{
				id: '1',
				name: 'Required'
			}, {
				id: '0',
				name: 'UnRequired'
			}],
			biao1: [],
			biao2: [],
			ziduan1: [],
			ziduan2: [],
			form: {
				nSelectType: 1,
				sName: '',
				sSchemaName: '',
				sSelectName: '',
				selectColumnList: [{
					sColumnCode: '',
					sColumnName: '',
					sColumnType: ''
				}],
				spConditionList: [{
					sParameterCode: '',
					sParameterName: '',
					sParameterType: ''
				}]
			},
			form2: {
				nSelect1Id: '',
				nSelect2Id: '',
				ku1: '',
				ku2: '',
				selectColumnList: [{
					nSelect1Key: '',
					nSelect2Key: ''
				}]
			},
			view: {},
			view2: {
				nSelect1Id: {},
				nSelect2Id: {},
				list: []
			},
			addTableRelatiionFlag: false,
			viewTableRelatiionFlag: false,
			activeName: 'first',
			tableData2: [],
			filters: {}
		};
	},

	methods: {
		queryTableColumns: function queryTableColumns() {
			var _this2 = this;

			(0, _api.selectBysTableName)({
				sTableName: this.form.sSelectName,
				sSchema: this.form.sSchemaName
			}).then(function (res) {
				var arr = [];
				var _type = {
					numeric: "Number",
					nvarchar: "String",
					varchar: "String",
					datetime: "Datetime",
					datetime2: "Datetime",
					'int': "Number"
				};
				res.data.forEach(function (one) {
					arr.push({
						nColumnOrder: one.nOrder,
						sColumnCode: one.name,
						sColumnName: one.name,
						sColumnType: _type[one.type]
					});
				});
				_this2.form.selectColumnList = arr;
			});
		},
		saveSP: function saveSP() {
			var _this3 = this;

			if (!this.form3.sName) {
				this.$message.error('Please enter the name');
				return;
			}
			if (!this.form3.sSchemaName) {
				this.$message.error('Please enter the Schema');
				return;
			}
			if (!this.form3.sSelectName) {
				this.$message.error('Please select the DB table name');
				return;
			}
			var flag = false;
			for (var i = 0; i < this.form3.selectColumnList.length; i++) {
				if (!this.form3.selectColumnList[i]['sColumnName']) {
					flag = true;
					this.$message.error('Please enter the display column name');
					return;
				}
				if (!this.form3.selectColumnList[i]['sColumnCode']) {
					flag = true;
					this.$message.error('Please enter the DB column name');
					return;
				}
				if (!this.form3.selectColumnList[i]['sColumnType']) {
					flag = true;
					this.$message.error('Please select the DB column Type');
					return;
				}
			}
			var flag = false;
			for (var i = 0; i < this.form3.spConditionList.length; i++) {
				this.form3.spConditionList[i]['nSequence'] = i;
				if (!this.form3.spConditionList[i]['sParameterName']) {
					flag = true;
					this.$message.error('Please enter the SP Parameter Name');
					return;
				}
				if (!this.form3.spConditionList[i]['sParameterCode']) {
					flag = true;
					this.$message.error('Please enter the SP Parameter Code');
					return;
				}
				if (!this.form3.spConditionList[i]['sParameterType']) {
					flag = true;
					this.$message.error('Please select the SP Parameter Type');
					return;
				}
			}
			if (flag == true) {
				return;
			}
			(0, _api.addProcedure)(this.form3).then(function (res) {
				_this3.addSPFlag = false;
				_this3.$refs.form3.resetFields();
				_this3.$message('Add Success');
				_this3.getAlltable();
			});
		},
		addSP: function addSP() {
			this.addSPFlag = true;
			this.form3.spConditionList = [{
				sParameterName: '',
				sParameterType: '',
				sParameterCode: '',
				nSequence: 0,
				sRequired: '0'
			}];
			this.form3.selectColumnList = [{
				sColumnCode: '',
				sColumnName: '',
				sColumnType: ''
			}];
		},
		addTable: function addTable() {
			this.addTableFlag = true;
			this.form.selectColumnList = [{
				nColumnOrder: '1',
				sParameterCode: '',
				sParameterName: '',
				sParameterType: ''
			}];
		},
		addTableRelation: function addTableRelation() {
			this.addTableRelatiionFlag = true;
			this.form2.selectColumnList = [{
				nSelect1Key: '',
				nSelect2Key: ''
			}];
		},
		change: function change(type) {
			var _this4 = this;

			this.form2.ku2 = this.form2.ku1;
			(0, _api.getSelectList)({
				currentPage: 1,
				sSchemaName: type == 1 ? this.form2.ku1 : this.form2.ku2,
				pageSize: 9999
			}).then(function (res) {
				_this4.biao1 = res.data;
				_this4.biao2 = res.data;
			});
		},
		change2: function change2(type) {
			var _this5 = this;

			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: type == 1 ? this.form2.nSelect1Id : this.form2.nSelect2Id,
				pageSize: 9999
			}).then(function (res) {
				if (type == 1) {
					_this5.ziduan1 = res.data;
				} else {
					_this5.ziduan2 = res.data;
				}
			});
		},
		showDetail3: function showDetail3(item) {
			var _this6 = this;

			(0, _api.selectPSpConditionList)({
				nSelectId: item.nSelectId
			}).then(function (res) {
				res.data.sort(function (a, b) {
					return a.nSequence - b.nSequence;
				});
				item.spConditionList = res.data;
				_this6.view3 = item;
				_this6.viewSPFlag = true;
			});
		},
		showDetail: function showDetail(item) {
			this.view = item;
			this.viewTableFlag = true;
		},
		showDetail2: function showDetail2(item) {
			var _this7 = this;

			this.view2 = item;
			(0, _api.getSelectList)({
				currentPage: 1,
				sSchemaName: item.nSelect1Id.sSchemaName,
				pageSize: 9999
			}).then(function (res) {
				_this7.biao1 = res.data;
				(0, _api.getSelectList)({
					currentPage: 1,
					sSchemaName: item.nSelect2Id.sSchemaName,
					pageSize: 9999
				}).then(function (res) {
					_this7.biao2 = res.data;
				});
			});
			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: item.nSelect1Id.nSelectId,
				pageSize: 9999
			}).then(function (res) {
				_this7.ziduan1 = res.data;
				(0, _api.getSelectColumnList)({
					currentPage: 1,
					nSelectId: item.nSelect2Id.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					_this7.ziduan2 = res.data;
				});
			});
			this.viewTableRelatiionFlag = true;
		},
		deleteSpTable: function deleteSpTable() {
			var _this = this;
			this.$confirm('Confirm to Delete Stored Procedure?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.deleteSelect)({
					nSelectId: _this.view3.nSelectId
				}).then(function (res) {
					_this.viewSPFlag = false;
					_this.$message('Delete Success');
					_this.getAlltable();
				});
			}).catch(function () {});
		},
		updateSpTable: function updateSpTable() {
			var _this8 = this;

			var obj = {
				sName: this.view3.sName,
				nSelectType: this.view3.nSelectType,
				nSelectId: this.view3.nSelectId,
				sSchemaName: this.view3.sSchemaName,
				sSelectName: this.view3.sSelectName,
				selectColumnList: [],
				spConditionList: []
			};
			var arr = [];
			for (var i = 0; i < this.view3.list.length; i++) {
				arr.push({
					sColumnCode: this.view3.list[i]['sColumnCode'],
					sColumnName: this.view3.list[i]['sColumnName'],
					sColumnType: this.view3.list[i]['sColumnType']
				});
			}
			for (var i = 0; i < this.view3.spConditionList.length; i++) {
				this.view3.spConditionList[i]['nSequence'] = i;
			}
			obj.selectColumnList = arr;
			obj.spConditionList = this.view3.spConditionList;

			(0, _api.updateProcedure)(obj).then(function (res) {
				_this8.viewSPFlag = false;
				_this8.$message('Update Success');
				_this8.getAlltable();
			});
		},
		deleteTable: function deleteTable() {
			var _this9 = this;

			var _this = this;
			(0, _api.getSelectSecondTableList)({
				nSelect1Id: _this.view.nSelectId,
				sSchemaName: _this.view.sSchemaName
			}).then(function (res) {
				if (res.data.length == 0) {
					_this9.$confirm('Confirm to Delete Table?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					}).then(function () {
						(0, _api.deleteSelect)({
							nSelectId: _this.view.nSelectId
						}).then(function (res) {
							_this.viewTableFlag = false;
							_this.$message('Delete Success');
							_this.getAlltable();
						});
					}).catch(function () {});
				} else {
					var arr = [];
					for (var i = 0; i < res.data.length; i++) {
						arr.push(res.data[i]['sSchemaName'] + '.' + res.data[i]['sSelectName']);
					}
					_this9.$confirm('Confirm to Delete Table? This table has relations to ' + arr.join(','), 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					}).then(function () {
						(0, _api.deleteSelect)({
							nSelectId: _this.view.nSelectId
						}).then(function (res) {
							_this.viewTableFlag = false;
							_this.$message('Delete Success');
							_this.getAlltable();
						});
					}).catch(function () {});
				}
			});
		},
		updateTable: function updateTable() {
			var _this10 = this;

			var obj = {
				sName: this.view.sName,
				nSelectType: this.view.nSelectType,
				nSelectId: this.view.nSelectId,
				sSchemaName: this.view.sSchemaName,
				sSelectName: this.view.sSelectName,
				selectColumnList: []
			};
			var arr = [];
			for (var i = 0; i < this.view.list.length; i++) {
				arr.push({
					sColumnCode: this.view.list[i]['sColumnCode'],
					sColumnName: this.view.list[i]['sColumnName'],
					sColumnType: this.view.list[i]['sColumnType'],
					nColumnOrder: this.view.list[i]['nColumnOrder']
				});
			}
			obj.selectColumnList = arr;

			(0, _api.updateSelect)(obj).then(function (res) {
				_this10.viewTableFlag = false;
				_this10.$message('Update Success');
				_this10.getAlltable();
			});
		},
		saveTable: function saveTable() {
			var _this11 = this;

			if (this.form.nSelectType == 1) {
				delete this.form.spConditionList;
			}
			if (!this.form.sName) {
				this.$message.error('Please enter the name');
				return;
			}
			if (!this.form.sSchemaName) {
				this.$message.error('Please enter the Schema');
				return;
			}
			if (!this.form.sSelectName) {
				this.$message.error('Please select the DB table name');
				return;
			}
			var flag = false;
			for (var i = 0; i < this.form.selectColumnList.length; i++) {
				if (!this.form.selectColumnList[i]['sColumnName']) {
					flag = true;
					this.$message.error('Please enter the display column name');
					return;
				}
				if (!this.form.selectColumnList[i]['sColumnCode']) {
					flag = true;
					this.$message.error('Please enter the DB column name');
					return;
				}
				if (!this.form.selectColumnList[i]['sColumnType']) {
					flag = true;
					this.$message.error('Please select the DB column Type');
					return;
				}
			}
			if (flag == true) {
				return;
			}
			(0, _api.addSelect)(this.form).then(function (res) {
				_this11.addTableFlag = false;
				_this11.$refs.form.resetFields();
				_this11.$message('Add Success');
				_this11.getAlltable();
			});
		},
		DeleteTableRelation: function DeleteTableRelation() {
			var _this = this;
			this.$confirm('Confirm to Delete Table Relation?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.deleteTableRelevance)({
					nSelect1Id: _this.view2.nSelect1Id.nSelectId,
					nSelect2Id: _this.view2.nSelect2Id.nSelectId
				}).then(function (res) {
					_this.viewTableRelatiionFlag = false;
					_this.$message('Delete Success');
					_this.getAlltable();
				});
			}).catch(function () {});
		},
		UpdateTableRelation: function UpdateTableRelation() {
			var _this12 = this;

			var obj = {
				nSelect1Id: this.view2.nSelect1Id.nSelectId,
				nSelect2Id: this.view2.nSelect2Id.nSelectId,
				selectColumnList: []
			};
			var arr = [];
			for (var i = 0; i < this.view2.list.length; i++) {
				arr.push({
					nSelect1Key: this.view2.list[i]['nSelect1Key'],
					nSelect2Key: this.view2.list[i]['nSelect2Key']
				});
			}
			obj.selectColumnList = arr;
			(0, _api.updateTableRelevance)(obj).then(function (res) {
				_this12.viewTableRelatiionFlag = false;
				_this12.$message('Update Success');
				_this12.getAlltable();
			});
		},
		SaveTableRelation: function SaveTableRelation() {
			var _this13 = this;

			if (!this.form2.nSelect1Id) {
				this.$message.error('Please enter the DB Table Name1');
				return;
			}
			if (!this.form2.nSelect2Id) {
				this.$message.error('Please enter the DB Table Name2');
				return;
			}
			var flag = false;

			for (var i = 0; i < this.form2.selectColumnList.length; i++) {
				if (!this.form2.selectColumnList[i]['nSelect1Key']) {
					flag = true;
					this.$message.error('Please select the Relation Colunm1');
					return;
				}
				if (!this.form2.selectColumnList[i]['nSelect2Key']) {
					flag = true;
					this.$message.error('Please select the Relation Colunm2');
					return;
				}
			}
			if (flag == true) {
				return;
			}

			(0, _api.addTableRelevance)(this.form2).then(function (res) {
				_this13.addTableRelatiionFlag = false;
				_this13.$refs.form2.resetFields();
				_this13.$message('Add Success');
				_this13.getAlltable();
			});
		},
		addRelationCloumn: function addRelationCloumn(item) {
			item.push({
				nSelect1Key: '',
				nSelect2Key: ''
			});
		},
		deleteRelationCloumn: function deleteRelationCloumn(item, index) {
			item.splice(index, 1);
		},
		adddisplayname: function adddisplayname(item) {
			try {
				var max = item[item.length - 1]['nColumnOrder'] * 1 + 1;
			} catch (e) {
				var max = item.length + 1;
			}
			item.push({
				nColumnOrder: max,
				sColumnCode: '',
				sColumnName: '',
				sColumnType: ''
			});
		},
		deletedisplayname: function deletedisplayname(item, index) {
			item.splice(index, 1);
		},
		addspname: function addspname(item) {
			item.push({
				sColumnCode: '',
				sColumnName: '',
				sColumnType: ''
			});
		},
		deletesppartyname: function deletesppartyname(item, index) {
			item.splice(index, 1);
		},
		addsppartyname: function addsppartyname(item) {
			item.push({
				sParameterName: '',
				sParameterType: '',
				sParameterCode: '',
				nSequence: item.length,
				sRequired: '0'
			});
		},
		deletespname: function deletespname(item, index) {
			item.splice(index, 1);
		},
		saveAddDataBaseFlag: function saveAddDataBaseFlag() {
			var _this14 = this;

			if (!this.addDataBaseForm.sDatabaseIp) {
				this.$message.error('Please enter database Ip');
				return;
			}
			if (!this.addDataBaseForm.sSchema) {
				this.$message.error('Please enter the schema');
				return;
			}
			if (!this.addDataBaseForm.sUsername) {
				this.$message.error('Please enter the User name');
				return;
			}
			if (!this.addDataBaseForm.sPassword) {
				this.$message.error('Please enter the password');
				return;
			}
			(0, _api.addDatabaseInfo)(this.addDataBaseForm).then(function (res) {
				_this14.$refs.addDataBaseForm.resetFields();
				_this14.addDataBaseFlag = false;
				_this14.getListDatabase();
			});
		},
		toDataDetail: function toDataDetail(item) {
			this.editDataBaseForm = item;
			this.editDataBaseFlag = true;
		},
		saveEditDataBaseFlag: function saveEditDataBaseFlag() {
			var _this15 = this;

			if (!this.editDataBaseForm.sDatabaseIp) {
				this.$message.error('Please enter database Ip');
				return;
			}
			if (!this.editDataBaseForm.sSchema) {
				this.$message.error('Please enter the schema');
				return;
			}
			if (!this.editDataBaseForm.sUsername) {
				this.$message.error('Please enter the User name');
				return;
			}
			if (!this.editDataBaseForm.sPassword) {
				this.$message.error('Please enter the password');
				return;
			}
			(0, _api.modifyDatabaseInfo)(this.editDataBaseForm).then(function (res) {
				_this15.$refs.editDataBaseForm.resetFields();
				_this15.editDataBaseFlag = false;
				_this15.getListDatabase();
			});
		},
		saveDeleteDataBaseFlag: function saveDeleteDataBaseFlag() {
			var _this = this;
			this.$confirm('Confirm to Delete?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				_this.getListDatabase();
			}).catch(function () {});
		},
		getListDatabase: function getListDatabase() {
			var _this16 = this;

			(0, _api.getDatabaseInfoList)({
				currentPage: 1,
				pageSize: 9999
			}).then(function (res) {
				_this16.tableData3 = res.data;
			});
		},
		getAlltable: function getAlltable() {
			var _this17 = this;

			(0, _api.getSelectColumnList)({
				nSelectType: 1,
				currentPage: 1,
				pageSize: 9999
			}).then(function (res2) {
				var obj = {};
				var obj2 = {};
				for (var i = 0; i < res2.data.length; i++) {
					if (res2.data[i]['nSelectType'] == 1) {
						if (!obj[res2.data[i]['nSelectId']]) {
							obj[res2.data[i]['nSelectId']] = res2.data[i];
							obj[res2.data[i]['nSelectId']]['list'] = [];
						}
						obj[res2.data[i]['nSelectId']]['list'].push(res2.data[i]);
					} else {
						if (!obj2[res2.data[i]['nSelectId']]) {
							obj2[res2.data[i]['nSelectId']] = res2.data[i];
							obj2[res2.data[i]['nSelectId']]['list'] = [];
							obj2[res2.data[i]['nSelectId']]['spConditionList'] = [];
						}
						obj2[res2.data[i]['nSelectId']]['list'].push(res2.data[i]);
					}
				}
				var arr = [];
				for (var i in obj) {
					arr.push(obj[i]);
				}
				_this17.tableData1 = arr;

				var arr = [];
				for (var i in obj2) {
					arr.push(obj2[i]);
				}
				_this17.spData = arr;

				(0, _api.getTableRelevanceList)({
					currentPage: 1,
					pageSize: 9999
				}).then(function (res3) {
					var obj = {};
					for (var i = 0; i < res3.data.length; i++) {
						if (!obj[res3.data[i]['nSelect1Id'] + '-' + res3.data[i]['nSelect2Id']]) {
							obj[res3.data[i]['nSelect1Id'] + '-' + res3.data[i]['nSelect2Id']] = {
								nSelect1Id: res3.data[i]['nSelect1Id'],
								nSelect2Id: res3.data[i]['nSelect2Id'],
								list: []
							};
						}
						obj[res3.data[i]['nSelect1Id'] + '-' + res3.data[i]['nSelect2Id']]['list'].push(res3.data[i]);
					}
					var arr = [];
					for (var i in obj) {
						arr.push(obj[i]);
					}
					for (var i = 0; i < arr.length; i++) {
						for (var j = 0; j < _this17.tableData1.length; j++) {
							if (arr[i]['nSelect1Id'] == _this17.tableData1[j]['nSelectId']) {
								arr[i]['nSelect1Id'] = _this17.tableData1[j];
							}
							if (arr[i]['nSelect2Id'] == _this17.tableData1[j]['nSelectId']) {
								arr[i]['nSelect2Id'] = _this17.tableData1[j];
							}
						}
					}
					_this17.tableData2 = arr;
				});
			});
		}
	},
	mounted: function mounted() {
		this.getAlltable();
		this.getListDatabase();
	}
};

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			activeName: 'first',
			addRoleFlag: false,
			EditRoleFlag: false,
			checkAll: false,
			isIndeterminate: true,
			options: [{
				id: '1',
				name: 'Active'
			}, {
				id: '0',
				name: 'Inactive'
			}],
			filters: {
				sRoleName: '',
				sState: '1',
				pageSize: 10,
				currentPage: 1
			},
			total: 0,
			form: {
				sRoleName: '',
				sRoleDescribe: '',
				roles: []
			},
			detailForm: {
				nRoleId: "",
				sRoleName: '',
				sRoleDescribe: '',
				roles: []
			},
			tableData: [],
			tableData3: [],
			tableData4: [],
			totalRoleList: [],
			filters2: {
				nRoleId: '',
				nUserIds: []
			},
			leftRoleList2: [],
			filters3: {
				nRoleId: '',
				nSelectIds: []
			},
			filters4: {
				nRoleId: '',
				pageSize: 10,
				currentPage: 1
			},
			filters5: {
				nRoleId: '',
				nTemplateIds: []
			},
			leftRoleList5: [],
			leftRoleList3: [],
			options3: [{
				id: "Admin",
				name: "Admin"
			}, {
				id: "Data",
				name: "Data"
			}, {
				id: "Upload",
				name: "Upload"
			}],
			options4: [{}],
			ViewFlag: false,
			ViewFieldFlag: false,
			ViewOptions: [],
			ViewFieldForm: {
				nRoleId: "",
				nSelectId: "",
				list: []
			},
			ViewForm: {
				nRoleId: "",
				nSelectId: "",
				list: [{
					sColumnCode: "",
					sColumnValue: ""
				}]
			}
		};
	},
	mounted: function mounted() {
		this.getList();
	},

	methods: {
		handleCheckAllChange: function handleCheckAllChange(flag) {
			if (flag == true) {
				var arr = [];
				for (var i = 0; i < this.ViewOptions.length; i++) {
					arr.push(this.ViewOptions[i]['sColumnCode']);
				}
				this.ViewFieldForm.list = arr;
			} else {
				this.ViewFieldForm.list = [];
			}
			this.isIndeterminate = false;
		},
		saveViewFlag: function saveViewFlag() {
			var _this2 = this;

			var arr = [];
			this.ViewForm.list.forEach(function (one) {
				arr.push({
					nRoleId: _this2.ViewForm.nRoleId,
					nSelectId: _this2.ViewForm.nSelectId,
					sColumnCode: one.sColumnCode,
					sColumnValue: one.sColumnValue
				});
			});
			if (arr.length == 0) {
				(0, _api.delRoleValueAuthority)({
					nRoleId: this.ViewForm.nRoleId,
					nSelectId: this.ViewForm.nSelectId
				}).then(function (res) {
					_this2.$message('Update Success');
					_this2.ViewFlag = false;
				});
			} else {
				(0, _api.addRoleValueAuthority)(arr).then(function (res) {
					_this2.$message('Update Success');
					_this2.ViewFlag = false;
				});
			}
		},
		saveViewFieldFlag: function saveViewFieldFlag() {
			var _this3 = this;

			var arr = [];

			this.ViewFieldForm.list.forEach(function (one) {
				arr.push({
					nRoleId: _this3.ViewFieldForm.nRoleId,
					nSelectId: _this3.ViewFieldForm.nSelectId,
					sColumnCode: one
				});
			});
			if (arr.length == 0) {
				(0, _api.delFieldAuthority)({
					nRoleId: this.ViewFieldForm.nRoleId,
					nSelectId: this.ViewFieldForm.nSelectId
				}).then(function (res) {
					_this3.$message('Update Success');
					_this3.ViewFieldFlag = false;
				});
			} else {
				(0, _api.addFieldAuthority)(arr).then(function (res) {
					_this3.$message('Update Success');
					_this3.ViewFieldFlag = false;
				});
			}
		},
		addView: function addView() {
			this.ViewForm.list.push({
				sColumnCode: "",
				sColumnValue: ""
			});
		},
		deleteView: function deleteView(index) {
			this.ViewForm.list.splice(index, 1);
		},
		changeDetail1: function changeDetail1(data) {
			var _this4 = this;

			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: data.nSelectId,
				pageSize: 9999
			}).then(function (res) {
				_this4.ViewOptions = res.data;
				(0, _api.selectRoleValueAuthorityBynSelectId)({
					nSelectId: data.nSelectId,
					nRoleId: data.nRoleId
				}).then(function (res) {
					_this4.ViewForm.nSelectId = data.nSelectId;
					_this4.ViewForm.nRoleId = data.nRoleId;
					_this4.ViewForm.list = res.data;
					_this4.ViewFlag = true;
				});
			});
		},
		changeDetail2: function changeDetail2(data) {
			var _this5 = this;

			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: data.nSelectId,
				pageSize: 9999
			}).then(function (res) {

				(0, _api.selectRoleFieldAuthorityBynSelectId)({
					nSelectId: data.nSelectId,
					nRoleId: data.nRoleId
				}).then(function (res) {
					_this5.ViewFieldForm.nSelectId = data.nSelectId;
					_this5.ViewFieldForm.nRoleId = data.nRoleId;
					_this5.ViewOptions = res.data;
					var arr = [];
					res.data.forEach(function (one) {
						if (one.fieldStatus == 1) {
							arr.push(one.sColumnCode);
						}
					});
					_this5.ViewFieldForm.list = arr;
					_this5.ViewFieldFlag = true;
				});
			});
		},
		handleClick: function handleClick(tab, event) {
			this.queryInit();
		},
		toDetailRole: function toDetailRole(data) {
			var _this6 = this;

			(0, _api.getRoleAuthorityList)({
				nRoleId: data.nRoleId
			}).then(function (res) {
				if (res.data.length == 0) {
					_this6.detailForm.nRoleId = data.nRoleId;
					_this6.detailForm.sRoleName = data.sRoleName;
					_this6.detailForm.sRoleDescribe = data.sRoleDescribe;
					_this6.detailForm.roles = [];
					_this6.EditRoleFlag = true;
				} else {
					_this6.detailForm.nRoleId = data.nRoleId;
					_this6.detailForm.sRoleName = data.sRoleName;
					_this6.detailForm.sRoleDescribe = data.sRoleDescribe;
					_this6.detailForm.roles = res.data[0].sAuthority.split(',');
					_this6.EditRoleFlag = true;
				}
			});
		},
		saveEdit: function saveEdit() {
			var _this7 = this;

			if (!this.detailForm.sRoleName) {
				this.$message.error('Please enter the role name');
				return;
			}
			if (!this.detailForm.sRoleDescribe) {
				this.$message.error('Please enter the role describe');
				return;
			}
			if (this.detailForm.roles.length == 0) {
				this.$message.error('Please select the Authority');
				return;
			}

			(0, _api.updateDetailRoleInfo)({
				nRoleId: this.detailForm.nRoleId,
				sRoleDescribe: this.detailForm.sRoleDescribe,
				sRoleName: this.detailForm.sRoleName,
				sAuthority: this.detailForm.roles.join(',')
			}).then(function (res) {
				_this7.$refs.detailForm.resetFields();
				_this7.reGetList();
				_this7.$message('Update Success');
				_this7.EditRoleFlag = false;
			});
		},

		queryInit: function queryInit() {
			var _this8 = this;

			(0, _api.getRoleInfoList)({
				pageSize: 9999,
				sState: "1",
				currentPage: 1
			}).then(function (res) {
				_this8.totalRoleList = res.data;
			});
		},
		change2: function change2() {
			var _this9 = this;

			if (!!this.filters2.nRoleId) {
				(0, _api.getUserInfoByOppositeRoleList)({
					pageSize: 9999,
					nRoleId: this.filters2.nRoleId,
					currentPage: 1
				}).then(function (res) {
					var arr = [];
					for (var i = 0; i < res.data.length; i++) {
						arr.push({
							key: res.data[i]['nUserId'],
							label: res.data[i]['sName']
						});
					}
					(0, _api.getUserInfoByRoleList)({
						pageSize: 9999,
						nRoleId: _this9.filters2.nRoleId,
						currentPage: 1
					}).then(function (res2) {
						var _arr = [];
						for (var i = 0; i < res2.data.length; i++) {
							arr.push({
								key: res2.data[i]['nUserId'],
								label: res2.data[i]['sName']
							});
							_arr.push(res2.data[i]['nUserId']);
						}
						_this9.filters2.nUserIds = _arr;
						_this9.leftRoleList2 = arr;
					});
				});
			}
		},
		change5: function change5() {
			var _this10 = this;

			if (!!this.filters5.nRoleId) {
				(0, _api.getTemplateByOppsiteRoleList)({
					pageSize: 9999,
					nRoleId: this.filters5.nRoleId,
					currentPage: 1
				}).then(function (res) {
					var arr = [];
					for (var i = 0; i < res.data.length; i++) {
						arr.push({
							key: res.data[i]['nTemplateId'],
							label: res.data[i]['sTemplateName']
						});
					}
					(0, _api.getTemplateByRoleList)({
						pageSize: 9999,
						nRoleId: _this10.filters5.nRoleId,
						currentPage: 1
					}).then(function (res2) {
						var _arr = [];
						for (var i = 0; i < res2.data.length; i++) {
							arr.push({
								key: res2.data[i]['nTemplateId'],
								label: res2.data[i]['sTemplateName']
							});
							_arr.push(res2.data[i]['nTemplateId']);
						}
						_this10.filters5.nTemplateIds = _arr;
						_this10.leftRoleList5 = arr;
					});
				});
			}
		},
		change3: function change3() {
			var _this11 = this;

			if (!!this.filters3.nRoleId) {
				(0, _api.getSelectByOppositeRoleList)({
					pageSize: 9999,
					nRoleId: this.filters3.nRoleId,
					currentPage: 1
				}).then(function (res) {
					var arr = [];
					for (var i = 0; i < res.data.length; i++) {
						arr.push({
							key: res.data[i]['nSelectId'],
							label: res.data[i]['sSchemaSelectName']
						});
					}
					(0, _api.getSelectByRoleList)({
						pageSize: 9999,
						nRoleId: _this11.filters3.nRoleId,
						currentPage: 1
					}).then(function (res2) {
						var _arr = [];
						for (var i = 0; i < res2.data.length; i++) {
							arr.push({
								key: res2.data[i]['nSelectId'],
								label: res2.data[i]['sSchemaSelectName']
							});
							_arr.push(res2.data[i]['nSelectId']);
						}
						_this11.filters3.nSelectIds = _arr;
						_this11.leftRoleList3 = arr;
					});
				});
			}
		},
		save2: function save2() {
			var _this12 = this;

			(0, _api.addUserRole)(this.filters2).then(function (res) {
				_this12.$message("Save Success");
			});
		},
		save3: function save3() {
			var _this13 = this;

			(0, _api.addDataBaseByRole)(this.filters3).then(function (res) {
				_this13.$message("Save Success");
			});
		},
		save5: function save5() {
			var _this14 = this;

			(0, _api.addRoleTemplate)(this.filters5).then(function (res) {
				_this14.$message("Save Success");
			});
		},
		filterMethod2: function filterMethod2(query, item) {
			return item.label.indexOf(query) > -1;
		},
		filterMethod3: function filterMethod3(query, item) {
			return item.label.indexOf(query) > -1;
		},
		filterMethod5: function filterMethod5(query, item) {
			return item.label.indexOf(query) > -1;
		},
		sState: function sState(data) {
			for (var i = 0; i < this.options.length; i++) {
				if (this.options[i]['id'] == data.sState) {
					return this.options[i]['name'];
				}
			}
		},
		valueStatus: function valueStatus(data) {
			var arr = [];
			if (data.valueStatus == 0) {
				arr.push('Value Unmanaged');
			} else if (data.valueStatus > 0) {
				arr.push('Value Managed');
			}
			return arr.join('\n\r');
		},
		fieldStatus: function fieldStatus(data) {
			var arr = [];
			if (data.fieldStatus == 0) {
				arr.push('Field  Unmanaged');
			} else if (data.fieldStatus > 0) {
				arr.push('Field  Managed');
			}
			return arr.join('\n\r');
		},
		toggleSelection: function toggleSelection(sState) {
			var arr = [];
			for (var i = 0; i < this.tableData3.length; i++) {
				arr.push(this.tableData3[i]['nRoleId']);
			}
			var _this = this;
			this.$confirm('Confirm to ' + (sState == 1 ? 'Active' : 'Inactive') + '?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.updateRoleInfo)({
					nRoleIds: arr,
					sState: sState
				}).then(function (res) {
					_this.reGetList();
				});
			}).catch(function () {});
		},
		save: function save() {
			var _this15 = this;

			if (!this.form.sRoleName) {
				this.$message.error('Please enter the role name');
				return;
			}
			if (!this.form.sRoleDescribe) {
				this.$message.error('Please enter the role describe');
				return;
			}
			if (this.form.roles.length == 0) {
				this.$message.error('Please select the Authority');
				return;
			}

			(0, _api.addRoleInfo)({
				sRoleDescribe: this.form.sRoleDescribe,
				sRoleName: this.form.sRoleName,
				sAuthority: this.form.roles.join(',')
			}).then(function (res) {
				_this15.$refs.form.resetFields();
				_this15.reGetList();
				_this15.$message('Add Success');
				_this15.addRoleFlag = false;
			});
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.tableData3 = val;
		},
		handleCurrentChange: function handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},
		reGetList: function reGetList() {
			this.filters.currentPage = 1;
			this.getList();
		},
		change4: function change4() {
			var _this16 = this;

			this.filters4.currentPage = 1;
			var param2 = (0, _assign2.default)({}, this.filters4);
			(0, _api.selectRoleVisitAuthorityBynRoleId)(param2).then(function (res) {
				_this16.tableData4 = res.data;
			});
		},
		getList: function getList() {
			var _this17 = this;

			var param = (0, _assign2.default)({}, this.filters);
			(0, _api.getRoleInfoList)(param).then(function (res) {
				_this17.tableData = res.data;
				_this17.total = res.page.totalCount * 1;
			});
		}
	}
};

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			activeName: 'first',
			addTemplateFlag: false,
			detailViewFlag: false,
			EditTemplateFlag: false,
			step: 1,
			filters: {
				pageSize: 10,
				currentPage: 1
			},
			options1: [],
			options2: [{
				id: 'int',
				name: 'int'
			}, {
				id: 'decimal',
				name: 'decimal'
			}, {
				id: 'nvarchar',
				name: 'nvarchar'
			}, {
				id: 'datetime',
				name: 'datetime'
			}],
			options3: [{
				id: '0',
				name: 'Null Able'
			}, {
				id: '1',
				name: 'Not Null'
			}],
			options4: [{
				id: '1',
				name: 'Using'
			}, {
				id: '2',
				name: '='
			}, {
				id: '3',
				name: 'In'
			}],
			options5: [],
			form: {
				sFileName: '',
				sTemplateName: '',
				sSchema: '',
				sTableName: ''
			},
			detailForm: {
				ziduanList: []
			},
			ziduanList: [],
			total: 0,
			tableData: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.getList();

		(0, _api.getDatabaseInfoList)({
			currentPage: 1,
			pageSize: 9999
		}).then(function (res) {
			_this.options1 = res.data;
		});
		(0, _api.getCurrencyCheckRulePage)({
			currentPage: 1,
			pageSize: 9999
		}).then(function (res) {
			_this.options5 = res.data;
		});
	},

	methods: {
		toConvit3: function toConvit3(val, arr) {
			if (val == 0) {
				return;
			}
			var one = arr.find(function (one) {
				return one.id == val;
			});
			if (one) {
				return one.name;
			}
		},
		toConvit1: function toConvit1(val, arr) {
			var one = arr.find(function (one) {
				return one.id == val;
			});
			if (one) {
				return one.name;
			}
		},
		toConvit2: function toConvit2(val, arr) {
			var one = arr.find(function (one) {
				return one.nId == val;
			});
			if (one) {
				return one.sRuleName;
			}
		},
		resetFrom: function resetFrom() {
			this.form = {
				sFileName: '',
				sTemplateName: '',
				sSchema: '',
				sTableName: ''
			};
			this.ziduanList = [];
			this.detailForm = {
				ziduanList: []
			};
		},
		changeSelect: function changeSelect(item) {
			if (item.sFieldType == 'decimal') {
				item.sLen = '10,2';
			} else if (item.sFieldType == 'nvarchar') {
				item.sLen = '500';
			} else {
				item.sLen = '';
			}
		},
		saveTemplate0: function saveTemplate0() {
			var _this2 = this;

			if (!this.form.sTemplateName) {
				this.$message.error('Please enter the template name');
				return;
			}
			if (!this.form.sSchema) {
				this.$message.error('Please select the schema');
				return;
			}
			if (!this.form.sTableName) {
				this.$message.error('Please enter the table name');
				return;
			}
			var arr = [];
			var flagPrimary = false;
			var flagFieldName = false;
			var sFieldType = false;
			var sameKeyFlag = false;
			var smaeKeyObj = {};
			var sLenFlag = false;
			var sLenTypeFlag = false;
			this.ziduanList.forEach(function (one) {
				if (one.nPrimaryKey == true) {
					flagPrimary = true;
				}
				if (one.sFieldName == '') {
					flagFieldName = true;
				}
				if (one.sFieldType == '') {
					sFieldType = true;
				}
				if (!smaeKeyObj[one.sFieldName]) {
					smaeKeyObj[one.sFieldName] = 1;
				} else {
					sameKeyFlag = true;
				}

				if (one.sFieldType == 'nvarchar') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (!/^\d*$/.test(one.sLen)) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.sFieldName,
						nOrder: one.nOrder,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else if (one.sFieldType == 'decimal') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (one.sLen.indexOf(',') == -1) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.sFieldName,
						nOrder: one.nOrder,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else {
					arr.push({
						sFieldName: one.sFieldName,
						nOrder: one.nOrder,
						sFieldType: one.sFieldType,
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				}
			});

			if (flagFieldName == true) {
				this.$message.error('Please input key name');
				return;
			}
			if (sFieldType == true) {
				this.$message.error('Please select field type');
				return;
			}
			if (sameKeyFlag == true) {
				this.$message.error('Field name duplicate');
				return;
			}
			if (sLenFlag == true) {
				this.$message.error('Please input Field length ');
				return;
			}
			if (sLenTypeFlag == true) {
				this.$message.error('Field type format error ');
				return;
			}
			(0, _api.saveTemplate)({
				sTemplateName: this.form.sTemplateName,
				sSchema: this.form.sSchema,
				sTableName: this.form.sTableName,
				templateFieldList: arr
			}).then(function (res) {
				_this2.$refs.form.resetFields();
				_this2.getList();
				_this2.$message('add Success');
				_this2.addTemplateFlag = false;
			});
		},
		updateTemplate: function updateTemplate() {
			var _this3 = this;

			if (!this.detailForm.sTemplateName) {
				this.$message.error('Please enter the template name');
				return;
			}
			if (!this.detailForm.sSchema) {
				this.$message.error('Please select the schema');
				return;
			}
			if (!this.detailForm.sTableName) {
				this.$message.error('Please enter the table name');
				return;
			}
			var arr = [];
			var flagPrimary = false;
			var flagFieldName = false;
			var sFieldType = false;
			var sameKeyFlag = false;
			var smaeKeyObj = {};
			var sLenFlag = false;
			var sLenTypeFlag = false;
			this.detailForm.ziduanList.forEach(function (one) {
				if (one.nPrimaryKey == true) {
					flagPrimary = true;
				}
				if (one.sFieldName == '') {
					flagFieldName = true;
				}
				if (one.sFieldType == '') {
					sFieldType = true;
				}
				if (!smaeKeyObj[one.sFieldName]) {
					smaeKeyObj[one.sFieldName] = 1;
				} else {
					sameKeyFlag = true;
				}

				if (one.sFieldType == 'nvarchar') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (!/^\d*$/.test(one.sLen)) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.isDelete == 1 ? '' : one.sFieldName,
						nOrder: one.nOrder,
						sOldFieldName: one.sOldFieldName,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else if (one.sFieldType == 'decimal') {
					if (one.sLen == '') {
						sLenFlag = true;
					}
					if (one.sLen.indexOf(',') == -1) {
						sLenTypeFlag = true;
					}
					arr.push({
						sFieldName: one.isDelete == 1 ? '' : one.sFieldName,
						nOrder: one.nOrder,
						sOldFieldName: one.sOldFieldName,
						sFieldType: one.sFieldType + '(' + one.sLen + ')',
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				} else {
					arr.push({
						sFieldName: one.isDelete == 1 ? '' : one.sFieldName,
						nOrder: one.nOrder,
						sOldFieldName: one.sOldFieldName,
						sFieldType: one.sFieldType,
						nPrimaryKey: one.nPrimaryKey == true ? '1' : '0',
						templateFieldCheckReq: {
							sFieldName: one.sFieldName,
							sIfcheckValue: one.sIfnull == 0 ? '0' : one.sIfcheckValue,
							sIfnull: one.sIfnull,
							sValueRange: one.sIfnull == 0 ? '' : one.sValueRange
						}
					});
				}
			});

			if (flagFieldName == true) {
				this.$message.error('Please input key name');
				return;
			}
			if (sFieldType == true) {
				this.$message.error('Please select field type');
				return;
			}
			if (sameKeyFlag == true) {
				this.$message.error('Field name duplicate');
				return;
			}
			if (sLenFlag == true) {
				this.$message.error('Please input Field length ');
				return;
			}
			if (sLenTypeFlag == true) {
				this.$message.error('Field type format error ');
				return;
			}
			(0, _api.modifyTemplate)({
				nTemplateId: this.detailForm.nTemplateId,
				sTemplateName: this.detailForm.sTemplateName,
				sSchema: this.detailForm.sSchema,
				sTableName: this.detailForm.sTableName,
				templateFieldList: arr
			}).then(function (res) {
				_this3.$refs.detailForm.resetFields();
				_this3.getList();
				_this3.EditTemplateFlag = false;
				_this3.$message('update Success');
				_this3.detailViewFlag = false;
			});
		},
		deleteOne: function deleteOne(index) {
			this.detailForm.ziduanList[index]['isDelete'] = 1;
		},
		addOne: function addOne() {
			if (this.detailForm.ziduanList.length == 0) {
				this.detailForm.ziduanList.push({
					sFieldName: '',
					sOldFieldName: '',
					sFieldType: '',
					sLen: '',
					sIfnull: '0',
					typeF: 0,
					sIfcheckValue: '',
					sValueRange: '',
					nOrder: 1,
					nPrimaryKey: false,
					isDelete: 0
				});
			} else {
				this.detailForm.ziduanList.push({
					sFieldName: '',
					sOldFieldName: '',
					sFieldType: '',
					sLen: '',
					sIfnull: '0',
					typeF: 0,
					sIfcheckValue: '',
					sValueRange: '',
					nOrder: this.detailForm.ziduanList[this.detailForm.ziduanList.length - 1]['nOrder'] * 1 + 1,
					nPrimaryKey: false,
					isDelete: 0
				});
			}
		},
		handleCurrentChange: function handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},
		changeFile: function changeFile(e) {
			var self = this;
			var files = document.getElementById('files').files;
			var reg = new RegExp('.*,".*,.*"$');
			if (files.length) {
				var file = files[0];
				self.form.sFileName = file.name;
				var arr = file.name.split('.');
				if ('csv'.indexOf(arr[arr.length - 1]) === -1) {
					self.$message({
						message: 'Please Select csv.',
						type: 'error',
						duration: 5 * 1000
					});
				}
				var reader = new FileReader();
				if (typeof FileReader == 'undefined') {
					self.$message({
						message: 'Your browser does not support FileReader interface',
						type: 'error',
						duration: 5 * 1000
					});
					return;
				}
				reader.readAsText(file);
				reader.onload = function (val) {
					var relArr = this.result.split('\r\n');
					if (relArr.length > 0) {
						var values = relArr[0];
						if (reg.test(values)) {
							self.$message({
								message: 'There are English commas in the content of the file. Please upload it after modification. The content with English commas is：' + values,
								type: 'error',
								duration: 5 * 1000
							});
							return;
						}
						var objArr = values.split(',');
						for (var i = 0, len = objArr.length; i < len; i++) {
							if (!!objArr[i]) {
								self.ziduanList.push({
									sFieldName: objArr[i],
									sFieldType: 'nvarchar',
									sLen: '500',
									sIfnull: '0',
									typeF: 0,
									sIfcheckValue: '',
									sValueRange: '',
									nOrder: i + 1,
									nPrimaryKey: false
								});
							}
						}
						self.ziduanList.push({
							sFieldName: 'LOAD_DT',
							sFieldType: 'nvarchar',
							sLen: '500',
							sIfnull: '0',
							typeF: 0,
							sIfcheckValue: '',
							sValueRange: '',
							nOrder: i + 1,
							nPrimaryKey: false
						});
						document.getElementById('files').value = '';
					} else {
						self.$message({
							message: 'Empty File',
							type: 'error',
							duration: 5 * 1000
						});
						return;
					}
				};
			}
		},
		toDetail: function toDetail(data) {
			var _this4 = this;

			(0, _api.selectTemplateFieldList)({
				nTemplateId: data.nTemplateId
			}).then(function (res) {
				var ziduanList = [];
				res.data.forEach(function (one) {
					if (!one.templateFieldCheck) {
						one.templateFieldCheck = {
							sIfnull: '0',
							typeF: 0,
							sIfcheckValue: '',
							sValueRange: ''
						};
					} else {
						one.templateFieldCheck.sIfcheckValue = one.templateFieldCheck.sIfcheckValue == 0 ? '' : one.templateFieldCheck.sIfcheckValue;
					}
					if (one.sFieldType.indexOf('nvarchar') > -1) {
						ziduanList.push({
							sFieldName: one.sFieldName,
							sOldFieldName: one.sFieldName,
							sFieldType: 'nvarchar',
							sLen: one.sFieldType.replace(/nvarchar\(/gi, '').replace(/\)/gi, ''),
							nOrder: one.nOrder,
							nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
							isDelete: 0,
							sIfnull: one.templateFieldCheck.sIfnull,
							typeF: one.templateFieldCheck.sIfcheckValue == '' ? 0 : 1,
							sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
							sValueRange: one.templateFieldCheck.sValueRange
						});
					} else if (one.sFieldType.indexOf('decimal') > -1) {
						ziduanList.push({
							sFieldName: one.sFieldName,
							sOldFieldName: one.sFieldName,
							sFieldType: 'decimal',
							sLen: one.sFieldType.replace(/decimal\(/gi, '').replace(/\)/gi, ''),
							nOrder: one.nOrder,
							nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
							isDelete: 0,
							sIfnull: one.templateFieldCheck.sIfnull,
							typeF: one.templateFieldCheck.sIfcheckValue == '' ? 0 : 1,
							sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
							sValueRange: one.templateFieldCheck.sValueRange
						});
					} else {
						ziduanList.push({
							sFieldName: one.sFieldName,
							sOldFieldName: one.sFieldName,
							sFieldType: one.sFieldType,
							sLen: '',
							nOrder: one.nOrder,
							nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
							isDelete: 0,
							sIfnull: one.templateFieldCheck.sIfnull,
							typeF: one.templateFieldCheck.sIfcheckValue == '' ? 0 : 1,
							sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
							sValueRange: one.templateFieldCheck.sValueRange
						});
					}
				});

				_this4.detailForm = {
					nTemplateId: data.nTemplateId,
					sTemplateName: data.sTemplateName,
					sSchema: data.sSchema,
					sTableName: data.sTableName,
					ziduanList: ziduanList
				};
				_this4.detailViewFlag = true;
			});
		},

		reGetList: function reGetList() {
			this.filters.currentPage = 1;
			this.getList();
		},
		getList: function getList() {
			var _this5 = this;

			var param = (0, _assign2.default)({}, this.filters);
			(0, _api.selectUploadTemplatePage)(param).then(function (res) {
				_this5.tableData = res.data;
				_this5.total = res.page.totalCount * 1;
			});
		}
	}
};

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			addUserFlag: false,
			activeName: 'first',
			form: {
				sName: '',
				sAccount: ''
			},
			options: [{
				id: '1',
				name: 'Active'
			}, {
				id: '0',
				name: 'Inactive'
			}],
			filters: {
				sName: '',
				sState: '1',
				pageSize: 10,
				currentPage: 1
			},
			total: 0,
			tableData3: [],
			tableData: []
		};
	},
	mounted: function mounted() {
		this.getList();
	},

	methods: {
		save: function save() {
			var _this2 = this;

			if (!this.form.sName) {
				this.$message.error('Please enter the user name');
				return;
			}
			if (!this.form.sAccount) {
				this.$message.error('Please enter the domain account ');
				return;
			}
			(0, _api.addUserInfo)(this.form).then(function (res) {
				_this2.$refs.form.resetFields();
				_this2.reGetList();
				_this2.$message('Add Success');
				_this2.addUserFlag = false;
			});
		},
		sState: function sState(data) {
			for (var i = 0; i < this.options.length; i++) {
				if (this.options[i]['id'] == data.sState) {
					return this.options[i]['name'];
				}
			}
		},
		toggleSelection: function toggleSelection(sState) {
			var arr = [];
			for (var i = 0; i < this.tableData3.length; i++) {
				arr.push(this.tableData3[i]['nUserId']);
			}
			var _this = this;
			this.$confirm('Confirm to ' + (sState == 1 ? 'Active' : 'Inactive') + '?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.updateUserInfo)({
					nUserIds: arr,
					sState: sState
				}).then(function (res) {
					_this.reGetList();
				});
			}).catch(function () {});
		},
		handleSelectionChange: function handleSelectionChange(val) {
			this.tableData3 = val;
		},
		handleCurrentChange: function handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},

		reGetList: function reGetList() {
			this.filters.currentPage = 1;
			this.getList();
		},
		getList: function getList() {
			var _this3 = this;

			var param = (0, _assign2.default)({}, this.filters);
			(0, _api.getUserInfoList)(param).then(function (res) {
				_this3.tableData = res.data;
				_this3.total = res.page.totalCount * 1;
			});
		}
	}
};

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			activeName: 'first',
			options: [{
				id: "1",
				name: "User Sign In"
			}, {
				id: "2",
				name: "User Upload"
			}],
			filters: {
				nType: "1",
				pageSize: 10,
				currentPage: 1
			},
			total: 0,
			tableData: []
		};
	},
	mounted: function mounted() {
		this.getList();
	},

	methods: {
		nType: function nType(data) {
			for (var i = 0; i < this.options.length; i++) {
				if (this.options[i]['id'] == data.nType) {
					return this.options[i]['name'];
				}
			}
		},
		handleCurrentChange: function handleCurrentChange(page) {
			this.filters.currentPage = page;
			this.getList();
		},

		reGetList: function reGetList() {
			this.filters.currentPage = 1;
			this.getList();
		},
		getList: function getList() {
			var _this = this;

			var param = (0, _assign2.default)({}, this.filters);
			(0, _api.getBehaviorListt)(param).then(function (res) {
				_this.tableData = res.data;
				_this.total = res.page.totalCount * 1;
			});
		}
	}
};

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(12);

exports.default = {
  data: function data() {
    return {
      logining: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var url = new URL(window.location.href);

    var params = new URLSearchParams(url.search);
    console.log(params, 'params');

    var code = params.get('code');
    console.log(code, 'code');
    (0, _api.loginSSO)({
      codeVerifier: sessionStorage.getItem('codeVerifier'),
      codeChallenge: sessionStorage.getItem('codeChallenge'),
      code: code
    }).then(function (res) {
      sessionStorage.setItem('userId', res.data.nUserId);
      sessionStorage.setItem('token', res.data.token);
      sessionStorage.setItem('sName', res.data.sName);
      sessionStorage.setItem('dLastLogin', res.data.dLastLogin);
      sessionStorage.setItem('sRole', res.data.sAuthority);
      sessionStorage.setItem('sRoleName', res.data.sRole);
      if (res.data.sAuthority == "") {
        _this.$router.replace('/no');
      } else if (res.data.sAuthority.indexOf('Data') > -1) {
        var id = sessionStorage.getItem('id');
        if (id == null) {
          _this.$router.replace({ path: '/select' });
        } else {
          _this.$router.replace({ path: '/select?id=' + id });
          sessionStorage.removeItem('id');
        }
      } else if (res.data.sAuthority.indexOf('Admin') > -1) {
        _this.$router.replace('/user');
      } else if (res.data.sAuthority.indexOf('Upload') > -1) {
        _this.$router.replace('/template');
      }
    });
  },

  methods: {}
};

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeName: "first",
      filters: {
        pageSize: 10,
        currentPage: 1
      },
      total: 0,
      dialogFlag: false,
      tableListData: [],
      tableData: [],
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px"
      },
      cellStyle: {
        height: "55px"
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },


  methods: {
    toDetail: function toDetail(data) {
      var _this = this;

      (0, _api.getUploadResultDetail)({
        nUploadId: data.nId
      }).then(function (res) {
        _this.dialogFlag = true;
        _this.tableListData = res.data;
      });
    },
    formatterStatus: function formatterStatus(row) {
      if (row.sStatus == 0) {
        return "Uploading";
      } else if (row.sStatus == 1) {
        return "Success";
      } else if (row.sStatus == 2) {
        return "Fail";
      } else if (row.sStatus == 3) {
        return "Value mismatch";
      } else if (row.sStatus == 4) {
        return "Primary key duplication";
      } else {
        return row.sStatus;
      }
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.filters.currentPage = page;
      this.getList();
    },

    reGetList: function reGetList() {
      this.filters.currentPage = 1;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      var param = (0, _assign2.default)({}, this.filters);
      (0, _api.selectTemplateLogPage)(param).then(function (res) {
        _this2.tableData = res.data;
        _this2.total = res.page.totalCount * 1;
      });
    }
  }
};

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeName: "first",
      addTemplateFlag: false,
      detailViewFlag: false,
      filters: {
        pageSize: 10,
        currentPage: 1
      },
      form: {},
      detail: {
        sRadio: "",
        sFileFormat: "",
        nTemplateId: "",
        sDelimiters: "",
        sFileName: "",
        sOperationName: ""
      },
      total: 0,
      options1: [{
        id: "csv",
        name: "csv"
      }, {
        id: "xlsx",
        name: "xlsx"
      }],
      options2: [{
        id: ",",
        name: "Comma"
      }, {
        id: ";",
        name: "Semicolon"
      }, {
        id: 5,
        name: "Other"
      }],
      options3: [{
        id: "0",
        name: "Null Able"
      }, {
        id: "1",
        name: "Not Null"
      }],
      options4: [{
        id: "1",
        name: "Using"
      }, {
        id: "2",
        name: "="
      }, {
        id: "3",
        name: "In"
      }],
      options5: [],
      tableData: [],
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px"
      },
      cellStyle: {
        height: "55px"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getList();

    (0, _api.getCurrencyCheckRulePage)({
      currentPage: 1,
      pageSize: 9999
    }).then(function (res) {
      _this.options5 = res.data;
    });
  },

  methods: {
    toConvit3: function toConvit3(val, arr) {
      if (val == 0) {
        return;
      }
      var one = arr.find(function (one) {
        return one.id == val;
      });
      if (one) {
        return one.name;
      }
    },
    toConvit1: function toConvit1(val, arr) {
      var one = arr.find(function (one) {
        return one.id == val;
      });
      if (one) {
        return one.name;
      }
    },
    toConvit2: function toConvit2(val, arr) {
      var one = arr.find(function (one) {
        return one.nId == val;
      });
      if (one) {
        return one.sRuleName;
      }
    },
    saveTemplate: function saveTemplate() {
      var _this2 = this;

      if (this.detail.sFileFormat == "csv") {
        if (!this.detail.sRadio) {
          this.$message.error("Please select the delimiters");
          return;
        }
      }


      var fdata = new FormData();

      fdata.append("file", document.getElementById("files").files[0]);
      fdata.append("nTemplateId", this.detail.nTemplateId);
      fdata.append("sFileFormat", this.detail.sFileFormat);
      fdata.append("sDelimiters", this.detail.sFileFormat !== "csv" ? "," : this.detail.sRadio == 5 ? this.detail.sDelimiters : this.detail.sRadio);
      fdata.append("sOperationName", sessionStorage.getItem("userId") + "_" + new Date().Format("yyyyMMddhhmmss"));


      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      (0, _api.importTemplate)(fdata).then(function (res) {
        _this2.getList();
        _this2.$message("import Success");
        _this2.addTemplateFlag = false;
        loading.close();
      }).catch(function () {
        loading.close();
      });
    },
    createCSVStr: function createCSVStr(outFieldsNames) {
      var textField = '"';
      var content = "";
      var len = 0,
          n = 0,
          comma = "",
          value = "";
      try {
        outFieldsNames.forEach(function (_field) {
          content = content + comma + _field;
          comma = ",";
        });
        content = content + "\r\n";
        len = outFieldsNames.length;
        n = outFieldsNames.length;
        for (var i = 0; i < len; i++) {
          comma = "";
          for (var m = 0; m < n; m++) {
            var _field = outFieldsNames[m];
            value = outFieldsNames[i][_field];
            if (!value && typeof value !== "number") {
              value = "";
            }

            if (value && /[",\r\n]/g.test(value)) {
              value = textField + value.replace(/(")/g, '""') + textField;
            }
            try {
              value = value.replace(/\r\n/g, "").value.replace(/\n/g, "");
            } catch (e) {}
            content = content + comma + value;
            comma = ",";
          }
          content = content + "\r\n";
        }
      } catch (err) {
        content = "";
      }
      return content;
    },
    doDownLoad: function doDownLoad() {
      var _this3 = this;

      (0, _api.selectTemplateFieldList)({
        nTemplateId: this.form.nTemplateId
      }).then(function (res) {
        var ziduanList = [];
        res.data.forEach(function (one) {
          if (one.sFieldName !== "LOAD_DT") {
            ziduanList.push(one.sFieldName);
          }
        });
        var blob = new Blob(["\uFEFF" + _this3.createCSVStr(ziduanList)], {
          type: "text/csv"
        });
        var alink = document.createElement("a");
        alink.setAttribute("href", URL.createObjectURL(blob));
        alink.target = "_blank";
        alink.download = _this3.form.sTemplateName + "_" + new Date().getTime() + ".csv";
        alink.click();
      });
    },
    toDetail: function toDetail(data) {
      var _this4 = this;

      (0, _api.selectTemplateFieldList)({
        nTemplateId: data.nTemplateId
      }).then(function (res) {
        var ziduanList = [];
        res.data.forEach(function (one) {
          if (!one.templateFieldCheck) {
            one.templateFieldCheck = {
              sIfnull: "0",
              typeF: 0,
              sIfcheckValue: "",
              sValueRange: ""
            };
          } else {
            one.templateFieldCheck.sIfcheckValue = one.templateFieldCheck.sIfcheckValue == 0 ? "" : one.templateFieldCheck.sIfcheckValue;
          }
          if (one.sFieldType.indexOf("varchar") > -1) {
            ziduanList.push({
              sFieldName: one.sFieldName,
              sOldFieldName: one.sFieldName,
              sFieldType: "varchar",
              sLen: one.sFieldType.replace(/varchar\(/gi, "").replace(/\)/gi, ""),
              nOrder: one.nOrder,
              nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
              isDelete: 0,
              sIfnull: one.templateFieldCheck.sIfnull,
              typeF: one.templateFieldCheck.sIfcheckValue == "" ? 0 : 1,
              sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
              sValueRange: one.templateFieldCheck.sValueRange
            });
          } else if (one.sFieldType.indexOf("decimal") > -1) {
            ziduanList.push({
              sFieldName: one.sFieldName,
              sOldFieldName: one.sFieldName,
              sFieldType: "decimal",
              sLen: one.sFieldType.replace(/decimal\(/gi, "").replace(/\)/gi, ""),
              nOrder: one.nOrder,
              nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
              isDelete: 0,
              sIfnull: one.templateFieldCheck.sIfnull,
              typeF: one.templateFieldCheck.sIfcheckValue == "" ? 0 : 1,
              sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
              sValueRange: one.templateFieldCheck.sValueRange
            });
          } else {
            ziduanList.push({
              sFieldName: one.sFieldName,
              sOldFieldName: one.sFieldName,
              sFieldType: one.sFieldType,
              sLen: "",
              nOrder: one.nOrder,
              nPrimaryKey: one.nPrimaryKey == 1 ? true : false,
              isDelete: 0,
              sIfnull: one.templateFieldCheck.sIfnull,
              typeF: one.templateFieldCheck.sIfcheckValue == "" ? 0 : 1,
              sIfcheckValue: one.templateFieldCheck.sIfcheckValue,
              sValueRange: one.templateFieldCheck.sValueRange
            });
          }
        });

        _this4.form = {
          nTemplateId: data.nTemplateId,
          sTemplateName: data.sTemplateName,
          sSchema: data.sSchema,
          sTableName: data.sTableName,
          ziduanList: ziduanList
        };
        _this4.detailViewFlag = true;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.filters.currentPage = page;
      this.getList();
    },

    reGetList: function reGetList() {
      this.filters.currentPage = 1;
      this.getList();
    },
    getList: function getList() {
      var _this5 = this;

      var param = (0, _assign2.default)({}, this.filters);
      (0, _api.getUploadTemplateByRoleListPage)(param).then(function (res) {
        _this5.tableData = res.data;
        _this5.total = res.page.totalCount * 1;
      });
    },
    changeFile: function changeFile(e) {
      var self = this;
      var files = document.getElementById("files").files;
      if (files.length) {
        var file = files[0];
        self.detail.sFileName = file.name;
        var arr = file.name.split(".");
        if ("csv;xls;xlsx;".indexOf(arr[arr.length - 1]) === -1) {
          self.$message({
            message: "Please Select right file",
            type: "error",
            duration: 5 * 1000
          });
        } else {
          if ("csv".indexOf(arr[arr.length - 1]) > -1) {
            this.detail.sType = 1;
          } else if ("xls".indexOf(arr[arr.length - 1]) > -1) {
            this.detail.sType = 2;
          } else {
            this.detail.sType = 3;
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(12);

exports.default = {
  data: function data() {
    return {
      activeName: 'first',
      addTemplateFlag: false,
      detailViewFlag: false,
      filters: {
        pageSize: 10,
        currentPage: 1
      },
      form: {},
      detail: {
        sRadio: '',
        sFileFormat: '',
        nTemplateId: '',
        sDelimiters: '',
        sFileName: '',
        sOperationName: ''
      },
      total: 0,
      sVersion: '',
      sName: '',
      nTemplateId: '',
      options1: [],
      options2: [{
        id: '1-Distributor Sell in含EC 100%分解到客户指标',
        name: '1-Distributor Sell in含EC 100%分解到客户指标'
      }, {
        id: '2-Distributor Sell out含EC 100%分解到客户指标',
        name: '2-Distributor Sell out含EC 100%分解到客户指标'
      }, {
        id: '3-T2购进指标',
        name: '3-T2购进指标'
      }, {
        id: '4-T3 Nonchain购进指标',
        name: '4-T3 Nonchain购进指标'
      }, {
        id: '5-T2/T3 Nonchain售出到BMM渠道指标',
        name: '5-T2/T3 Nonchain售出到BMM渠道指标'
      }, {
        id: '6-T2/T3 Nonchain售出到BRM渠道指标',
        name: '6-T2/T3 Nonchain售出到BRM渠道指标'
      }, {
        id: '7-DM BMM UL指标',
        name: '7-DM BMM UL指标'
      }, {
        id: '8-医院和互联网医院购进指标',
        name: '8-医院和互联网医院购进指标'
      }, {
        id: '9-地区主任/专员 BRM 批发 UL指标',
        name: '9-地区主任/专员 BRM 批发 UL指标'
      }, {
        id: '10-地区主任/专员 BRM 非批发UL指标',
        name: '10-地区主任/专员 BRM 非批发UL指标'
      }, {
        id: '11-Dealer Sell in 100%分解到客户指标',
        name: '11-Dealer Sell in 100%分解到客户指标'
      }, {
        id: '12-Dealer Sell out 100%分解到客户指标',
        name: '12-Dealer Sell out 100%分解到客户指标'
      }, {
        id: '13-保健品 Sell in 100%分解到客户指标',
        name: '13-保健品 Sell in 100%分解到客户指标'
      }, {
        id: '14-保健品 Sell out 100%分解到客户指标',
        name: '14-保健品 Sell out 100%分解到客户指标'
      }, {
        id: '15-Oral Pharmacy Sell in',
        name: '15-Oral Pharmacy Sell in'
      }, {
        id: '16-Oral Pharmacy Sell out',
        name: '16-Oral Pharmacy Sell out'
      }, {
        id: '17-T3 Chain二级分部购进指标',
        name: '17-T3 Chain二级分部购进指标'
      }, {
        id: '18-T3 Chain门店Endcon指标',
        name: '18-T3 Chain门店Endcon指标'
      }, {
        id: '19-T客户购进指标',
        name: '19-T客户购进指标'
      }, {
        id: '20-直接单体门店购进指标',
        name: '20-直接单体门店购进指标'
      }, {
        id: '21-SR岗位Endcon指标',
        name: '21-SR岗位Endcon指标'
      }, {
        id: '22-O2O GTV指标',
        name: '22-O2O GTV指标'
      }],
      options3: [{
        id: '0',
        name: 'Null Able'
      }, {
        id: '1',
        name: 'Not Null'
      }],
      options4: [{
        id: '1',
        name: 'Using'
      }, {
        id: '2',
        name: '='
      }, {
        id: '3',
        name: 'In'
      }],
      options5: [],
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getSelectList();
  },

  methods: {
    getSelectList: function getSelectList() {
      var _this = this;

      this.options1 = [];
      this.options2 = [];
      this.options3 = [];
      (0, _api.getLock)({ "a": "a" }).then(function (res) {
        _this.options1 = res.data['lockList'];
        _this.options2 = res.data['targetList'];
        _this.options3 = res.data['templateList'];
      });
    },
    saveTemplate: function saveTemplate() {
      var _this2 = this;

      var fdata = new FormData();

      fdata.append('file', document.getElementById('files').files[0]);
      fdata.append('sVersion', this.sVersion);
      fdata.append('sName', this.sName);
      fdata.append('nTemplateId', this.nTemplateId);

      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      (0, _api.importWellness)(fdata).then(function (res) {
        _this2.$message('import Success');
        _this2.addTemplateFlag = false;
        loading.close();
      }).catch(function () {
        loading.close();
      });
    },
    doDownLoad: function doDownLoad() {
      var alink = document.createElement('a');
      alink.setAttribute('href', "./down.xlsx");
      alink.target = '_blank';

      alink.click();
    },
    changeFile: function changeFile(e) {
      var self = this;
      var files = document.getElementById('files').files;
      if (files.length) {
        var file = files[0];
        self.detail.sFileName = file.name;
        var arr = file.name.split('.');
        if ('xls;xlsx;'.indexOf(arr[arr.length - 1]) === -1) {
          self.$message({
            message: 'Please Select right file',
            type: 'error',
            duration: 5 * 1000
          });
        }
      }
    }
  }
};

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeName: "first",
      filter1: {
        nType: 1,
        pageSize: 10,
        currentPage: 1
      },
      filter2: {
        nType: 2,
        pageSize: 10,
        currentPage: 1
      },
      filter3: {
        nType: 3,
        pageSize: 10,
        currentPage: 1
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      total1: 0,
      total2: 0,
      total3: 0,
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px"
      },
      cellStyle: {
        height: "55px"
      }
    };
  },
  mounted: function mounted() {
    this.getList1();
    this.getList2();
    this.getList3();
  },

  methods: {
    refresh: function refresh(data) {
      var _this = this;
      this.$confirm("Confirm to rebuild?", "Tips", {
        type: "warning",
        customClass: 'customConfimClass'
      }).then(function () {
        (0, _api.reloadDownloadExport)({
          nId: data.nId,
          sStatus: 0
        }).then(function (res) {
          _this.getList1();
          _this.getList2();
          _this.getList3();
        });
      }).catch(function () {});
    },
    download: function download(data) {
      window.open("download/" + data.nUserId + "/" + data.sFileName, "_blank");
    },
    sStatus: function sStatus(data) {
      if (data.sStatus == 0) {
        return "loading";
      } else if (data.sStatus == 1) {
        return "complete";
      } else if (data.sStatus == 2) {
        return "fail";
      } else if (data.sStatus == 3) {
        return "Too much data.Unable to export!";
      }
    },
    handleCurrentChange3: function handleCurrentChange3(val) {
      this.filter3.currentPage = val;
      this.getList3();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.filter2.currentPage = val;
      this.getList2();
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.filter1.currentPage = val;
      this.getList1();
    },
    favorite: function favorite(data, type) {
      var _this2 = this;

      (0, _api.addSelectView)({
        sSelectName: data.sSelectName,
        sSelectFieldName: data.sSelectFieldName,
        sSelectFilter: data.sSelectFilter,
        sContent: data.sContent,
        sViewName: data.sFileName.replace(".csv", ""),
        nViewType: data.nType
      }).then(function (res) {
        (0, _api.updateFavorite)({
          sFavorite: 1,
          sFileName: data.sFileName
        }).then(function (res) {
          if (type == 1) {
            _this2.getList1();
          } else if (type == 2) {
            _this2.getList2();
          } else {
            _this2.getList3();
          }
        });
      });
    },

    getList1: function getList1() {
      var _this3 = this;

      var param = (0, _assign2.default)({}, this.filter1);
      (0, _api.getDownloadExportList)(param).then(function (res) {
        _this3.tableData1 = res.data;
        _this3.total1 = res.page.totalCount * 1;
      });
    },
    getList2: function getList2() {
      var _this4 = this;

      var param = (0, _assign2.default)({}, this.filter2);
      (0, _api.getDownloadExportList)(param).then(function (res) {
        _this4.tableData2 = res.data;
        _this4.total2 = res.page.totalCount * 1;
      });
    },
    getList3: function getList3() {
      var _this5 = this;

      var param = (0, _assign2.default)({}, this.filter3);
      (0, _api.getDownloadExportList)(param).then(function (res) {
        _this5.tableData3 = res.data;
        _this5.total3 = res.page.totalCount * 1;
      });
    }
  }
};

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(84);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(12);

var _util = __webpack_require__(83);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			allCheck: true,
			dialogVisible1: false,
			dialogVisible11: false,
			dialogVisible2: false,
			dialogVisible3: false,
			dialogVisible31: false,
			dialogVisible4: false,
			dialogVisible5: false,
			dialogVisible51: false,
			dialogVisible6: false,
			activeName: 'first',
			filter1: {
				nViewType: 1,
				pageSize: 10,
				currentPage: 1
			},
			filter2: {
				nViewType: 2,
				pageSize: 10,
				currentPage: 1
			},
			filter3: {
				nViewType: 3,
				pageSize: 10,
				currentPage: 1
			},
			tableData1: [],
			tableData2: [],
			tableData3: [],
			total1: 0,
			total2: 0,
			total3: 0,
			view1: {
				sContent: {
					sName: '',
					sSchema: '',
					sSchemaName: '',
					sSelectName: '',
					nSelectId: '',
					sSelectFilter: [],
					sSelectFieldName: []
				}
			},
			view2: {
				sContent: {
					sSchema: '',
					table: [{
						sName: '',
						sSchemaName: '',
						sSelectName: '',
						nSelectId: '',
						options: []
					}],
					keys: [],
					sSelectFilter: [],
					sSelectFieldName: []
				}
			},
			view3: {
				sContent: {
					sName: '',
					sSchemaName: '',
					sSelectName: '',
					nSelectId: '',
					sSelectFilter: [],
					sSelectFieldName: []
				}
			},
			tableData: [],
			showListFlag: false,
			count: 0,
			timer: 0,
			sql: {
				table: '',
				ziduan: '',
				tiaojian: ''
			},
			displayArr: [],
			isIndeterminate: false,
			options3: [],
			options4: [{
				id: 'in',
				name: '='
			}, {
				id: '>',
				name: '>'
			}, {
				id: '>=',
				name: '>='
			}, {
				id: '<',
				name: '<'
			}, {
				id: '<=',
				name: '<='
			}, {
				id: 'not in',
				name: '!='
			}],
			loading: false,
			checkAll: false
		};
	},
	mounted: function mounted() {
		this.getList1();
		this.getList2();
		this.getList3();
	},

	methods: {
		timeFormatter: function timeFormatter(row, column) {
			var shuju = row[column.property];
			try {
				if (shuju.indexOf('T') > -1) {
					var times = new Date(shuju);
					if (times == "Invalid Date") {
						return shuju;
					}
					return _util2.default.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
				} else {
					return shuju;
				}
			} catch (e) {
				return shuju;
			}
		},
		save5: function save5() {
			var _this2 = this;

			this.sql.table = this.view3.sContent.sSchemaName + '.' + this.view3.sContent.sSelectName;
			var arr = [];
			for (var i = 0; i < this.view3.sContent.sSelectFilter.length; i++) {
				if (this.view3.sContent.sSelectFilter[i]['sRequired'] == 0) {
					if (this.view3.sContent.sSelectFilter[i]['value'].length == 0) {
						this.view3.sContent.sSelectFilter[i]['value'] = this.view3.sContent.sSelectFilter[i]['options'];
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['options'].join(',') + "'");
					} else {
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
					}
				} else {
					arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
				}
			}
			this.sql.tiaojian = arr.join(',');

			(0, _api.updateSelectView)({
				nViewId: this.view3.nViewId,
				sFileName: this.view3.sViewName + '.csv',
				sSelectName: this.sql.table,
				sSelectFieldName: this.sql.ziduan,
				sSelectFilter: this.sql.tiaojian,
				sContent: (0, _stringify2.default)(this.view3.sContent),
				nViewType: 3
			}).then(function (res) {
				_this2.$message('Update Success');
				_this2.dialogVisible51 = false;
				_this2.getList3();
			});
		},
		save51: function save51() {
			var _this3 = this;

			this.sql.table = this.view3.sContent.sSchemaName + '.' + this.view3.sContent.sSelectName;
			var arr = [];
			for (var i = 0; i < this.view3.sContent.sSelectFilter.length; i++) {
				if (this.view3.sContent.sSelectFilter[i]['sRequired'] == 0) {
					if (this.view3.sContent.sSelectFilter[i]['value'].length == 0) {
						this.view3.sContent.sSelectFilter[i]['value'] = this.view3.sContent.sSelectFilter[i]['options'];
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['options'].join(',') + "'");
					} else {
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
					}
				} else {
					arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
				}
			}
			this.sql.tiaojian = arr.join(',');

			this.$prompt('Enter file name', 'Tips', {
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				inputPattern: /\S/,
				inputErrorMessage: 'Enter file name'
			}).then(function (_ref) {
				var value = _ref.value;

				(0, _api.addSelectView)({
					sSelectName: _this3.sql.table,
					sSelectFieldName: _this3.sql.ziduan,
					sSelectFilter: _this3.sql.tiaojian,
					sContent: (0, _stringify2.default)(_this3.view3.sContent),
					sViewName: value,
					nViewType: 3
				}).then(function (res) {
					_this3.$message('Add Success');
					_this3.dialogVisible5 = false;
					_this3.dialogVisible51 = false;
					_this3.getList3();
				});
			}).catch(function () {});
		},
		delete3: function delete3() {
			var _this4 = this;

			var _this = this;
			this.$confirm('Confirm to Delete View?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.deleteSelectView)({
					nViewId: _this4.view3.nViewId
				}).then(function (res) {
					(0, _api.updateFavorite)({
						sFavorite: 0,
						sFileName: _this4.view3.sViewName + '.csv'
					}).then(function (res) {
						_this4.$message('Delete success');
						_this4.dialogVisible5 = false;
						_this4.getList2();
					});
				});
			}).catch(function () {});
		},
		doEdit3: function doEdit3() {
			this.dialogVisible51 = true;
		},
		doQuery3: function doQuery3() {
			var _this5 = this;

			this.sql.table = this.view3.sContent.sSchemaName + '.' + this.view3.sContent.sSelectName;
			var arr = [];
			for (var i = 0; i < this.view3.sContent.sSelectFilter.length; i++) {
				if (this.view3.sContent.sSelectFilter[i]['sRequired'] == 0) {
					if (this.view3.sContent.sSelectFilter[i]['value'].length == 0) {
						this.view3.sContent.sSelectFilter[i]['value'] = this.view3.sContent.sSelectFilter[i]['options'];
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['options'].join(',') + "'");
					} else {
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
					}
				} else {
					arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
				}
			}
			this.sql.tiaojian = arr.join(',');
			var loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			(0, _api.selectDynamic)({
				sSelectName: this.sql.table,
				sSelectFilter: this.sql.tiaojian,
				sSchemaName: this.view3.sContent.sSchemaName,
				currentPage: 1,
				pageSize: 100
			}).then(function (res) {
				loading.close();
				_this5.count = res.data.length * 1;
				if (res.data.length > 100) {
					_this5.tableData = res.data.slice(0, 100);
				} else {
					_this5.tableData = res.data;
				};

				_this5.dialogVisible6 = true;
			}).catch(function (res) {
				loading.close();
			});
		},
		zhuanhuanItem: function zhuanhuanItem(item) {
			for (var i = 0; i < this.options3.length; i++) {
				if (this.options3[i]['sColumnCode'] == item) {
					return this.options3[i]['sColumnName'];
				}
			}
			return '';
		},
		zhuanhuanItem2: function zhuanhuanItem2(options3, item) {
			for (var i = 0; i < options3.length; i++) {
				if (options3[i]['sColumnCode'] == item) {
					return options3[i]['sColumnName'];
				}
			}
			return '';
		},
		delete1: function delete1() {
			var _this6 = this;

			var _this = this;
			this.$confirm('Confirm to Delete View?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.deleteSelectView)({
					nViewId: _this6.view1.nViewId
				}).then(function (res) {
					(0, _api.updateFavorite)({
						sFavorite: 0,
						sFileName: _this6.view1.sViewName + '.csv'
					}).then(function (res) {
						_this6.$message('Delete success');
						_this6.dialogVisible1 = false;
						_this6.getList1();
					});
				});
			}).catch(function () {});
		},
		delete2: function delete2() {
			var _this7 = this;

			var _this = this;
			this.$confirm('Confirm to Delete View?', 'Tips', {
				type: 'warning',
				customClass: 'customConfimClass'
			}).then(function () {
				(0, _api.deleteSelectView)({
					nViewId: _this7.view2.nViewId
				}).then(function (res) {
					(0, _api.updateFavorite)({
						sFavorite: 0,
						sFileName: _this7.view2.sViewName + '.csv'
					}).then(function (res) {
						_this7.$message('Delete success');
						_this7.dialogVisible3 = false;
						_this7.getList2();
					});
				});
			}).catch(function () {});
		},
		save3: function save3() {
			var _this8 = this;

			var arr = [];
			var displayArr = [];
			for (var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
				for (var j = 0; j < this.view2.sContent.sSelectFieldName[i]['value'].length; j++) {
					arr.push(this.view2.sContent.sSelectFieldName[i]['sBie'] + '.' + this.view2.sContent.sSelectFieldName[i]['value'][j] + ' as ' + this.view2.sContent.sSelectFieldName[i]['sBie'] + '_' + this.view2.sContent.sSelectFieldName[i]['value'][j]);
					displayArr.push(this.view2.sContent.sSelectFieldName[i]['value'][j]);
				}
			}
			this.sql.ziduan = arr.join(',');
			var arr3 = [];
			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};
			for (var i = 0; i < this.view2.sContent.sSelectFilter.length; i++) {
				if (this.view2.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view2.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
					arr3.push(this.view2.sContent.sSelectFilter[i]['sBie'] + '.' + this.view2.sContent.sSelectFilter[i]['sColumnCode'] + ' ' + this.view2.sContent.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.view2.sContent.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.view2.sContent.sSelectFilter[i]['value'].length; j++) {
						arr3.push(this.view2.sContent.sSelectFilter[i]['sBie'] + '.' + this.view2.sContent.sSelectFilter[i]['sColumnCode'] + this.view2.sContent.sSelectFilter[i]['fuhao'] + "N'" + this.view2.sContent.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}

			var sqlDongGArr = [];
			this.view2.sContent.table.forEach(function (one) {
				sqlDongGArr.push((0, _api.selectExColumnValueBynSelectId)({
					nSelectId: one.nSelectId
				}));
			});
			_promise2.default.all(sqlDongGArr).then(function (res) {
				var duoyuanarr = [];
				res.forEach(function (one, index) {
					one.data.forEach(function (two) {
						duoyuanarr.push(_this8.view2.sContent.table[index]['sBie'] + '.' + two.sColumnCode + ' in(N' + two.sColumnValue + ')');
					});
				});

				arr3 = arr3.concat(duoyuanarr);
				_this8.sql.tiaojian = arr3.join(' and ');

				var arr = [];
				arr.push(_this8.view2.sContent.keys[0]['sSchema1Name'] + '.' + _this8.view2.sContent.keys[0]['sSelect1Name'] + ' ' + _this8.view2.sContent.keys[0]['sBie1']);

				for (var i = 0; i < _this8.view2.sContent.keys.length; i++) {
					var _arr = [];
					for (var j = 0; j < _this8.view2.sContent.keys[i]['selectKey'].length; j++) {
						_arr.push(_this8.view2.sContent.keys[i]['sBie1'] + '.' + _this8.stringArr(_this8.view2.sContent.keys[i]['selectKey'][j], 0) + '=' + _this8.view2.sContent.keys[i]['sBie2'] + '.' + _this8.stringArr(_this8.view2.sContent.keys[i]['selectKey'][j], 1));
					}

					arr.push(_this8.view2.sContent.keys[i]['sSchema2Name'] + '.' + _this8.view2.sContent.keys[i]['sSelect2Name'] + ' ' + _this8.view2.sContent.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
				}
				_this8.sql.table = arr.join(' left join  ');

				(0, _api.updateSelectView)({
					nViewId: _this8.view2.nViewId,
					sFileName: _this8.view2.sViewName + '.csv',
					sSelectName: _this8.sql.table,
					sSelectFieldName: _this8.sql.ziduan,
					sSelectFilter: _this8.sql.tiaojian,
					sContent: (0, _stringify2.default)(_this8.view2.sContent),
					nViewType: 2
				}).then(function (res) {
					_this8.$message('Update Success');
					_this8.dialogVisible3 = false;
					_this8.dialogVisible31 = false;
					_this8.getList2();
				});
			});
		},
		save31: function save31() {
			var _this9 = this;

			var arr = [];
			var displayArr = [];
			for (var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
				for (var j = 0; j < this.view2.sContent.sSelectFieldName[i]['value'].length; j++) {
					arr.push(this.view2.sContent.sSelectFieldName[i]['sBie'] + '.' + this.view2.sContent.sSelectFieldName[i]['value'][j] + ' as ' + this.view2.sContent.sSelectFieldName[i]['sBie'] + '_' + this.view2.sContent.sSelectFieldName[i]['value'][j]);
					displayArr.push(this.view2.sContent.sSelectFieldName[i]['value'][j]);
				}
			}
			this.sql.ziduan = arr.join(',');
			var arr3 = [];
			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};
			for (var i = 0; i < this.view2.sContent.sSelectFilter.length; i++) {
				if (this.view2.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view2.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
					arr3.push(this.view2.sContent.sSelectFilter[i]['sBie'] + '.' + this.view2.sContent.sSelectFilter[i]['sColumnCode'] + ' ' + this.view2.sContent.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.view2.sContent.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.view2.sContent.sSelectFilter[i]['value'].length; j++) {
						arr3.push(this.view2.sContent.sSelectFilter[i]['sBie'] + '.' + this.view2.sContent.sSelectFilter[i]['sColumnCode'] + this.view2.sContent.sSelectFilter[i]['fuhao'] + "N'" + this.view2.sContent.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}


			var sqlDongGArr = [];
			this.view2.sContent.table.forEach(function (one) {
				sqlDongGArr.push((0, _api.selectExColumnValueBynSelectId)({
					nSelectId: one.nSelectId
				}));
			});
			_promise2.default.all(sqlDongGArr).then(function (res) {
				var duoyuanarr = [];
				res.forEach(function (one, index) {
					one.data.forEach(function (two) {
						duoyuanarr.push(_this9.view2.sContent.table[index]['sBie'] + '.' + two.sColumnCode + ' in(N' + two.sColumnValue + ')');
					});
				});

				arr3 = arr3.concat(duoyuanarr);
				_this9.sql.tiaojian = arr3.join(' and ');

				var arr = [];
				arr.push(_this9.view2.sContent.keys[0]['sSchema1Name'] + '.' + _this9.view2.sContent.keys[0]['sSelect1Name'] + ' ' + _this9.view2.sContent.keys[0]['sBie1']);

				for (var i = 0; i < _this9.view2.sContent.keys.length; i++) {
					var _arr = [];
					for (var j = 0; j < _this9.view2.sContent.keys[i]['selectKey'].length; j++) {
						_arr.push(_this9.view2.sContent.keys[i]['sBie1'] + '.' + _this9.stringArr(_this9.view2.sContent.keys[i]['selectKey'][j], 0) + '=' + _this9.view2.sContent.keys[i]['sBie2'] + '.' + _this9.stringArr(_this9.view2.sContent.keys[i]['selectKey'][j], 1));
					}

					arr.push(_this9.view2.sContent.keys[i]['sSchema2Name'] + '.' + _this9.view2.sContent.keys[i]['sSelect2Name'] + ' ' + _this9.view2.sContent.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
				}
				_this9.sql.table = arr.join(' left join  ');

				_this9.$prompt('Enter file name', 'Tips', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					inputPattern: /\S/,
					inputErrorMessage: 'Enter file name'
				}).then(function (_ref2) {
					var value = _ref2.value;

					(0, _api.addSelectView)({
						sSelectName: _this9.sql.table,
						sSelectFieldName: _this9.sql.ziduan,
						sSelectFilter: _this9.sql.tiaojian,
						sContent: (0, _stringify2.default)(_this9.view2.sContent),
						sViewName: value,
						nViewType: 2
					}).then(function (res) {
						_this9.$message('Add Success');
						_this9.dialogVisible3 = false;
						_this9.dialogVisible31 = false;
						_this9.getList2();
					});
				}).catch(function () {});
			});
		},
		save1: function save1() {
			var _this10 = this;

			if (this.view1.sContent.sSelectFilter.length == 1) {
				if (!this.view1.sContent.sSelectFilter[0]['sColumnCode'] && !this.view1.sContent.sSelectFilter[0]['fuhao'] && this.view1.sContent.sSelectFilter[0]['value'].length == 0) {
					this.view1.sContent.sSelectFilter.splice(0, 1);
					return;
				}
			}
			var flag = false;
			for (var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
				if (!this.view1.sContent.sSelectFilter[i]['sColumnCode']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (!this.view1.sContent.sSelectFilter[i]['fuhao']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (this.view1.sContent.sSelectFilter[i]['value'].length == 0) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
			}
			if (flag == true) {
				return;
			}
			if (this.view1.sContent.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}
			this.sql.table = this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName;
			var arr = [];
			for (var i = 0; i < this.view1.sContent.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFieldName[i]);
			}
			this.sql.ziduan = arr.join(',');
			var arr = [];
			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};
			for (var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
				if (this.view1.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view1.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFilter[i]['sColumnCode'] + ' ' + this.view1.sContent.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.view1.sContent.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.view1.sContent.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFilter[i]['sColumnCode'] + this.view1.sContent.sSelectFilter[i]['fuhao'] + "N'" + this.view1.sContent.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}

			(0, _api.selectExColumnValueBynSelectId)({
				nSelectId: this.view1.sContent.nSelectId
			}).then(function (res) {
				var duoyuarr = [];
				res.data.forEach(function (one) {
					duoyuarr.push(_this10.view1.sContent.sSchemaName + '.' + _this10.view1.sContent.sSelectName + '.' + one.sColumnCode + ' in(N' + one.sColumnValue + ')');
				});

				arr = arr.concat(duoyuarr);
				_this10.sql.tiaojian = arr.join(' and ');

				(0, _api.updateSelectView)({
					nViewId: _this10.view1.nViewId,
					sFileName: _this10.view1.sViewName + '.csv',
					sSelectName: _this10.sql.table,
					sSelectFieldName: _this10.sql.ziduan,
					sSelectFilter: _this10.sql.tiaojian,
					sContent: (0, _stringify2.default)(_this10.view1.sContent),
					nViewType: 1
				}).then(function (res) {
					_this10.$message('Update Success');
					_this10.dialogVisible1 = false;
					_this10.dialogVisible11 = false;
					_this10.getList1();
				});
			});
		},
		save11: function save11() {
			var _this11 = this;

			if (this.view1.sContent.sSelectFilter.length == 1) {
				if (!this.view1.sContent.sSelectFilter[0]['sColumnCode'] && !this.view1.sContent.sSelectFilter[0]['fuhao'] && this.view1.sContent.sSelectFilter[0]['value'].length == 0) {
					this.view1.sContent.sSelectFilter.splice(0, 1);
					return;
				}
			}
			var flag = false;
			for (var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
				if (!this.view1.sContent.sSelectFilter[i]['sColumnCode']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (!this.view1.sContent.sSelectFilter[i]['fuhao']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (this.view1.sContent.sSelectFilter[i]['value'].length == 0) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
			}
			if (flag == true) {
				return;
			}
			if (this.view1.sContent.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}

			this.sql.table = this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName;
			var arr = [];
			for (var i = 0; i < this.view1.sContent.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFieldName[i]);
			}
			this.sql.ziduan = arr.join(',');
			var arr = [];
			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};

			for (var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
				if (this.view1.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view1.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFilter[i]['sColumnCode'] + ' ' + this.view1.sContent.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.view1.sContent.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.view1.sContent.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFilter[i]['sColumnCode'] + this.view1.sContent.sSelectFilter[i]['fuhao'] + "N'" + this.view1.sContent.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}

			(0, _api.selectExColumnValueBynSelectId)({
				nSelectId: this.view1.sContent.nSelectId
			}).then(function (res) {
				var duoyuarr = [];
				res.data.forEach(function (one) {
					duoyuarr.push(_this11.view1.sContent.sSchemaName + '.' + _this11.view1.sContent.sSelectName + '.' + one.sColumnCode + ' in(N' + one.sColumnValue + ')');
				});

				arr = arr.concat(duoyuarr);
				_this11.sql.tiaojian = arr.join(' and ');

				_this11.$prompt('Enter file name', 'Tips', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					inputPattern: /\S/,
					inputErrorMessage: 'Enter file name'
				}).then(function (_ref3) {
					var value = _ref3.value;

					(0, _api.addSelectView)({
						sSchema: _this11.view1.sSchema,
						sSelectName: _this11.sql.table,
						sSelectFieldName: _this11.sql.ziduan,
						sSelectFilter: _this11.sql.tiaojian,
						sContent: (0, _stringify2.default)(_this11.view1.sContent),
						sViewName: value,
						nViewType: 1
					}).then(function (res) {
						_this11.$message('Add Success');
						_this11.dialogVisible1 = false;
						_this11.dialogVisible11 = false;
						_this11.getList1();
					});
				}).catch(function () {});
			});
		},
		querySearchAsync2: function querySearchAsync2(queryString) {
			var _this12 = this;

			var index = 0;
			try {
				var node = window.getSelection().focusNode.parentElement;
				index = node.getAttribute('data-id');
			} catch (e) {}
			if (!this.view2.sContent.sSelectFilter[index]['sColumnCode']) {
				this.$message.error('Please select the Condition Code');
				return;
			}
			if (queryString != '') {
				this.loading = true;
				(0, _api.selectColumnValueBynSelectId)({
					nSelectId: this.view2.sContent.sSelectFilter[index]['nSelectId'],
					sColumnCode: this.view2.sContent.sSelectFilter[index]['sColumnCode']
				}).then(function (res) {
					if (res.data.length === 0) {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this12.view2.sContent.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this12.view2.sContent.sSelectFilter[index]['sSchemaName'],
							sSelectName: _this12.view2.sContent.sSelectFilter[index]['sSelectName'],
							pageSize: 9999
						}).then(function (res) {
							var arr = [];
							for (var i = 0; i < res.data.length; i++) {
								arr.push(res.data[i][_this12.view2.sContent.sSelectFilter[index]['sColumnCode']]);
							}
							_this12.loading = false;
							_this12.view2.sContent.sSelectFilter[index].options = arr;
						});
					} else {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this12.view2.sContent.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this12.view2.sContent.sSelectFilter[index]['sSchemaName'],
							sSelectName: _this12.view2.sContent.sSelectFilter[index]['sSelectName'],
							pageSize: 9999
						}).then(function (res2) {
							var arr = [];
							for (var i = 0, len = res.data.length; i < len; i++) {
								for (var j = 0, len2 = res2.data.length; j < len2; j++) {
									if (res.data[i]['sColumnValue'] == res2.data[j][_this12.view2.sContent.sSelectFilter[index]['sColumnCode']]) {
										arr.push(res.data[i]['sColumnValue']);
									}
								}
							}
							_this12.loading = false;
							_this12.view2.sContent.sSelectFilter[index].options = arr;
						});
					}
				});
			}
		},
		querySearchAsync: function querySearchAsync(queryString) {
			var _this13 = this;

			var index = 0;
			try {
				var node = window.getSelection().focusNode.parentElement;
				index = node.getAttribute('data-id');
			} catch (e) {}
			if (!this.view1.sContent.sSelectFilter[index]['sColumnCode']) {
				this.$message.error('Please select the Condition Code');
				return;
			}
			if (queryString != '') {
				this.loading = true;
				(0, _api.selectColumnValueBynSelectId)({
					nSelectId: this.view1.sContent.nSelectId,
					sColumnCode: this.view1.sContent.sSelectFilter[index]['sColumnCode']
				}).then(function (res) {
					if (res.data.length === 0) {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this13.view1.sContent.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this13.view1.sContent.sSchemaName,
							sSelectName: _this13.view1.sContent.sSelectName,
							pageSize: 9999
						}).then(function (res) {
							var arr = [];
							for (var i = 0; i < res.data.length; i++) {
								arr.push(res.data[i][_this13.view1.sContent.sSelectFilter[index]['sColumnCode']]);
							}
							_this13.loading = false;
							_this13.view1.sContent.sSelectFilter[index].options = arr;
						});
					} else {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this13.view1.sContent.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this13.view1.sContent.sSchemaName,
							sSelectName: _this13.view1.sContent.sSelectName,
							pageSize: 9999
						}).then(function (res2) {
							var arr = [];
							for (var i = 0, len = res.data.length; i < len; i++) {
								for (var j = 0, len2 = res2.data.length; j < len2; j++) {
									if (res.data[i]['sColumnValue'] == res2.data[j][_this13.view1.sContent.sSelectFilter[index]['sColumnCode']]) {
										arr.push(res.data[i]['sColumnValue']);
									}
								}
							}
							_this13.loading = false;
							_this13.view1.sContent.sSelectFilter[index].options = arr;
						});
					}
				});
			}
		},
		change2: function change2(item) {
			for (var i = 0; i < this.options3.length; i++) {
				if (this.options3[i]['sColumnCode'] == item.sColumnCode) {
					item.type = this.options3[i]['sColumnType'];
				}
			}
			if (item.sColumnCode == '') {
				item.fuhao = '';
				item.value = [];
				item.options = [];
			}
		},
		change4: function change4(item, index, content) {
			if (!!item.sBie) {
				for (var i = 0; i < this.view2.sContent.table.length; i++) {
					if (this.view2.sContent.table[i]['sBie'] == item.sBie) {
						item.sName = this.view2.sContent.table[i]['sName'];
						item.sSchemaName = this.view2.sContent.table[i]['sSchemaName'];
						item.sSelectName = this.view2.sContent.table[i]['sSelectName'];
						item.nSelectId = this.view2.sContent.table[i]['nSelectId'];
					}
				}
				console.log(item);
				(0, _api.getSelectColumnList)({
					currentPage: 1,
					nSelectId: item.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					item.codes = res.data;
					item.fuhao = '';
					item.sColumnCode = '';
					item.value = [];
					item.options = [];
				});
			} else {
				item.fuhao = '';
				item.codes = [];
				item.sColumnCode = '';
				item.value = [];
				item.options = [];
			}
		},
		change5: function change5(item) {
			for (var i = 0; i < item.codes.length; i++) {
				if (item.codes[i]['sColumnCode'] == item.sColumnCode) {
					item.type = item.codes[i]['sColumnType'];
				}
			}
		},
		handleCheckAllChange: function handleCheckAllChange(flag) {
			if (flag == true) {
				var arr = [];
				for (var i = 0; i < this.options3.length; i++) {
					arr.push(this.options3[i]['sColumnCode']);
				}
				this.view1.sContent.sSelectFieldName = arr;
			} else {
				this.view1.sContent.sSelectFieldName = [];
			}

			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
			var checkedCount = value.length;
			this.checkAll = checkedCount === this.options3.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.options3.length;
		},
		handleCheckAllChange2: function handleCheckAllChange2(item) {
			if (item.checkAll == false) {
				item.value = [];
			} else {
				var arr = [];
				for (var i = 0; i < item.options.length; i++) {
					arr.push(item.options[i]['sColumnCode']);
				}
				item.value = arr;
			}
			item.isIndeterminate = false;
		},
		handleCheckedCitiesChange2: function handleCheckedCitiesChange2(value) {
			var item = null;
			for (var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
				for (var j = 0; j < this.view2.sContent.sSelectFieldName[i]['options'].length; j++) {
					if (value[0] == this.view2.sContent.sSelectFieldName[i]['options'][j]['sColumnCode']) {
						item = this.view2.sContent.sSelectFieldName[i];
					}
				}
			}

			var checkedCount = value.length;
			if (checkedCount == 0) {
				item.checkAll = false;
				item.isIndeterminate = false;
			} else {
				item.checkAll = checkedCount === item.options.length;
				item.isIndeterminate = checkedCount > 0 && checkedCount < item.options.length;
			}
		},
		stringArr: function stringArr(str, index) {
			var arr = (str || '').split('=');
			try {
				return arr[index];
			} catch (e) {
				return 0;
			}
		},
		addDownLoad3: function addDownLoad3() {
			var _this14 = this;

			if (this.timer == 0) {
				(0, _api.simpleDownloadExport)({
					nViewId: this.view3.nViewId,
					sSelectName: this.sql.table,
					sSelectFieldName: this.sql.ziduan,
					sSelectFilter: this.sql.tiaojian,
					sContent: (0, _stringify2.default)(this.view3.sContent),
					sFileName: this.view3.sViewName + '.csv',
					nType: 3
				}).then(function (res) {
					_this14.timer = 60;
					var _this = _this14;
					var T = setInterval(function () {
						_this.timer--;
						if (_this.timer == 1) {
							clearInterval(T);
							setTimeout(function () {
								_this.timer = 0;
							}, 1000);
						}
					}, 1000);
				});
			}
		},
		addDownLoad: function addDownLoad() {
			var _this15 = this;

			if (this.timer == 0) {
				(0, _api.simpleDownloadExport)({
					nViewId: this.view1.nViewId,
					sSelectName: this.sql.table,
					sSelectFieldName: this.sql.ziduan,
					sSelectFilter: this.sql.tiaojian,
					sContent: (0, _stringify2.default)(this.view1.sContent),
					sFileName: this.view1.sViewName + '.csv',
					nType: 1
				}).then(function (res) {
					_this15.timer = 60;
					var _this = _this15;
					var T = setInterval(function () {
						_this.timer--;
						if (_this.timer == 1) {
							clearInterval(T);
							setTimeout(function () {
								_this.timer = 0;
							}, 1000);
						}
					}, 1000);
				});
			}
		},
		addDownLoad2: function addDownLoad2() {
			var _this16 = this;

			if (this.timer == 0) {
				(0, _api.simpleDownloadExport)({
					nViewId: this.view2.nViewId,
					sSelectName: this.sql.table,
					sSelectFieldName: this.sql.ziduan,
					sSelectFilter: this.sql.tiaojian,
					sContent: (0, _stringify2.default)(this.view2.sContent),
					sFileName: this.view2.sViewName + '.csv',
					nType: 2
				}).then(function (res) {
					_this16.timer = 60;
					var _this = _this16;
					var T = setInterval(function () {
						_this.timer--;
						if (_this.timer == 1) {
							clearInterval(T);
							setTimeout(function () {
								_this.timer = 0;
							}, 1000);
						}
					}, 1000);
				});
			}
		},
		doDownload2: function doDownload2() {
			var _this17 = this;

			(0, _api.simpleDownloadExport)({
				nViewId: this.view2.nViewId,
				sSchema: this.view2.sSchema,
				sSelectName: this.view2.sSelectName,
				sSelectFieldName: this.view2.sSelectFieldName,
				sSelectFilter: this.view2.sSelectFilter,
				sFileName: this.view2.sViewName + '.csv',
				sContent: (0, _stringify2.default)(this.view2.sContent),
				sFavorite: 0,
				nType: 2
			}).then(function (res) {
				_this17.$message('download success！');
			});
		},
		doDownload1: function doDownload1() {
			var _this18 = this;

			(0, _api.simpleDownloadExport)({
				nViewId: this.view1.nViewId,
				sSchema: this.view1.sSchema,
				sSelectName: this.view1.sSelectName,
				sSelectFieldName: this.view1.sSelectFieldName,
				sSelectFilter: this.view1.sSelectFilter,
				sFileName: this.view1.sViewName + '.csv',
				sContent: (0, _stringify2.default)(this.view1.sContent),
				sFavorite: 0,
				nType: 1
			}).then(function (res) {
				_this18.$message('download success！');
			});
		},
		doQuery1: function doQuery1() {
			var _this19 = this;

			this.sql.table = this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName;
			var arr = [];
			for (var i = 0; i < this.view1.sContent.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFieldName[i]);
			}
			this.sql.ziduan = arr.join(',');
			var arr = [];
			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};
			for (var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
				if (this.view1.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view1.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFilter[i]['sColumnCode'] + ' ' + this.view1.sContent.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.view1.sContent.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.view1.sContent.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFilter[i]['sColumnCode'] + this.view1.sContent.sSelectFilter[i]['fuhao'] + "N'" + this.view1.sContent.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}
			this.sql.tiaojian = arr.join(' and ');
			var loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			(0, _api.getDynamicSQL)({
				sSelectName: this.sql.table,
				sSelectFieldName: this.sql.ziduan,
				sSelectFilter: this.sql.tiaojian,
				sSchemaName: this.view1.sContent.sSchemaName,
				currentPage: 1,
				pageSize: 100
			}).then(function (res) {
				loading.close();
				_this19.count = res.page.totalCount * 1;
				_this19.tableData = res.data;
				_this19.dialogVisible2 = true;
			}).catch(function (res) {
				loading.close();
			});
		},
		doEdit1: function doEdit1() {
			this.dialogVisible11 = true;
		},
		addList2: function addList2(item) {
			item.push({
				nSelectId: '',
				codes: [],
				sName: '',
				sBie: '',
				sSchemaName: '',
				sSelectName: '',
				sColumnCode: '',
				fuhao: '',
				options: [],
				value: [],
				type: ''
			});
		},
		deleteList2: function deleteList2(item, index) {
			item.splice(index, 1);
		},
		addList: function addList(item) {
			item.push({
				sColumnCode: '',
				fuhao: '',
				options: [],
				value: [],
				type: ''
			});
		},
		deleteList: function deleteList(item, index) {
			item.splice(index, 1);
		},
		doQuery2: function doQuery2() {
			var _this20 = this;

			console.log(this.view2.sContent);
			var arr = [];
			var displayArr = [];
			for (var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
				for (var j = 0; j < this.view2.sContent.sSelectFieldName[i]['value'].length; j++) {
					arr.push(this.view2.sContent.sSelectFieldName[i]['sBie'] + '.' + this.view2.sContent.sSelectFieldName[i]['value'][j] + ' as ' + this.view2.sContent.sSelectFieldName[i]['sBie'] + '_' + this.view2.sContent.sSelectFieldName[i]['value'][j]);
					displayArr.push(this.view2.sContent.sSelectFieldName[i]['sBie'] + '_' + this.view2.sContent.sSelectFieldName[i]['value'][j]);
				}
			}
			this.sql.ziduan = arr.join(',');
			var arr = [];
			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};
			for (var i = 0; i < this.view2.sContent.sSelectFilter.length; i++) {
				if (this.view2.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view2.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.view2.sContent.sSelectFilter[i]['sBie'] + '.' + this.view2.sContent.sSelectFilter[i]['sColumnCode'] + ' ' + this.view2.sContent.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.view2.sContent.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.view2.sContent.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.view2.sContent.sSelectFilter[i]['sBie'] + '.' + this.view2.sContent.sSelectFilter[i]['sColumnCode'] + this.view2.sContent.sSelectFilter[i]['fuhao'] + "N'" + this.view2.sContent.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}
			this.sql.tiaojian = arr.join(' and ');
			var arr = [];
			arr.push(this.view2.sContent.keys[0]['sSchema1Name'] + '.' + this.view2.sContent.keys[0]['sSelect1Name'] + ' ' + this.view2.sContent.keys[0]['sBie1']);

			for (var i = 0; i < this.view2.sContent.keys.length; i++) {
				var _arr = [];
				for (var j = 0; j < this.view2.sContent.keys[i]['selectKey'].length; j++) {
					_arr.push(this.view2.sContent.keys[i]['sBie1'] + '.' + this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 0) + '=' + this.view2.sContent.keys[i]['sBie2'] + '.' + this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 1));
				}

				arr.push(this.view2.sContent.keys[i]['sSchema2Name'] + '.' + this.view2.sContent.keys[i]['sSelect2Name'] + ' ' + this.view2.sContent.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
			}
			this.sql.table = arr.join(' left join  ');

			var loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			(0, _api.getDynamicSQL)({
				sSelectName: this.sql.table,
				sSelectFieldName: this.sql.ziduan,
				sSelectFilter: this.sql.tiaojian,
				sSchemaName: this.view2.sContent.sSchema,
				currentPage: 1,
				pageSize: 100
			}).then(function (res) {
				loading.close();
				_this20.count = res.page.totalCount * 1;
				_this20.tableData = res.data;
				_this20.displayArr = displayArr;
				_this20.dialogVisible4 = true;
			}).catch(function (res) {
				loading.close();
			});
		},
		doEdit2: function doEdit2() {
			this.dialogVisible31 = true;
		},
		arrToString: function arrToString(arr) {
			try {
				return arr.join(',');
			} catch (e) {
				return arr;
			}
		},
		sp: function sp(row, column, event) {
			console.log(row);
			this.view3 = row;
			this.dialogVisible5 = true;
		},
		multiTable: function multiTable(row, column, event) {
			console.log(row);
			this.view2 = row;
			this.dialogVisible3 = true;
		},
		singleTable: function singleTable(row, column, event) {
			var _this21 = this;

			console.log(row);
			this.view1 = row;
			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: this.view1.sContent.nSelectId,
				pageSize: 9999
			}).then(function (res) {
				_this21.options3 = res.data;
				_this21.dialogVisible1 = true;
			});
		},
		handleCurrentChange3: function handleCurrentChange3(val) {
			this.filter3.currentPage = val;
			this.getList3();
		},
		handleCurrentChange2: function handleCurrentChange2(val) {
			this.filter2.currentPage = val;
			this.getList2();
		},
		handleCurrentChange1: function handleCurrentChange1(val) {
			this.filter1.currentPage = val;
			this.getList1();
		},

		getList1: function getList1() {
			var _this22 = this;

			var param = (0, _assign2.default)({}, this.filter1);
			(0, _api.getSelectViewList)(param).then(function (res) {
				for (var i = 0; i < res.data.length; i++) {
					if (!!res.data[i]['sContent']) {
						res.data[i]['sContent'] = JSON.parse(res.data[i]['sContent']);
					} else {
						res.data[i]['sContent'] = {};
					}
				}
				_this22.tableData1 = res.data;
				_this22.total1 = res.page.totalCount * 1;
			});
		},
		getList2: function getList2() {
			var _this23 = this;

			var param = (0, _assign2.default)({}, this.filter2);
			(0, _api.getSelectViewList)(param).then(function (res) {
				for (var i = 0; i < res.data.length; i++) {
					if (!!res.data[i]['sContent']) {
						res.data[i]['sContent'] = JSON.parse(res.data[i]['sContent']);
					} else {
						res.data[i]['sContent'] = {};
					}
				}
				_this23.tableData2 = res.data;
				_this23.total2 = res.page.totalCount * 1;
			});
		},
		getList3: function getList3() {
			var _this24 = this;

			var param = (0, _assign2.default)({}, this.filter3);
			(0, _api.getSelectViewList)(param).then(function (res) {
				for (var i = 0; i < res.data.length; i++) {
					if (!!res.data[i]['sContent']) {
						res.data[i]['sContent'] = JSON.parse(res.data[i]['sContent']);
					} else {
						res.data[i]['sContent'] = {};
					}
				}
				_this24.tableData3 = res.data;
				_this24.total3 = res.page.totalCount * 1;
			});
		}
	}
};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeName: "first",
      filter1: {
        nType: 1,
        pageSize: 10,
        currentPage: 1
      },
      filter2: {
        nType: 2,
        pageSize: 10,
        currentPage: 1
      },
      filter3: {
        nType: 3,
        pageSize: 10,
        currentPage: 1
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      total1: 0,
      total2: 0,
      total3: 0,
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px"
      },
      cellStyle: {
        height: "55px"
      }
    };
  },
  mounted: function mounted() {
    this.getList1();
  },

  methods: {
    download: function download(data) {
      window.open("helpDoc/" + data['Address'], "_blank");
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.filter1.currentPage = val;
      this.getList1();
    },


    getList1: function getList1() {
      var _this = this;

      var param = (0, _assign2.default)({
        sSelectName: "Prompt_List",
        sSelectFieldName: "DocumentName,Address",
        extBody: 1,
        sSchemaName: "business_data.dbo"
      }, this.filter1);
      (0, _api.getDynamicSQL)(param).then(function (res) {
        _this.tableData1 = res.data;
        _this.total1 = res.page.totalCount * 1;
      });
    } }
};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(84);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(316);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(12);

var _util = __webpack_require__(83);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		var _form;

		return {
			step: 0,
			form: (_form = {
				sSchema: "",
				table: [{
					sName: '',
					sBie: '',
					sSchemaName: '',
					sSelectName: '',
					nSelectId: '',
					options: []
				}],
				keys: []
			}, (0, _defineProperty3.default)(_form, 'sSchema', ""), (0, _defineProperty3.default)(_form, 'sSelectFilter', []), (0, _defineProperty3.default)(_form, 'sSelectFieldName', []), _form),
			activeName: 'first',
			options: [],
			options4: [{
				id: 'in',
				name: '='
			}, {
				id: '>',
				name: '>'
			}, {
				id: '>=',
				name: '>='
			}, {
				id: '<',
				name: '<'
			}, {
				id: '<=',
				name: '<='
			}, {
				id: 'not in',
				name: '!='
			}],
			options5: [],
			dialogVisible: false,
			loading: false,
			tableData: [],
			showListFlag: false,
			count: 0,
			sql: {
				table: '',
				ziduan: '',
				join: '',
				tiaojian: ''
			},
			favortFlag: false,
			displayArr: [],
			timer: 0
		};
	},
	mounted: function mounted() {
		var _this2 = this;

		(0, _api.getDatabaseInfoList)({
			currentPage: 1,
			pageSize: 9999
		}).then(function (res) {
			_this2.options = res.data;
		});
	},

	methods: {
		panduanTable1: function panduanTable1(a, item) {
			if (a.sBie != item.sBie2) {
				if (this.form.keys.length == 1) {
					return true;
				} else {
					var one = this.form.keys[this.form.keys.length - 2];
					if (one.sBie1 == '') {
						return true;
					} else {
						if (a.sBie == one.sBie1 || a.sBie == one.sBie2) {
							return true;
						} else {
							return false;
						}
					}
				}
			} else {
				return false;
			}
		},
		timeFormatter: function timeFormatter(row, column) {
			var shuju = row[column.property];
			try {
				if (shuju.indexOf('T') > -1) {
					var times = new Date(shuju);
					if (times == 'Invalid Date') {
						return shuju;
					}
					return _util2.default.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
				} else {
					return shuju;
				}
			} catch (e) {
				return shuju;
			}
		},
		stringArr: function stringArr(str, index) {
			var arr = (str || '').split('=');
			try {
				return arr[index];
			} catch (e) {
				return 0;
			}
		},
		querySearchAsync: function querySearchAsync(queryString) {
			var _this3 = this;

			this.options5 = [];
			var index = 0;
			try {
				var node = window.getSelection().focusNode.parentElement;
				index = node.getAttribute('data-id');
			} catch (e) {}
			if (!this.form.sSelectFilter[index]['sColumnCode']) {
				this.$message.error('Please select the Condition Code');
				return;
			}
			if (queryString != '') {
				this.loading = true;
				(0, _api.selectColumnValueBynSelectId)({
					nSelectId: this.form.sSelectFilter[index]['nSelectId'],
					sColumnCode: this.form.sSelectFilter[index]['sColumnCode']
				}).then(function (res) {
					if (res.data.length === 0) {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this3.form.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this3.form.sSelectFilter[index]['sSchemaName'],
							sSelectName: _this3.form.sSelectFilter[index]['sSelectName'],
							pageSize: 9999
						}).then(function (res) {
							var arr = [];
							for (var i = 0; i < res.data.length; i++) {
								arr.push(res.data[i][_this3.form.sSelectFilter[index]['sColumnCode']]);
							}
							_this3.loading = false;
							_this3.form.sSelectFilter[index].options = arr;
						});
					} else {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this3.form.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this3.form.sSelectFilter[index]['sSchemaName'],
							sSelectName: _this3.form.sSelectFilter[index]['sSelectName'],
							pageSize: 9999
						}).then(function (res2) {
							var arr = [];
							for (var i = 0, len = res.data.length; i < len; i++) {
								for (var j = 0, len2 = res2.data.length; j < len2; j++) {
									if (res.data[i]['sColumnValue'] == res2.data[j][_this3.form.sSelectFilter[index]['sColumnCode']]) {
										arr.push(res.data[i]['sColumnValue']);
									}
								}
							}
							_this3.loading = false;
							_this3.form.sSelectFilter[index].options = arr;
						});
					}
				});
			}
		},
		addTable: function addTable(item) {
			if (!item[0].nSelectId) {
				this.$message('Select Table');
				return;
			}
			var obj = {
				sName: '',
				sBie: '',
				sSchemaName: item[0].sSchemaName,
				sSelectName: '',
				nSelectId: '',
				options: []
			};

			if (this.form.table.length == 1) {
				(0, _api.getSelectSecondTableList)({
					nSelect1Id: this.form.table[0].nSelectId,
					sSchemaName: this.form.table[0].sSchemaName
				}).then(function (res) {
					obj.options = res.data;
					item.push(obj);
				});
			} else if (this.form.table.length == 2) {
				if (!item[1].nSelectId) {
					this.$message('Select Table');
					return;
				}
				(0, _api.getSelectThirdTableList)({
					nSelect1Id: this.form.table[0].nSelectId,
					nSelect2Id: this.form.table[1].nSelectId
				}).then(function (res) {
					obj.options = res.data;
					item.push(obj);
				});
			}
		},
		deleteTable: function deleteTable(item, index) {
			item.splice(index, 1);
			try {
				this.form.sSelectFieldName.splice(index, 1);
			} catch (e) {}
		},
		addList: function addList(item) {
			item.push({
				nSelectId: '',
				codes: [],
				sName: '',
				sBie: '',
				sSchemaName: '',
				sSelectName: '',
				sColumnName: '',
				sColumnCode: '',
				fuhao: '',
				options: [],
				value: [],
				type: ''
			});
		},
		deleteList: function deleteList(item, index) {
			item.splice(index, 1);
		},
		addkey: function addkey(item) {
			item.push({
				table1: '',
				sName1: '',
				sBie1: '',
				sSchema1Name: '',
				sSelect1Name: '',
				table2: '',
				sName2: '',
				sBie2: '',
				sSchema2Name: '',
				sSelect2Name: '',
				selectKey: [],
				keys: []
			});
		},
		deletekey: function deletekey(item, index) {
			item.splice(index, 1);
		},
		toStep0: function toStep0() {
			this.step = 0;
		},
		toStep1: function toStep1() {
			for (var i = this.form.table.length - 1; i >= 0; i--) {
				if (!this.form.table[i]['nSelectId']) {
					this.form.table.splice(i, 1);
				}
			}
			if (this.form.table.length < 2) {
				this.$message.error('Please select the minimum two table');
				return;
			}
			if (this.form.keys.length == 0) {
				this.form.keys = [{
					table1: '',
					sName1: '',
					sBie1: '',
					sSchema1Name: '',
					sSelect1Name: '',
					table2: '',
					sName2: '',
					sBie2: '',
					sSchema2Name: '',
					sSelect2Name: '',
					selectKey: [],
					keys: []
				}];
			}
			this.step = 2;
		},
		toStep2: function toStep2() {
			var flag = false;
			var obj = {};
			var index = 0;
			for (var i = 0; i < this.form.keys.length; i++) {
				if (this.form.keys[i]['selectKey'].length == 0) {
					this.$message.error('Please select the table keys');
					flag = true;
					return;
				}
				if (!obj[this.form.keys[i]['table1']]) {
					obj[this.form.keys[i]['table1']] = 1;
					index++;
				}
				if (!obj[this.form.keys[i]['table2']]) {
					obj[this.form.keys[i]['table2']] = 1;
					index++;
				}
			}


			if (flag == true) {
				return;
			}
			if (this.form.sSelectFilter.length == 0) {
				this.form.sSelectFilter = [{
					nSelectId: '',
					codes: [],
					sName: '',
					sBie: '',
					sSchemaName: '',
					sSelectName: '',
					sColumnName: '',
					sColumnCode: '',
					fuhao: '',
					options: [],
					value: [],
					type: ''
				}];
			}
			this.step = 3;
		},
		toStep3: function toStep3() {

			if (this.form.sSelectFilter.length == 1) {
				if (!this.form.sSelectFilter[0]['sColumnCode'] && !this.form.sSelectFilter[0]['fuhao'] && this.form.sSelectFilter[0]['value'].length == 0) {
					this.form.sSelectFilter.splice(0, 1);
					this.step = 5;
					return;
				}
			}
			var flag = false;
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (!this.form.sSelectFilter[i]['sColumnCode']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (!this.form.sSelectFilter[i]['fuhao']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (this.form.sSelectFilter[i]['value'].length == 0) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
			}
			this.step = 5;
		},
		save2: function save2() {
			var _this4 = this;

			if (this.form.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}
			this.$prompt('Enter file name', 'Tips', {
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				inputPattern: /\S/,
				inputErrorMessage: 'Enter file name'
			}).then(function (_ref) {
				var value = _ref.value;

				var sqlDongGArr = [];
				_this4.form.table.forEach(function (one) {
					sqlDongGArr.push((0, _api.selectExColumnValueBynSelectId)({
						nSelectId: one.nSelectId
					}));
				});
				_promise2.default.all(sqlDongGArr).then(function (res) {
					var duoyuanarr = [];
					res.forEach(function (one, index) {
						one.data.forEach(function (two) {
							duoyuanarr.push(_this4.form.table[index]['sBie'] + '.' + two.sColumnCode + ' in(N' + two.sColumnValue + ')');
						});
					});

					_this4.pinjiesql(duoyuanarr);
					(0, _api.addDownloadExport)({
						sSchema: _this4.form.sSchema,
						sSelectName: _this4.sql.table,
						sSelectFieldName: _this4.sql.ziduan,
						sSelectFilter: _this4.sql.tiaojian,
						sFileName: value + '.csv',
						sContent: (0, _stringify2.default)(_this4.form),
						sFavorite: 0,
						nType: 2,
						sStatus: 0
					}).then(function (res) {
						_this4.$message('download success！');
					});
				});
			}).catch(function () {});
		},
		save: function save() {
			var _this5 = this;

			if (this.form.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}

			var arr = [];
			var displayArr = [];
			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {
				for (var j = 0; j < this.form.sSelectFieldName[i]['value'].length; j++) {
					arr.push(this.form.sSelectFieldName[i]['sBie'] + '.' + this.form.sSelectFieldName[i]['value'][j] + ' as ' + this.form.sSelectFieldName[i]['sBie'] + '_' + this.form.sSelectFieldName[i]['value'][j]);
					displayArr.push(this.form.sSelectFieldName[i]['sBie'] + '_' + this.form.sSelectFieldName[i]['value'][j]);
				}
			}
			this.sql.ziduan = arr.join(',');

			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};
			var arr = [];
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.form.sSelectFilter[i]['sBie'] + '.' + this.form.sSelectFilter[i]['sColumnCode'] + ' ' + this.form.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.form.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.form.sSelectFilter[i]['sBie'] + '.' + this.form.sSelectFilter[i]['sColumnCode'] + this.form.sSelectFilter[i]['fuhao'] + "N'" + this.form.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}
			this.sql.tiaojian = arr.join(' and ');

			var arr = [];
			arr.push(this.form.keys[0]['sSchema1Name'] + '.' + this.form.keys[0]['sSelect1Name'] + ' ' + this.form.keys[0]['sBie1']);

			for (var i = 0; i < this.form.keys.length; i++) {
				var _arr = [];
				for (var j = 0; j < this.form.keys[i]['selectKey'].length; j++) {
					_arr.push(this.form.keys[i]['sBie1'] + '.' + this.stringArr(this.form.keys[i]['selectKey'][j], 0) + '=' + this.form.keys[i]['sBie2'] + '.' + this.stringArr(this.form.keys[i]['selectKey'][j], 1));
				}

				arr.push(this.form.keys[i]['sSchema2Name'] + '.' + this.form.keys[i]['sSelect2Name'] + ' ' + this.form.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
			}
			this.sql.table = arr.join(' left join  ');
			var loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			(0, _api.getDynamicSQL)({
				sSelectName: this.sql.table,
				sSelectFieldName: this.sql.ziduan,
				sSelectFilter: this.sql.tiaojian,
				sSchemaName: this.form.sSchema,
				currentPage: 1,
				pageSize: 100
			}).then(function (res) {
				loading.close();
				_this5.count = res.page.totalCount * 1;
				_this5.tableData = res.data;
				_this5.favortFlag = false;
				_this5.timer = 0;
				_this5.displayArr = displayArr;
				_this5.dialogVisible = true;
			}).catch(function (res) {
				loading.close();
			});
		},
		change1: function change1(item, index) {
			var _this6 = this;

			(0, _api.getSelectList)({
				currentPage: 1,
				nSelectType: 1,
				sSchema: this.form.sSchema,
				pageSize: 9999
			}).then(function (res) {
				_this6.form.table[0].options = res.data;
			});
		},
		change5: function change5(item) {
			for (var i = 0; i < item.codes.length; i++) {
				if (item.codes[i]['sColumnCode'] == item.sColumnCode) {
					item.type = item.codes[i]['sColumnType'];
					item.sColumnName = item.codes[i]['sColumnName'];
				}
			}
		},
		change4: function change4(item, index) {
			if (!!item.sBie) {
				for (var i = 0; i < this.form.table.length; i++) {
					if (this.form.table[i]['sBie'] == item.sBie) {
						item.sName = this.form.table[i]['sName'];
						item.sSchemaName = this.form.table[i]['sSchemaName'];
						item.sSelectName = this.form.table[i]['sSelectName'];
						item.nSelectId = this.form.table[i]['nSelectId'];
					}
				}

				(0, _api.getSelectColumnList)({
					currentPage: 1,
					nSelectId: item.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					item.codes = res.data;
					item.fuhao = '';
					item.sColumnCode = '';
					item.value = [];
					item.options = [];
				});
			} else {
				item.fuhao = '';
				item.codes = [];
				item.sColumnCode = '';
				item.value = [];
				item.options = [];
			}
		},
		change2: function change2(item, index) {
			var _this7 = this;

			for (var i = 0; i < item.options.length; i++) {
				if (item.options[i]['nSelectId'] == item.nSelectId) {
					item.sSelectName = item.options[i]['sSelectName'];
					item.sSchemaName = item.options[i]['sSchemaName'];
					item.sName = item.options[i]['sName'];
					item.sBie = 'Table' + (index + 1);
				}
			}

			this.form.keys = [{
				table1: '',
				sName1: '',
				sBie1: '',
				sSchema1Name: '',
				sSelect1Name: '',
				table2: '',
				sName2: '',
				sBie2: '',
				sSchema2Name: '',
				sSelect2Name: '',
				selectKey: [],
				keys: []
			}];

			this.form.sSelectFilter = [{
				nSelectId: '',
				codes: [],
				sName: '',
				sBie: '',
				sSchemaName: '',
				sSelectName: '',
				sColumnName: '',
				sColumnCode: '',
				fuhao: '',
				options: [],
				value: [],
				type: ''
			}];

			if (index == 0) {
				(0, _api.getSelectSecondTableList)({
					nSelect1Id: item.nSelectId,
					sSchemaName: item.sSchemaName
				}).then(function (res) {
					try {
						_this7.form.table[1]['nSelectId'] = '';

						_this7.form.table[1].options = res.data;
						console.log(_this7.form);
					} catch (e) {}
				});
			} else if (index == 1) {
				(0, _api.getSelectThirdTableList)({
					nSelect1Id: this.form.table[0].nSelectId,
					nSelect2Id: this.form.table[1].nSelectId
				}).then(function (res) {
					try {
						_this7.form.table[2]['nSelectId'] = '';
						_this7.form.table[2].options = res.data;
					} catch (e) {}
				});
			}

			if (index == 0) {
				(0, _api.getSelectColumnList)({
					currentPage: 1,
					nSelectId: item.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					if (_this7.form.sSelectFieldName.length == 0) {
						_this7.form.sSelectFieldName.push({
							sNameAll: item.sName,
							sBie: item.sBie,
							sName: item.sSchemaName + '.' + item.sSelectName,
							checkAll: false,
							isIndeterminate: true,
							options: res.data,
							value: []
						});
					} else {
						_this7.$set(_this7.form.sSelectFieldName, 0, {
							sNameAll: item.sName,
							sBie: item.sBie,
							sName: item.sSchemaName + '.' + item.sSelectName,
							checkAll: false,
							isIndeterminate: true,
							options: res.data,
							value: []
						});
					}
				});
			} else if (index == 1) {
				(0, _api.getSelectColumnList)({
					currentPage: 1,
					nSelectId: item.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					if (_this7.form.sSelectFieldName.length == 1) {
						_this7.form.sSelectFieldName.push({
							sNameAll: item.sName,
							sBie: item.sBie,
							sName: item.sSchemaName + '.' + item.sSelectName,
							checkAll: false,
							isIndeterminate: true,
							options: res.data,
							value: []
						});
					} else {
						_this7.$set(_this7.form.sSelectFieldName, 1, {
							sNameAll: item.sName,
							sBie: item.sBie,
							sName: item.sSchemaName + '.' + item.sSelectName,
							checkAll: false,
							isIndeterminate: true,
							options: res.data,
							value: []
						});
					}
				});
			} else if (index == 2) {
				(0, _api.getSelectColumnList)({
					currentPage: 1,
					nSelectId: item.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					if (_this7.form.sSelectFieldName.length == 2) {
						_this7.form.sSelectFieldName.push({
							checkAll: false,
							sBie: item.sBie,
							isIndeterminate: true,
							options: res.data,
							sNameAll: item.sName,
							sName: item.sSchemaName + '.' + item.sSelectName,
							value: []
						});
					} else {
						_this7.$set(_this7.form.sSelectFieldName, 2, {
							sNameAll: item.sName,
							sBie: item.sBie,
							sName: item.sSchemaName + '.' + item.sSelectName,
							checkAll: false,
							isIndeterminate: true,
							options: res.data,
							value: []
						});
					}
				});
			}
		},
		change3: function change3(item, index) {
			console.log(item);
			if (!!item.sBie1 && !!item.sBie2) {
				for (var i = 0; i < this.form.table.length; i++) {
					if (this.form.table[i]['sBie'] == item.sBie1) {
						item.sSchema1Name = this.form.table[i]['sSchemaName'];
						item.sSelect1Name = this.form.table[i]['sSelectName'];
						item.sName1 = this.form.table[i]['sName'];
						item.nSelect1Id = this.form.table[i]['nSelectId'];
					}
					if (this.form.table[i]['sBie'] == item.sBie2) {
						item.sSchema2Name = this.form.table[i]['sSchemaName'];
						item.sSelect2Name = this.form.table[i]['sSelectName'];
						item.sName2 = this.form.table[i]['sName'];
						item.nSelect2Id = this.form.table[i]['nSelectId'];
					}
				}
				(0, _api.getTableRelevanceListBySelectList)({
					nSelect1Id: item.nSelect1Id,
					nSelect2Id: item.nSelect2Id
				}).then(function (res) {
					var arr = [];
					for (var i = 0; i < res.data.length; i++) {
						if (res.data[i]['nSelect1Id'] == item.nSelect1Id && res.data[i]['nSelect2Id'] == item.nSelect2Id) {
							arr.push(res.data[i]);
						} else {
							arr.push({
								nSelect1Id: res.data[i]['nSelect2Id'],
								nSelect1Key: res.data[i]['nSelect2Key'],
								nSelect2Id: res.data[i]['nSelect1Id'],
								nSelect2Key: res.data[i]['nSelect1Key']
							});
						}
					}

					item.keys = arr;
				});
			}
		},
		handleCheckAllChange: function handleCheckAllChange(item) {
			if (item.checkAll == false) {
				item.value = [];
			} else {
				var arr = [];
				for (var i = 0; i < item.options.length; i++) {
					arr.push(item.options[i]['sColumnCode']);
				}
				item.value = arr;
			}
			item.isIndeterminate = false;
		},
		handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
			var item = null;
			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {
				for (var j = 0; j < this.form.sSelectFieldName[i]['options'].length; j++) {
					if (value[0] == this.form.sSelectFieldName[i]['options'][j]['sColumnCode']) {
						item = this.form.sSelectFieldName[i];
					}
				}
			}

			var checkedCount = value.length;
			if (checkedCount == 0) {
				item.checkAll = false;
				item.isIndeterminate = false;
			} else {
				item.checkAll = checkedCount === item.options.length;
				item.isIndeterminate = checkedCount > 0 && checkedCount < item.options.length;
			}
		},
		arrToString: function arrToString(arr) {
			try {
				return arr.join(',');
			} catch (e) {
				return arr;
			}
		},
		pinjiesql: function pinjiesql(duoyuarr) {
			var arr = [];
			var displayArr = [];
			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {

				for (var j = 0; j < this.form.sSelectFieldName[i]['value'].length; j++) {
					arr.push(this.form.sSelectFieldName[i]['sBie'] + '.' + this.form.sSelectFieldName[i]['value'][j] + ' as ' + this.form.sSelectFieldName[i]['sBie'] + '_' + this.form.sSelectFieldName[i]['value'][j]);
					displayArr.push(this.form.sSelectFieldName[i]['sBie'] + '_' + this.form.sSelectFieldName[i]['value'][j]);
				}
			}
			this.sql.ziduan = arr.join(',');

			var arrToyinhao = function arrToyinhao(arr) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};

			var arr = [];
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.form.sSelectFilter[i]['sBie'] + '.' + this.form.sSelectFilter[i]['sColumnCode'] + ' ' + this.form.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.form.sSelectFilter[i]['value']).join(',') + ')');
				} else {
					for (var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.form.sSelectFilter[i]['sBie'] + '.' + this.form.sSelectFilter[i]['sColumnCode'] + this.form.sSelectFilter[i]['fuhao'] + "N'" + this.form.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}
			arr = arr.concat(duoyuarr);
			this.sql.tiaojian = arr.join(' and ');

			var arr = [];
			arr.push(this.form.keys[0]['sSchema1Name'] + '.' + this.form.keys[0]['sSelect1Name'] + ' ' + this.form.keys[0]['sBie1']);

			for (var i = 0; i < this.form.keys.length; i++) {
				var _arr = [];
				for (var j = 0; j < this.form.keys[i]['selectKey'].length; j++) {
					_arr.push(this.form.keys[i]['sBie1'] + '.' + this.stringArr(this.form.keys[i]['selectKey'][j], 0) + '=' + this.form.keys[i]['sBie2'] + '.' + this.stringArr(this.form.keys[i]['selectKey'][j], 1));
				}

				arr.push(this.form.keys[i]['sSchema2Name'] + '.' + this.form.keys[i]['sSelect2Name'] + ' ' + this.form.keys[i]['sBie2'] + ' on ' + _arr.join(' and '));
			}
			this.sql.table = arr.join(' left join  ');
		},
		addDownLoad: function addDownLoad() {
			var _this8 = this;

			if (this.timer == 0) {
				this.$prompt('Enter file name', 'Tips', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					inputPattern: /\S/,
					inputErrorMessage: 'Enter file name'
				}).then(function (_ref2) {
					var value = _ref2.value;

					(0, _api.addDownloadExport)({
						sSchema: _this8.form.sSchema,
						sSelectName: _this8.sql.table,
						sSelectFieldName: _this8.sql.ziduan,
						sSelectFilter: _this8.sql.tiaojian,
						sFileName: value + '.csv',
						sContent: (0, _stringify2.default)(_this8.form),
						sFavorite: 0,
						nType: 2,
						sStatus: 0
					}).then(function (res) {
						_this8.timer = 60;
						var _this = _this8;
						var T = setInterval(function () {
							_this.timer--;
							if (_this.timer == 1) {
								clearInterval(T);
								setTimeout(function () {
									_this.timer = 0;
								}, 1000);
							}
						}, 1000);
					});
				}).catch(function () {});
			}
		}
	}
};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(313);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(311);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(111);

var _extends3 = _interopRequireDefault(_extends2);

var _api = __webpack_require__(12);

var _da = __webpack_require__(583);

var _da2 = _interopRequireDefault(_da);

var _debounce = __webpack_require__(307);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  directives: {
    loadmore: {
      inserted: function inserted(el, binding) {
        var dom = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
        dom.addEventListener("scroll", function () {
          var condition = this.scrollHeight.toFixed(0) - this.scrollTop.toFixed(0) <= this.clientHeight;

          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      addUserFlag: false,
      formData: {
        flag: false,
        tableHeaders: [],
        tableData: [],
        sSelectFieldName: ""
      },
      formItems: [],
      items: [],
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px"
      },
      cellStyle: {
        height: "55px"
      },
      isShowAllFormItems: false,
      defItems: [{
        link: "OP指标报告",
        db: "",
        tbl: "portal_target_download"
      }, {
        link: "销售水单",
        db: "销售水单",
        tbl: "Portal_Fact_SalesDetail_download"
      }],
      currentItem: "选择报表",
      activeIndex: "",
      dialogVisible: false,
      activeName: "first",
      sSchemaName: "business_data.dbo",
      form: {},

      options: [{
        id: 1,
        name: "竖版"
      }, {
        id: 2,
        name: "横版"
      }],
      filters: {
        pageSize: 10,
        currentPage: 1
      },
      total: 0,
      tableData3: [],
      tableDataVertical: [],
      tableDataCross: []
    };
  },

  computed: {},
  watch: {
    currentItem: function currentItem() {
      delete this.formData.flex;
      this.formItems = [];
      this.form = {};
      this.getFormItems();
    },
    watchedFormValue: function watchedFormValue(newVal, oldVal) {}
  },
  mounted: function mounted() {
    var _this2 = this;

    var today = new Date();
    var currentMonth = today.getMonth() + 1;
    (0, _api.getReport)({}).then(function (res1) {
      var data1 = res1.data;
      if (data1.length == 0) {
        return;
      }

      for (var i = 0; i < data1.length; i++) {
        _this2.items.push({
          link: data1[i]["report_name"],
          db: data1[i]["report_name"],
          tbl: data1[i]["tbl_name"]
        });
      }

      if (_this2.items.length > 0) {
        var reportID = _this2.$route.query.id;
        console.log(reportID, 'reportID');
        if (reportID) {
          if (reportID === 'DM_DE_DS_BMM') {
            _this2.clickItem(_this2.items[6].link, 6);
            _this2.handleSubmit();
          } else if (reportID === 'RM_CM_T1_Sellout') {
            _this2.clickItem(_this2.items[8].link, 8);
            _this2.handleSubmit();
          } else if (reportID === 'DM_DE_DS_BRM') {
            _this2.clickItem(_this2.items[7].link, 7);
            _this2.handleSubmit();
          } else if (reportID === 'DE_DS_KPI') {
            _this2.clickItem(_this2.items[4].link, 4);
            _this2.handleSubmit();
          } else if (reportID === 'DM_BMM_UL_KPI') {
            _this2.clickItem(_this2.items[5].link, 5);
            _this2.handleSubmit();
          } else if (reportID === 'Endcon_KPI') {
            _this2.clickItem(_this2.items[3].link, 3);
            _this2.handleSubmit();
          } else if (reportID === 'RM_T1_T2_KPI') {
            _this2.clickItem(_this2.items[9].link, 9);
            _this2.handleSubmit();
          } else if (reportID === 'BRM_KPI') {
            _this2.clickItem(_this2.items[0].link, 0);
            _this2.handleSubmit();
          } else {
            _this2.clickItem(_this2.items[0].link, 0);
            _this2.handleSubmit();
          }
        } else {
          _this2.clickItem(_this2.items[0].link, 0);
          _this2.handleSubmit();
        }
      }
    });
  },

  methods: {
    changeSelect: function changeSelect(check, options, form) {
      if (this.form[form].length === options.length) {
        this.formData[check] = true;
      } else {
        this.formData[check] = false;
      }
    },
    clickItem: function clickItem(link, index) {
      console.log(index, 'activeIndex');
      this.activeIndex = index;
    },
    fillOptionPermission: function fillOptionPermission(data, name, options) {
      var filterName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "row_name";
      var fieldName = arguments[4];
      var fieldValue = arguments[5];

      var filters = data.filter(function (item) {
        return item[filterName] === name && item["field_name"] == fieldName && item["field_value"] == fieldValue;
      });
      if (filters.length == 0) {
        return;
      }
      options.length = 0;
      filters.forEach(function (each) {
        var filter = options.filter(function (item) {
          return item.id === each["row_value"];
        });
        if (filter.length === 0) {
          options.push({
            id: each["row_value"],
            name: each["row_value"]
          });
        }
      });
    },
    getFormItems: function getFormItems() {
      var _this3 = this;

      var loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var _this = this;
      var formItems = {};
      delete _this.formData.flex;
      (0, _api.getFormItemsList)({
        reportName: this.items[this.activeIndex].link,
        tblName: this.items[this.activeIndex].tbl
      }).then(function (res) {
        var data = res.data.map(function (item) {
          return (0, _extends3.default)({}, item, {
            currentPage: 1,
            loading: false
          });
        });

        data.sort(function (obj1, obj2) {
          return obj1.sort - obj2.sort;
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var formItem = formItems[item["tbl_name"] + item["columnName"]];
            if (formItem) {
              continue;
            } else {
              formItem = {};
              formItem["columnNameFilter"] = item["columnNameFilter"];
              formItem["columnName"] = item["columnName"];
              formItem["isShow"] = item["isShow"];
              formItem["filterType"] = item["filterType"];
              formItem[formItem["columnName"] + "Multiple"] = true;

              _this[formItem["columnName"] + "Checked"] = false;
              formItem[formItem["columnName"] + "Options"] = [];

              formItems[item["tbl_name"] + item["columnName"]] = formItem;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this3.formData["flag"] = true;
        _this.$set(_this, "formItems", formItems);
        _this3.total = 0;
        _this3.formData['tableData'].Length = 0;
        _this3.formData['tableHeaders'].length = 0;
        loading.close();
        if (_this.formData["tbl"] === "portal_target_download") {
          _this.$set(_this.formData, "flex", 1);
        }
      });
    },
    getFormItemsOptionsList: function getFormItemsOptionsList(item) {
      var _this4 = this;

      var keywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var params = {
        reportName: this.items[this.activeIndex].link,
        tblName: this.items[this.activeIndex].tbl,
        columnName: item.columnName,
        keywords: keywords,
        currentPage: item.currentPage,
        pageSize: 20
      };
      this.loading = true;
      (0, _api.getOptionByPermission2)(params).then(function (res) {
        _this4.loading = false;
        var records = [];
        if (params.currentPage == 1) {
          records = res.data;
        } else {
          records = item[item["columnName"] + "Options"].concat(res.data);
        }
        item[item["columnName"] + "Options"] = records;
        _this4.changeSelect(item["columnName"] + "Checked", item[item["columnName"] + "Options"], item["columnName"]);
      }).catch(function () {
        _this4.loading = false;
      });
    },

    getList: function getList() {
      var _this5 = this;

      var table = this.formData["tbl"];
      if (this.formData["tbl"] === "portal_target_download") {
        table = "portal_target_cross_download";
        if (this.formData["flex"]) {
          if (this.formData.flex === 1) {
            table = "portal_target_cross_download";
          } else {
            table = "portal_target_vertical_download";
          }
        } else {}
      }
      var arr = [];
      for (var formKey in this.form) {
        if (this.form[formKey] instanceof Array) {
          if (this.form[formKey].length > 0) {
            arr = arr.concat(formKey + "  in  (" + this.form[formKey].map(function (item) {
              return "N'" + item + "'";
            }).join(",") + ")");
          }
        } else {
          if (this.form[formKey] !== "") {
            arr = arr.concat(formKey + "  in  (N'" + this.form[formKey] + "')");
          }
        }
      }

      var param = (0, _assign2.default)({
        sSelectName: table,
        sSelectFieldName: "*",
        reportName: this.items[this.activeIndex].link,
        extBody: 1,
        sSelectFilter: arr.join(" and "),
        sSchemaName: this.sSchemaName
      }, this.form, this.filters);

      var reportColumnsName = [];
      (0, _api.getReportColumns)({
        reportName: this.items[this.activeIndex].link,
        tblName: table
      }).then(function (res1) {

        if (res1.data.length > 0) {
          res1.data.forEach(function (item1) {
            reportColumnsName.push(item1.columnName + " as '" + item1.columnShowName + "' ");
          });
          param.sSelectFieldName = reportColumnsName.join(",");
        }

        _this5.formData['sSelectFieldName'] = param.sSelectFieldName;

        (0, _api.getDynamicSQL)(param).then(function (res) {
          _this5.total = res.page.totalCount * 1;


          _this5.$set(_this5.formData, "tableData", res.data);
          var headers = (0, _keys2.default)(res.data[0]).filter(function (key) {
            return key !== "__row_number__";
          });
          _this5.formData["tableHeaders"] = headers;
        });
      });
    },
    handleCancel: function handleCancel() {
      this.dialogVisible = false;
    },

    handleCheckAll: function handleCheckAll(check, options, form) {
      if (this.formData[check]) {
        this.form[form] = options.map(function (item) {
          return item.rowValue;
        });
      } else {
        this.form[form] = [];
      }
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.filters.currentPage = page;
      this.getList();
    },
    handleFoucus: function handleFoucus(e, item) {
      if (!item[item["columnName"] + "Options"] || !item[item["columnName"] + "Options"].length) {
        item.currentPage = 1;
        this.getFormItemsOptionsList(item);
      }
    },
    handleLoadmore: function handleLoadmore(e, item) {
      item.currentPage++;
      this.getFormItemsOptionsList(item);
    },
    handleSubmit: function handleSubmit() {
      this.isShowAllFormItems = false;
      this.dialogVisible = false;
      this.currentItem = this.items[this.activeIndex].link;
      this.formData["tbl"] = this.items[this.activeIndex].tbl;
      var ele = document.querySelector("._tabs");
      ele.style.display = "block";

      if (this.formData["tbl"] === "portal_target_download") {} else {
        delete this.formData.flex;
      }
    },

    reFlex: function reFlex() {
      this.filters.currentPage = 1;
      this.total = 0;
    },
    reGetList: function reGetList() {
      this.filters.currentPage = 1;
      this.getList();
    },
    remoteMethod: function remoteMethod(e, item) {
      var _this6 = this;

      (0, _debounce2.default)(function () {
        item.currentPage = 1;
        _this6.getFormItemsOptionsList(item, e);
      });
    },
    showDialog: function showDialog() {
      this.dialogVisible = true;
    },
    toData2: function toData2(val) {
      var _this7 = this;

      if (this.total === 0) {
        this.$confirm("先查询，再下载", "Tips", {
          type: "warning",
          customClass: 'customConfimClass'
        });
        return;
      }
      if (this.total > 1000000) {
        this.$confirm(this.total + "条记录，" + "为确保系统运行可支持下载条目数上限为一百万行，建议筛选“省份”信息后再进行下载", "Tips", {
          type: "warning",
          customClass: 'customConfimClass'
        });
        return;
      }

      var table = this.formData["tbl"];
      if (this.formData["tbl"] === "portal_target_download") {
        table = "portal_target_cross_download";
        if (this.formData["flex"]) {
          if (this.formData.flex === 1) {
            table = "portal_target_cross_download";
          } else {
            table = "portal_target_vertical_download";
          }
        }
      }
      var arr = [];
      for (var formKey in this.form) {
        if (this.form[formKey] instanceof Array) {
          if (this.form[formKey].length > 0) {
            arr = arr.concat(formKey + "  in  (" + this.form[formKey].map(function (item) {
              return "N'" + item + "'";
            }).join(",") + ")");
          }
        } else {
          if (this.form[formKey] !== "") {
            arr = arr.concat(formKey + "  in  (N'" + this.form[formKey] + "')");
          }
        }
      }

      var param = (0, _assign2.default)({
        sSelectName: this.sSchemaName + "." + table,
        sSelectFieldName: this.formData['sSelectFieldName'],
        sSelectFilter: arr.join(" and "),
        sSchemaName: this.sSchemaName,
        reportName: this.items[this.activeIndex].link,
        sFileName: table + "_" + new Date().getTime() + ".csv",
        sFavorite: 0,
        extBody: 1,
        nType: 1
      }, this.form);
      (0, _api.addDownloadExport)(param).then(function (res) {
        _this7.$message("download success！");
      });
    }
  }
};

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(12);

var _util = __webpack_require__(83);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			step: 0,
			form: {
				sName: '',
				sSchema: '',
				sSchemaName: '',
				sSelectName: '',
				nSelectId: '',
				sSelectFilter: [],
				sSelectFieldName: []
			},
			dialogVisible: false,
			checkAll: false,
			isIndeterminate: true,
			activeName: 'first',
			options: [],
			options2: [],
			options3: [],
			options4: [{
				id: 'in',
				name: '='
			}, {
				id: '>',
				name: '>'
			}, {
				id: '>=',
				name: '>='
			}, {
				id: '<',
				name: '<'
			}, {
				id: '<=',
				name: '<='
			}, {
				id: 'not in',
				name: '!='
			}],
			options5: [],
			index: 0,
			loading: false,
			tableData: [],
			showListFlag: false,
			count: 0,
			sql: {
				table: '',
				ziduan: '',
				tiaojian: ''
			},
			favortFlag: false,
			timer: 0
		};
	},
	mounted: function mounted() {
		var _this2 = this;

		(0, _api.getDatabaseInfoList)({
			currentPage: 1,
			pageSize: 9999
		}).then(function (res) {
			_this2.options = res.data;
		});
	},

	methods: {
		timeFormatter: function timeFormatter(row, column) {
			var shuju = row[column.property];
			try {
				if (shuju.indexOf('T') > -1) {
					var times = new Date(shuju);
					if (times == 'Invalid Date') {
						return shuju;
					}
					return _util2.default.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
				} else {
					return shuju;
				}
			} catch (e) {
				return shuju;
			}
		},
		arrToString: function arrToString(arr) {
			try {
				return arr.join(',');
			} catch (e) {
				return arr;
			}
		},
		addList: function addList(item) {
			item.push({
				sColumnCode: '',
				sColumnName: '',
				fuhao: '',
				options: [],
				value: [],
				type: ''
			});
		},
		deleteList: function deleteList(item, index) {
			item.splice(index, 1);
		},
		querySearchAsync: function querySearchAsync(queryString) {
			var _this3 = this;

			this.options5 = [];
			var index = 0;
			try {
				var node = window.getSelection().focusNode.parentElement;
				index = node.getAttribute('data-id');
			} catch (e) {}
			if (!this.form.sSelectFilter[index]['sColumnCode']) {
				this.$message.error('Please select the Condition Code');
				return;
			}
			if (queryString != '') {
				this.loading = true;
				(0, _api.selectColumnValueBynSelectId)({
					nSelectId: this.form.nSelectId,
					sColumnCode: this.form.sSelectFilter[index]['sColumnCode']
				}).then(function (res) {
					if (res.data.length === 0) {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this3.form.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this3.form.sSchemaName,
							sSelectName: _this3.form.sSelectName,
							pageSize: 9999
						}).then(function (res) {
							var arr = [];
							for (var i = 0; i < res.data.length; i++) {
								arr.push(res.data[i][_this3.form.sSelectFilter[index]['sColumnCode']]);
							}
							_this3.loading = false;
							_this3.form.sSelectFilter[index].options = arr;
						});
					} else {
						(0, _api.getDynamicColumnList)({
							currentPage: 1,
							sColumnCode: _this3.form.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: _this3.form.sSchemaName,
							sSelectName: _this3.form.sSelectName,
							pageSize: 9999
						}).then(function (res2) {
							var arr = [];
							for (var i = 0, len = res.data.length; i < len; i++) {
								for (var j = 0, len2 = res2.data.length; j < len2; j++) {
									if (res.data[i]['sColumnValue'] == res2.data[j][_this3.form.sSelectFilter[index]['sColumnCode']]) {
										arr.push(res.data[i]['sColumnValue']);
									}
								}
							}
							_this3.loading = false;
							_this3.form.sSelectFilter[index].options = arr;
						});
					}
				});
			}
		},
		change2: function change2(item) {
			for (var i = 0; i < this.options3.length; i++) {
				if (this.options3[i]['sColumnCode'] == item.sColumnCode) {
					item.type = this.options3[i]['sColumnType'];
					item.sColumnName = this.options3[i]['sColumnName'];
				}
			}
			if (item.sColumnCode == '') {
				item.fuhao = '';
				item.value = [];
				item.options = [];
			}
		},
		change1: function change1() {
			var _this4 = this;

			(0, _api.getSelectList)({
				currentPage: 1,
				nSelectType: 1,
				sSchema: this.form.sSchema,
				pageSize: 9999
			}).then(function (res) {
				_this4.options2 = res.data;
			});
		},
		step1: function step1() {
			this.step = 0;
		},
		step2: function step2() {
			var _this5 = this;

			for (var i = 0; i < this.options2.length; i++) {
				if (this.options2[i]['nSelectId'] == this.form.nSelectId) {
					this.form.sName = this.options2[i]['sName'];
					this.form.sSelectName = this.options2[i]['sSelectName'];
					this.form.sSchemaName = this.options2[i]['sSchemaName'];
				}
			}
			if (!this.form.nSelectId) {
				this.$message.error('Please select the Table');
				return;
			}
			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: this.form.nSelectId,
				pageSize: 9999
			}).then(function (res) {
				_this5.options3 = res.data;
				if (_this5.form.sSelectFilter.length == 0) {
					_this5.form.sSelectFilter = [{
						sColumnCode: '',
						sColumnName: '',
						fuhao: '',
						options: [],
						value: [],
						type: ''
					}];
				}
				_this5.step = 2;
			});
		},
		step3: function step3() {
			if (this.form.sSelectFilter.length == 1) {
				if (!this.form.sSelectFilter[0]['sColumnCode'] && !this.form.sSelectFilter[0]['fuhao'] && this.form.sSelectFilter[0]['value'].length == 0) {
					this.form.sSelectFilter.splice(0, 1);
					this.step = 4;
					return;
				}
			}
			var flag = false;
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (!this.form.sSelectFilter[i]['sColumnCode']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (!this.form.sSelectFilter[i]['fuhao']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (this.form.sSelectFilter[i]['value'].length == 0) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
			}
			if (flag == true) {
				return;
			} else {
				this.step = 4;
			}
		},
		toData2: function toData2() {
			var _this6 = this;

			if (this.form.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}
			this.$prompt('Enter file name', 'Tips', {
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				inputPattern: /\S/,
				inputErrorMessage: 'Enter file name'
			}).then(function (_ref) {
				var value = _ref.value;

				(0, _api.selectExColumnValueBynSelectId)({
					nSelectId: _this6.form.nSelectId
				}).then(function (res) {
					var arr = [];
					res.data.forEach(function (one) {
						arr.push(_this6.form.sSchemaName + '.' + _this6.form.sSelectName + '.' + one.sColumnCode + ' in(' + one.sColumnValue + ')');
					});
					_this6.pinjiesql(arr);
					(0, _api.addDownloadExport)({
						sSchema: _this6.form.sSchema,
						sSelectName: _this6.sql.table,
						sSelectFieldName: _this6.sql.ziduan,
						sSelectFilter: _this6.sql.tiaojian,
						sFileName: value + '.csv',
						sContent: (0, _stringify2.default)(_this6.form),
						sFavorite: 0,
						nType: 1
					}).then(function (res) {
						_this6.$message('download success！');
					});
				});
			}).catch(function () {});
		},
		pinjiesql: function pinjiesql(duoyuarr) {
			this.sql.table = this.form.sSchemaName + '.' + this.form.sSelectName;
			var arr = [];
			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.form.sSelectFieldName[i]);
			}
			this.sql.ziduan = arr.join(',');
			var arr = [];

			var arrToyinhao = function arrToyinhao(arr, type) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};

			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.sql.table + '.' + this.form.sSelectFilter[i]['sColumnCode'] + ' ' + this.form.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.form.sSelectFilter[i]['value'], this.form.sSelectFilter[i]['type']).join(',') + ')');
				} else {
					for (var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.sql.table + '.' + this.form.sSelectFilter[i]['sColumnCode'] + this.form.sSelectFilter[i]['fuhao'] + "N'" + this.form.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}
			arr = arr.concat(duoyuarr);
			this.sql.tiaojian = arr.join(' and ');
		},
		toData: function toData() {
			var _this7 = this;

			if (this.form.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}
			this.sql.table = this.form.sSchemaName + '.' + this.form.sSelectName;
			var arr = [];

			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.form.sSelectFieldName[i]);
			}

			this.sql.ziduan = arr.join(',');
			var arr = [];

			var arrToyinhao = function arrToyinhao(arr, type) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};

			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(this.sql.table + '.' + this.form.sSelectFilter[i]['sColumnCode'] + ' ' + this.form.sSelectFilter[i]['fuhao'] + '(' + arrToyinhao(this.form.sSelectFilter[i]['value'], this.form.sSelectFilter[i]['type']).join(',') + ')');
				} else {
					for (var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
						arr.push(this.sql.table + '.' + this.form.sSelectFilter[i]['sColumnCode'] + this.form.sSelectFilter[i]['fuhao'] + "N'" + this.form.sSelectFilter[i]['value'][j] + "'");
					}
				}
			}
			this.sql.tiaojian = arr.join(' and ');
			var loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			(0, _api.getDynamicSQL)({
				sSelectName: this.sql.table,
				sSelectFieldName: this.sql.ziduan,
				sSelectFilter: this.sql.tiaojian,
				sSchemaName: this.form.sSchemaName,
				currentPage: 1,
				pageSize: 100
			}).then(function (res) {
				loading.close();
				_this7.count = res.page.totalCount * 1;
				_this7.tableData = res.data;
				_this7.favortFlag = false;
				_this7.timer = 0;
				_this7.dialogVisible = true;
			}).catch(function (res) {
				loading.close();
			});
		},
		handleCheckAllChange: function handleCheckAllChange(flag) {
			if (flag == true) {
				var arr = [];
				for (var i = 0; i < this.options3.length; i++) {
					arr.push(this.options3[i]['sColumnCode']);
				}
				this.form.sSelectFieldName = arr;
			} else {
				this.form.sSelectFieldName = [];
			}
			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
			var checkedCount = value.length;
			this.checkAll = checkedCount === this.options3.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.options3.length;
		},
		addDownLoad: function addDownLoad() {
			var _this8 = this;

			if (this.timer == 0) {
				this.$prompt('Enter file name', 'Tips', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					inputPattern: /\S/,
					inputErrorMessage: 'Enter file name'
				}).then(function (_ref2) {
					var value = _ref2.value;

					(0, _api.addDownloadExport)({
						sSchema: _this8.form.sSchema,
						sSelectName: _this8.sql.table,
						sSelectFieldName: _this8.sql.ziduan,
						sSelectFilter: _this8.sql.tiaojian,
						sFileName: value + '.csv',
						sContent: (0, _stringify2.default)(_this8.form),
						sFavorite: 0,
						nType: 1,
						sStatus: 0
					}).then(function (res) {
						_this8.timer = 60;
						var _this = _this8;
						var T = setInterval(function () {
							_this.timer--;
							if (_this.timer == 1) {
								clearInterval(T);
								setTimeout(function () {
									_this.timer = 0;
								}, 1000);
							}
						}, 1000);
					});
				}).catch(function () {});
			}
		}
	}
};

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(12);

var _util = __webpack_require__(83);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			activeName: 'first',
			step: 0,
			options0: [],
			options: [],
			options2: [],
			options3: [],
			options4: [],
			allCheck: true,
			form: {
				nSelectId: '',
				sName: '',
				sSchemaName: '',
				sSelectName: '',
				sSelectFilter: [],
				sSelectFieldName: []
			},
			loading: false,
			tableData: [],
			showListFlag: false,
			dialogVisible: false,
			count: 0,
			sql: {
				table: '',
				ziduan: '',
				tiaojian: ''
			},
			favortFlag: false,
			timer: 0
		};
	},
	mounted: function mounted() {
		var _this = this;

		(0, _api.getDatabaseInfoList)({
			currentPage: 1,
			pageSize: 9999
		}).then(function (res) {
			_this.options0 = res.data;
		});
		(0, _api.getSelectList)({
			currentPage: 1,
			nSelectType: 2,
			pageSize: 9999
		}).then(function (res) {
			_this.options = res.data;
		});
	},

	methods: {
		timeFormatter: function timeFormatter(row, column) {
			var shuju = row[column.property];
			try {
				if (shuju.indexOf('T') > -1) {
					var times = new Date(shuju);
					if (times == "Invalid Date") {
						return shuju;
					}
					return _util2.default.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
				} else {
					return shuju;
				}
			} catch (e) {
				return shuju;
			}
		},
		addDownLoad: function addDownLoad() {
			var _this2 = this;

			if (this.timer == 0) {
				this.$prompt('Enter file name', 'Tips', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					inputPattern: /\S/,
					inputErrorMessage: 'Enter file name'
				}).then(function (_ref) {
					var value = _ref.value;

					(0, _api.addDownloadExport)({
						sSelectName: _this2.sql.table,
						sSelectFieldName: _this2.sql.ziduan,
						sSelectFilter: _this2.sql.tiaojian,
						sFileName: value + '.csv',
						sContent: (0, _stringify2.default)(_this2.form),
						sFavorite: 0,
						nType: 3,
						sStatus: 0
					}).then(function (res) {
						_this2.$message('download success！');
					});
				}).catch(function () {});
			}
		},
		toData: function toData() {
			this.sql.table = this.form.sSchemaName + '.' + this.form.sSelectName;
			var arr = [];
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['sRequired'] == 0) {
					if (this.form.sSelectFilter[i]['value'].length == 0) {
						arr.push("N'" + this.form.sSelectFilter[i]['options'].join(',') + "'");
					} else {
						arr.push("N'" + this.form.sSelectFilter[i]['value'].join(',') + "'");
					}
				} else {
					arr.push("N'" + this.form.sSelectFilter[i]['value'].join(',') + "'");
				}
			}
			this.sql.tiaojian = arr.join(',');
			this.addDownLoad();
		},
		toSetp3: function toSetp3() {
			this.step = 2;
		},
		toSetp2: function toSetp2() {
			var flag = false;
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['sRequired'] == 1) {
					if (this.form.sSelectFilter[i]['value'].length == 0) {
						this.$message.error('Please select the Value');
						flag = true;
						return;
					}
				} else {
					if (this.form.sSelectFilter[i]['value'].length == 0) {
						this.form.sSelectFilter[i]['value'] = this.form.sSelectFilter[i]['options'];
					}
				}
			}
			if (flag == true) {
				return;
			} else {
				this.step = 4;
			}
		},
		toSetp1: function toSetp1() {
			this.step = 0;
		},
		arrToString: function arrToString(arr) {
			try {
				return arr.join(',');
			} catch (e) {
				return arr;
			}
		},
		getNext: function getNext() {
			var _this3 = this;

			for (var i = 0; i < this.options.length; i++) {
				if (this.options[i]['nSelectId'] == this.form.nSelectId) {
					this.form.sName = this.options[i]['sName'];
					this.form.sSelectName = this.options[i]['sSelectName'];
					this.form.sSchemaName = this.options[i]['sSchemaName'];
				}
			}
			if (!this.form.nSelectId) {
				this.$message.error('Please select the Stored Procedure');
				return;
			}
			(0, _api.getSelectColumnList)({
				currentPage: 1,
				nSelectId: this.form.nSelectId,
				pageSize: 9999
			}).then(function (res) {
				_this3.form.sSelectFieldName = res.data;
				_this3.options3 = res.data;
				(0, _api.selectPSpConditionList)({
					currentPage: 1,
					nSelectId: _this3.form.nSelectId,
					pageSize: 9999
				}).then(function (res) {
					res.data.sort(function (a, b) {
						return a.nSequence - b.nSequence;
					});
					var i = 0;
					var that = _this3;
					var queyOne = function queyOne() {
						console.log(i);
						res.data[i].value = [];
						res.data[i]['options'] = [];
						if (res.data[i]['sParameterType'] == 'datetime') {
							i++;
							if (i == res.data.length) {
								that.form.sSelectFilter = res.data;
								that.step = 2;
							} else {
								queyOne();
							}
						} else {
							(0, _api.selectDynamicSP)({
								currentPage: 1,
								paraName: res.data[i]['sParameterCode'],
								paraValue: '',
								sSchemaName: that.form.sSchemaName,
								spName: that.form.sSelectName,
								pageSize: 9999
							}).then(function (back) {
								var arr = [];
								for (var j = 0; j < back.data.length; j++) {
									arr.push(back.data[j]['Para_value']);
								}
								res.data[i]['options'] = arr;
								i++;
								if (i == res.data.length) {
									that.form.sSelectFilter = res.data;
									that.step = 2;
								} else {
									queyOne();
								}
							});
						}
					};
					queyOne();
				});
			});
		}
	}
};

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(240);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(239);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _from = __webpack_require__(238);

var _from2 = _interopRequireDefault(_from);

var generateCodeChallenge = function () {
	var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(codeVerifier) {
		var encoder, data, hashBuffer, hashArray, base64;
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						encoder = new TextEncoder();
						data = encoder.encode(codeVerifier);
						_context.next = 4;
						return window.crypto.subtle.digest('SHA-256', data);

					case 4:
						hashBuffer = _context.sent;
						hashArray = (0, _from2.default)(new Uint8Array(hashBuffer));
						base64 = btoa(String.fromCharCode.apply(null, hashArray)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
						return _context.abrupt('return', base64);

					case 8:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function generateCodeChallenge(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _babelPolyfill = __webpack_require__(237);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(244);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(165);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(243);

var _vueRouter = __webpack_require__(245);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(236);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(166);

var _vuex2 = _interopRequireDefault(_vuex);

var _en = __webpack_require__(241);

var _en2 = _interopRequireDefault(_en);

var _routes = __webpack_require__(164);

__webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default, {
	locale: _en2.default
});
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

Date.prototype.Format = function (fmt) {
	var o = {
		"M+": this.getMonth() + 1,
		"d+": this.getDate(),
		"h+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"q+": Math.floor((this.getMonth() + 3) / 3),
		"S": this.getMilliseconds() };
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	}return fmt;
};

function generateCodeVerifier() {
	var array = new Uint32Array(43);
	window.crypto.getRandomValues(array);
	return (0, _from2.default)(array, function (dec) {
		return ('0' + dec.toString(16)).slice(-2);
	}).join('');
}

var router = new _vueRouter2.default({
	mode: 'history',
	routes: _routes.rolesRouters.concat(_routes.defaultRouter)
});

router.beforeEach(function () {
	var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(to, from, next) {
		var token, codeVerifier, codeChallenge, sso;
		return _regenerator2.default.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						token = sessionStorage.getItem('token');

						if (!(!token && to.path != '/login_t' && to.path != '/sso')) {
							_context2.next = 16;
							break;
						}

						if (to.query.id) {
							sessionStorage.setItem('id', to.query.id);
						}

						if (true) {
							_context2.next = 7;
							break;
						}

						return _context2.abrupt('return', next({ path: '/login_t' }));

					case 7:
						codeVerifier = generateCodeVerifier();
						_context2.next = 10;
						return generateCodeChallenge(codeVerifier);

					case 10:
						codeChallenge = _context2.sent;

						sessionStorage.setItem('codeVerifier', codeVerifier);
						sessionStorage.setItem('codeChallenge', codeChallenge);
						sso = 'https://federation.corpnet4.com/as/authorization.oauth2?client_id=1ebc8f5353994ce5ad356e844972b67d&response_type=code&code_challenge=' + codeChallenge + '&code_challenge_method=S256';

						window.location.href = sso;
						return _context2.abrupt('return');

					case 16:
						if (!(token && to.name === 'login')) {
							_context2.next = 18;
							break;
						}

						return _context2.abrupt('return', next({ path: '/select' }));

					case 18:

						next();

					case 19:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, undefined);
	}));

	return function (_x2, _x3, _x4) {
		return _ref2.apply(this, arguments);
	};
}());

new _vue2.default({
	router: router,
	store: _store2.default,
	render: function render(h) {
		return h(_App2.default);
	}
}).$mount('#app');

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var timeout = null;

function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (timeout !== null) clearTimeout(timeout);

  if (immediate) {
    var callNow = !timeout;
    timeout = setTimeout(function () {
      timeout = null;
    }, wait);
    if (callNow) typeof func === 'function' && func();
  } else {
    timeout = setTimeout(function () {
      typeof func === 'function' && func();
    }, wait);
  }
}

exports.default = debounce;

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAsCAYAAAAXb/p7AAAAAXNSR0IArs4c6QAAA9dJREFUWEflmUvIVVUUx39/JRWKUlHMRCRRJ5GGDsyEb6KWSKgpKBVUhOIgUdAsjUgdFJZJRQ8aGg2UiHw7CNNK8TFRsiJR7KGgFaVmD9LU5Vmyr2zvd8495557j3zQnlwu+7F+e+211l57HZnZCmA5XaMtlfRqjCJLCLsG23WKiZI+q/3rioCbJU3LA7wCnANuqUi7l4HbgW4p6++VNL4R4GLgE+A3oGcFgG5SDtgHmAGsqZOxQ9KkLMAlkl6vACpzSTNbArwWDcgE/A/oK+mvmwx4K3AG6BHkZgK6zQ2U9O9NBuwFnAZ65wGeBwZL8t8bmpl1DwbtzlOmuTNckeS2V7+2O8vJ4DTel6nBRoCbgdEupAxd2NxBSVOrAjwKDC8JV5t2TNKIqgD3Afe3CLhf0riqAN2I72wR8GdJA6sC9Fg1FLhUEtJvpCOS3qwEsCRUoWlm1roXF5JUclBbAM1sFnA3cKEkh9/pP0j6qJIjNrNTfsuUhKtNOy3prqoA9wNjWwQ8IKlTqGrXEX+VpGAjWwQ8LGnU/1aDA9qQvF6Q9EuKBu8I2Xut65Akv/evtfhNkpkstHi0Daeb2W3AAcB/ve2R9HhTgAXTLUkqe9NkbqKQBs0sL92SnwbwtKRPi2g8bJq0HDGeXxSwaLr1qKT1eYBmNifZ0Mow7mtJk7PmFAUsmm49ImljAcAfgSHRuPskeSjr1IoCFk23npD0YSNAM3sHeKZuzHHgAUm/1s8tCpiXbrn9+bvjXUnf1oSY2QTgH8DDy73JW3t+4qUTMzbgL7s3gC/Cnd9P0vZCgHlHltZvZp5cfB/6/LHum2i2vVAJYIhth4BhzRKVOuJmhZhZX8AzoKzSyXvABuBPYEryWnypJS9uFtDHhyP+LgXyKUkfxGuamT+m3Pbqi1XLKjniyEneSsoaCyKY1JQrbMiLSIuisSckDakacCbwcST0RUkvZziVH/W2qG+TpOlVA3pYeTsSuiYpTj2bAfgksDbq2y2pIwZse/HIzL4B7omE/g4MktTpbWNme4DrhUs3Y2BEDHgxlN/+LuMUdUbvJTUPunNT1vLUarakn4Lt+bPT64PzUsbuqq9RPydpdRsAByeZzYkG67gytgYtdSQ3UP8iYaY2plYCPgt42a3ZG+Ccp1Bm9kpyZS1rcbOHs6r8XmbzDNsBm2m+mQclefbjsfBLwE3GA7KXTsbkLOZ18c+DZj3bWVjFZ4gJifftzPDU6SHspG38fcA/5PwRz60CsEPS7ixNmdnDiSa31PWvk/RY2hwHfB5Y1cw55ox9KC/tTwk/vdJCj8u5Cs38VAkUIGv7AAAAAElFTkSuQmCC"

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAACXBIWXMAABYlAAAWJQFJUiTwAAABx0lEQVQ4jZ3Uu2sUURTH8c/ETYJogswaxWbxAb4KQbAQX/gHCHba2FlaClaWWilWFmJlJViJItgIIYVdMKJFtAgINpGYC64RojEbiznrDsNOssmBYe5877m/Oefce24mOYH72I81m7chfMVNuZlMMoULWxCq2ie5Yw3sCvAOT/Ab2wYQ6GAYV3EOzQIns5I1ye4txZWMxvpFaGA7yH0vOe3BiP41zbCKebk1rAQf6QquhsiY3M+YnMTxdeJawL5YuyNYh2KH+tnedcRgom6iUcNb8bP6lPPIbEDBQxij76IhLGNmM4IfanjPkmG5v4MKvsQRRXpdK4+/6ZWjy8frBXOXN4yw59uWzOJXvWByQ3EsOqUI7sm1K34TaMp7R6wu5Yd92BtMVdg0WuV61gk+wAFFnbJ4f4moTikO83XF8YL3kttYyCRzOIjxUqf0t+QKnlXoH9F21HdKnS2KFsNHxR3awotgKyRzcVvsHEgyeRr+F0usGWxp6H+UuaUBxEZxNL7OlGZOx7vTIISSs3JvN5C8hpMxvhtZLeNWsLFM8hmHA0yGQ/XGzvAKz/FYscvnKz7TmCd5JGlHDdZ7XlfSvyT5EWvvdPE/V7eL3RpvVoYAAAAASUVORK5CYII="

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABEZJREFUWEfFmVuoVkUUx3/HUpEEX5S8lIna5WiheAkRzN4UTZ8yKxFv1UMKXrKLeLdQ8lZKClLow8ELCkKJoqBCdiCwMqzEO1pWgvZiinL0lM7/MBv2mW/m23v298m3XvestX57zdoza61dR7w8B0wCRgNDMtQHAL8AK4EFgbU3gB3AZuC3kL26CE45nQW8FaHzEfAp8DfQLYfeF8B881JN7to8oG2AdcCcHI7cJXIq3atA15z6F4A3gR/S67NABwPbgWdzOnGX6eU2AL8DPSNtvAR8l+iUA9VbCbKc3Ae+BQ4DSo0JzuIQ6B3ga+BFoHcZB/2A03oeAp1mIrC1jIErJue2AA3AH3bdDOCrnKD/AY9a/x8AK8wH187jT7n9FNDsA1VUdgcgm4HFwHrgrrNmEfBxTlAtqwfO2PWK6kGzg097/Orl33ZBdfS0hNojx4HJJtHPBZ7HgsrX2ZStx4CfA7D1aVB93ZeBJz0g+4DxGflaKajM62T4y6SCWNLSkAbVds71wByyh3sGJ9UAlQ8daWscZ00JqI6fJF/Sa3RTvJBFaJ/HgnYC/g3YVnq1ytcEdD8wxqPUw94qeVhjQeXvoufkuQWsNYF7Pe1UoPripODK+1YhD6TWxIKWs3sPaOuCLgOWOlr/AF3yEpbZ+tnAxsgr1OtWET0P9HWexkYzFNF5wGemkPkTUBoVFoHqGnRF0VRUY8S39QttibcJeDfGmLvWB6q7++UCRn2gS+xtpevxE1MRjTV53zHS9m1grw9UObs80lho698xW/5lAVslKj7Q14A9BYz7InoUOGJvGqWYovN/hG0VLjeBRh/ocOD7CGPJUh9oATN+FR/o86auPFXAQ7m+qIC51io+0IHAyQKWZwLqeR6KVHPr9TWfCJRpFcNX82MSTAdTY75hq3JV8TEfTvIy0htkWudX02/nA9V5pyq+lqKWvNWx5gNV56cOsJZyzBxrI7IiquePmyvvWo1IOwPXXd+KqHok9S9p+RBYXSNQX4V/QaDqHHVYp0XRVFRrIYqmopqW5QLVBEOTDFeKlHqVvpgvmrLZJ2lFdrqlv/UY04pUCtnddqCunQOquhLQXsAlj6eY5q5S0F8BXd+utPT/6Xb5c0Ctgytq/F6plCJDX1OSUZ416g7UJZTMnjRTesKj0BL+hwT7DTDOY1ss2umW280d6YT6e63VSGdKoP8v8g7P2EmzRps+Sc+mvNO8ieZc3RVQVvGrL1NVkjskywur4Oic1lX9SECppHivZOwoWL1QMnbMAtUxqCHbVE/Xm9adboqaba6xagxyGwHdzbrhBK3WQdLebK22V8PYYcDIMvPYhEs/MfTjoUSyRuP666FhrXvFZkUv9rnGj4L8KaSYBSo9NVirbG7GAuRZr2PxvazaNQ9o4myohVWiV0M0SVae52p7YkATuP4mH3Uy6OxTfxUjP9oRuH5i+MacQVsPAM0K3gsFHd5dAAAAAElFTkSuQmCC"

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABJNJREFUWEfFmVnIVVUUx3//siIKekksbZBGNUNpIoKstyKrp7JSpLmHCjSzLJo0xWhQKyyIpB4+LCkIKoyCCkwhaKQybDCaC8yXBgpLW511O0fOt7997tn7u1fuerxnDb+zzt5r77WuyBQzmwTMAc4FTmkxnybpYzNbDtzeoPsr8AzwuKTNTf6Uymlm04AbgWtSbYDbJN1vZj8BhybYrQYWStoR6raCmtlewApgfkKgUMWDrjCzn4FDEu23ArMlvVvX7wpqZicDa4HjE4OEavMlPWJm3wJHZPqYIWljZdMIamazS8hu/g3YALwO+NK4OFBuAv0LeBE4DTiqS4Apkrb48yhokYEriww81cXB98WaewIYkvSd65nZ1cCaRNBdksaYmce/FbgX2DcSz9f2kZJ2jgA1M8/Kcw2QO4G7gJWS/q7rmNmdwNJEUFebLOmz8iU9q68WX/DYSNw1kq4dBlqWnk6qI/IOMFfSF7GHowCdJOnzypeZHQB82AA7eTdoubu/AQ6PgLws6cKuizU/o8NAy8x6ZfixWApeaeoyVAddCdwUgXlNkhf3rtJrRmuZXQg8GATb0QE1My8/nfUSyGZJJ7ZBlj5y1+hBkn5rWEa+vIat1wp0PXBexGiCJN95rTKKjHq8ryKV5w/goSJxl9aDysx8x7lBKLdIcoMkGQVoN7//APuEoIuLr39PYLVd0tgkwlKpAXSepEczj9BoWM/ol8AxwdOsbHZZowskrTKzH4AJOS8e6jqoH4OhjJW0PcdxQ0bvkLTczB4Drs/xlwK6QdLZuU4bQO+WtLS4j/rxuAyYWWyUAzN9/wm8EMvoYklLMp15iYuVp+skPZnrK6YfA50l6flc5w2gbwJvlCeNLzHPzr8ZvscAvwObYqBnSHo7w1lHtQE0102jfgx0qqRPcyO09EW57kbox0CnS/oo17OZ3QB4z7NHpJ+f3nfzBw3XtJ7h+7aZynW6P3CZ38qLC/auzI1TvYzbnQRcVH+7GOgySX6LH5gUJ5m35MPKWgx0o6QZA6P8v4K8VZS1M9sy6s/HSdo2CFgzOxj4JYztGfUeycc0dVkk6YEBgcZu+Fsd1DtHP/7qsk3SuAGBejY9q3VZ4qA+wfBJRijZV71eX8zMYtl0t0dXrciz4dW/DJrcivQBcnzZgYauXinmUDMr0InA15Fgyc1dH0A/AaZG/HTa6nq7/DAwL6K4XtL5vYJ0szczn5KcE9FZVXSqC/z3cFLiM6XDIgad9O8JWDN7Cbgg4ttZJkrqXAtD0Kb+3nV9pHN5NS/qFdrMjisnzT7ajMnu2dQIUP+hqKuXFHV1XYOxX359Z64Oh2Sp4OUEb1HZmuzdYDfi8t7L2NGvdOuqsWMbaFkG5wJXRLreuvlVkp4O/fVjkLsJ8LPZTziflXrr4LJf8Wn9804pRoqnA2c1zWNrUHMk+R8PI6RtNO7/egxFjti2BOY+9/GjQ77fZJjyZ4M3WPeVazMXIEXfy+LN1e4eNWhlaGanlrCzUqIn6PgY3TdlUtvTmtEwoJmdUKxHrwxe+6YnANVV3itH4Gtzy9x/VIwA54D2TdQAAAAASUVORK5CYII="

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAeCAYAAAA2Lt7lAAAAAXNSR0IArs4c6QAAAqNJREFUSEvtlstLVHEUxz/nXqdx0oE0X6VJMCmGgW4q6bUKSbRFgYsWSfYQEvprAhdBELYUKigxpFWRWG0yCsQHhPmcMRNGG6fx3pP35sVxnBmn/fy29/x+38fve87vyv1VSmKbVIpNkyh+gelEgvH+Gn7yH6trlsM+Hw0KIRXiajAWKGBJ7i5z0rY4pgYtohxUYUotPgSjTDysI54LxoNJ/NEg9WJyVpQTKvwWm1HD5Id0R7ghUI/SClQILABD2Lx8XMXXXADuLHIKg6tAm8IRIIwwrDAh3WG6RWlU6BSh1jlQ4J0Kz9RguHiF6UxKHOZrpYTEplWU6woXnf2qzAgMqPBNboe5oEKDoXR5BUAUGBN4hc1gJiXbzNsVOoAmIOgRtIV+UcalZ56yTZNqhDagPanQEhhJpyQN83OA6REDBlGGCizmpFMxyyME4jbH1eQyyjXgfPKGVCX3Fmi0TTpSmFvAe4TnYvHGb/A9Uk5Mki8xg2Rn41uFFyKMGKC24jB2iFzKRmTbrh2ILNKXUb4AU261QQh1PS8DMlq5B8CDyqAkBqxu1xwCArmEYZdFHkAaJaeBwpSe2BD4tF+c0wKkKnHStXUHzV4MHeYCn920ZIlxRovSKLnipks5434TPjpp2Rovr7M14i6Am4sUBQ2kr5x1BE2241aY5i072gVa3E6FUYXBJxWuip2lSG+EoqiNPq1i3QVw+iAwxyFfISEsfHYBM2ulzA8ITjzd1RumOA51tlDthkiZ88NkXwVrXo1zTvEKR41NajFJJDaYjlWzmvM07VQOMOt2K9RgDQh/kq3MT9O070J+mnoPSH6apsxIID9Nkz3J+h54hTlP071uO/9Y+69cpmmmU3IC6FF8sSVKDPn3Y2Ur0UAlvx4Jif3o/QUs9wYQXVKmbwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAAAXNSR0IArs4c6QAAA3lJREFUaEPtmE2IHFUQx//VvdOvXrsIQchB8OIn6mLU+P0BgoHcQoToKQcxIEnIKUTwYky8eBARBb0pioKgEOJJ8BSJyYrGZCVGIQZyMTc36uLQ7/Wyr5wXe5aZntl1+k3P7go9MKeu+tev/1NTXa8J/9MPTYp7enp68+Li4nMAIqXUJwsLC1frrDURcKXULUR0GsDmAvZ359xTeZ5fqAt+IuDM/BmAZ3shieiLLMt2bmhwrfWPInJPCfKCMWZmo4PPiciWXkgRmbPW3rehwZVSPxDR/SXws9barQ14XQ706jSOr+LqRMZh43jj+Ij/5KZVmlZpWmVEB5pWGdGoZqpMslWUUndMTU3pdrs9162jlDrbOfH07d4ics5au7zqpmn64NLS0p/W2l9H/CH7wsbaVZj5PQD7CsVZ59yePM9/UUqdI6J7hx0kkiS5M47jT7sHDRF5y1p7sCp8MDgz7wbwcalg2zn3QBRFr5XPnAA+d84djqLoDIDrSnnPG2M+qgIfDK6UOkZEz5SLicgfRDQP4NbStUsicgMRbRqSc9xaO6C12o0Eg2utD4nIG1VcWimWiA5lWfZmFa1gcP+ih5lPAHiySsEhsbPGGK+xVEVnHHBfx8N/A+DRKkV7Yj30EwBc1fxxwa/VK+Afr1j8VAFdMe3f8FrAC/hTAB4bkeK0MabqjdY3x0uQVDj/X/Ae2reHjHiTQ8Nqc7xQ9/De+ZV63ve0d3os6IFWYeYX/RtWEfnOWvtVqCMFfNn5sdqDmf3k2SYi89bad7qOt5j5SwBPd2FF5IC19t1AeNJaHxeRHT6/8wL0mLV2V6jTSqn9RNTLcvIa+AqPbzHGXA/g70B4JElyl8/N8/znUA0AKTP/BWCqV6ML/jqAl8viInJ76PY2BmhfapIkM1EUnS/rdcH9UvTKkGI3G2Mu1wURopOm6VbnnF/MBschMx/p9N+rGxG81WptieN4edfvMq7qOBHdlGXZbyFO1ZWTJMndURT9tJLjRzv7wuHyRWPMNIB2XRAhOmma3uicuzIUXGt9UESGrZUfxnH8dp7nYz8wQqB9ThzHewH472CPa60fEZHZUPH1yFt+5DPzRQC3rQdEQM2Ly+Ba64dF5NsAkTVPiaLoob4li5lfAPD+mpNUK7jHGPPBwHZYOO+nzPZqehOP/r4z4V4yxnztK/0D/pCbFJ+yw/EAAAAASUVORK5CYII="

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAAAXNSR0IArs4c6QAAAvZJREFUaEPtmE+oVVUUxn9f6KCSQAQHgRM1JZNMTc1UEAyciYE5ciAFoeJInuDE/DNxECEGNSsSBUEhbCQ0MtKnmD6NegXPwEnNshJ0aF9nPc+9nHfeue/dc+65vfvgbLiTe/de67e/u/baay8xS4f6xW17IbAbeA44L+mvOn31Bdz2EmAYCPgYfwJbJY3WBd8v8IvAeznIbyTtHHTwH4HXc5CjklYOOvg9YFUO8p6k1YMOfgdYk4MckbS2Aa9Lgawd243inYTtVzpsFG8U7+YwN4dzCpWaw9nk8W4OEdCEShMq/1eo2F4OPJ+8bqIGHx+2R4B87X1XUrvUtb0O+EfS/S5ZJ0zrKcaTB/HnwP7U4g3gA0m/2r4LvFH0kLD9KnAh89A4LelQWfjK4Lb3AOdyDp8AbyYv+5MFb85LwEfAbeDF3Lq9ks6Wge8F/Gvg3QJnfwMPk5bE0txvvwELgPkFay5LKrLVcS+9gA8lyn1cRqUp5g5J+qSMrV7Ao9FzFdhSxmHB3DgbWyQ9LWOnMniaPQL+GrCxjNPM3IDeLOnfsut7As+kv4DfVNL5dUmbS65pT68FPFX/OvB2lyDDksputL48nrVkO0QI5aeDj55ihIe73GThtNoUT1UPe6F8p5iPmN7UK3T4mgBu+8O0w3pL0rdVFbFdFDY9hYftyF7vxB0h6dNxcNtzgSvAtgzsQUmfVYFPw+YysCNdH5fVrqpK2z4AZFm+b4EXXd8Rgy9JelwFPhVkxfjfKv3Sg40XgEfAnKyNFvgp4EiB8WVVq7eqoPl1tqM1/VP++xZ4FEVHC5wtlvSgLogqdmxHhzcKs8np0PbxJNSPDSh49NnbtX6LcTrFF0n6vYpSda2x/VpysH/upPiJtFbO/z5PUtTYMzZsvwz80Qk8XiBFZeVXSf18JjLmjJHDPp59CmP8LSButVkz2jen7THglVlCPpYF3wDcnCXg6/O1yvvAFwMOH52ELydVh7ZD+cgy2wdsAz8AhyV9F1z/AebcM+W1NPxbAAAAAElFTkSuQmCC"

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAsCAYAAAAjFjtnAAAAAXNSR0IArs4c6QAAAyBJREFUaEPtmUuoTXscxz/fgWdCXuXeZIABEdcjuXnUpbzquiJSB0ODWygpAwNFUe7kGulMDO5VBleEwkB5XW6c41FeUwZMEEoeydf6n/Y+rbOtvddae2/bOtz/bO/1+//35/N/r9+W7RHAf8A4ele5DyyU7QA/u3exd9N2BgH3Uvgu7CSBS8DLgkoNAebF2ZIEfpD0pIgCtkcDj9MEpkm6XVCBqcCtNIHpkm4WVOAn4Mb/AnlHx3Y/YBDwPkPdPsA7Sa8rY21/nRGw/TuwD3ibQSDIXpa0rEgCO4HdGeDLIXckTSmSwLZoCv2RQ+BfSXOLJLA3mj47Ci1gezgwR9KphJ77BVgDfAQeAj9H2+GvNYRaPwK2wwETDpr1kv6u1du2L1ZeCSriWytg+zywIAaRKGF7DNABjEqZTq0TSIAvs22Q9Ff5g+2xwHVgZAL8K2Bw7PvWCNSAL7O0STps+0cgXE+S4NdFYsuBtpYKZIAv84TdZyMwMaHnN0lqt30GWNwygRzwtab6FkkHQoDta8CsWHCHpPjnrkdNuUrYvgDMTyBrBw5Fu8s5YGDKIu2GL4GFhT0jVqcz2o5nNv0gqwF/IrqCryjBTAOuAAOqSGyV9Gf8me3JQHjb+gCEy9xTSQ+aKpAFPrbjVJP4DD7H6Vz/FKpx8JyUlHii2g6H2tXYSDQEX9casD0eCKdqUtqlKnxsJILEWeCgpF15ejspNvcitr0WOJLQWPecT4OyPVTSi7S4LM9zC5SGbTMQX3SZ4bNA5YmpS6BC4pykRXl+tJmxdQuUJMI2eUbSu2ZC5WmrIYE8P/SlYr8bgeGSnn+pXmykXdvDgGfxNpJyo9uj1797QEhvFKmEtTcJ2J8mUCToVJYwAm+ipFP/1MiCBgSBaqdtQZF7YG1UaY/fEF1lQ/ZsQm+gBu4CeyQd6RIol9I+G/5ECCXkcIpUAmtf4FE8/d9DoEi0WVm+fQHb4V214bt81h6tiNslqbNW3dQRsL0K+KdOgEarrY7S7EcbFVgSvZGdbpSkzvpLJYWcUdWSZQR+i5K2x+oEaLTaSknHazXyCRMK+fIprSmBAAAAAElFTkSuQmCC"

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABuElEQVRIia3UP4hTQRAG8N/zElDEIg9EQbzCf42FCIqgjSA2NopgLVhZCqIIB4KVnNgf2Agq2CgcWguCoK2lClHkVLS4ERUUcmeeRTaXl1ySy8V8ze58u/PN7OzOZsJ+PMA+bDA5/MTdTHiHvRMU7kImNFDFDbyYoPZ9bCP8EArhyATFCW+EooJmonaM6DiFaa37KkorGRbkGsmuQmWM3HK8H7B2EK/LxDivJktj0Wdtld5oAcKccClZi9iKC1jq2fm313XtEoWbuJjmdbmnwhJmpDpjeZDW8BOEK7hWYp4Il/EBe/AJ50viVT0YHCDM4FayHuFlmt9GDX9wVO4evuELfvfKlI81VRKfxdVkzcudS/xbrS/lFw7LLQgV7EQht9wv0++p0U4l+2GyC+F5z97twjPh0MCTd/bW243WRrvhptP4Su54l1PuK06sKV5C+Q62JJFjWhd7cj1Cg1ApBfm4wuZmJ6DdaAfYlIjTQi1xhU7HrhftDq+hmQl17PqPTIciSy9iDru1nmpzuMtIqCDwuEOFjWKlXOOjpbO5ba6ucziAs2PKf5a7Uyb6fVBncH3MAIt0B/gHh51wDWgdTI0AAAAASUVORK5CYII="

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAeCAYAAAA2Lt7lAAAAAXNSR0IArs4c6QAAAqtJREFUSEvtls1LVGEUxn/njtM46YCan2kS+IFRpJtK7GMVklhQgYsWSVYICf01gYsiCFsKuUgxpFWSWG0SEkQbCFPTGTNhrHEa7z3NvY41Dt6ZiZb57i7v+57zPOc853mvkMPqVbzRFYoNIWAft5SIv4JvD4V4tuuS7YC93xeiMAYNllBtfxvKog/m+svZyHY/pwS3QrQIdAq02gEVJhVGnpTz/p8S3J/Dt1FCnVhcQrmGctoJKLxFGFKDF4VrBB80EHNLlJHBnWVOYNAJdCq0wHYPgIjgoB/BYuRxJR/+KkEK8nZRrifKcQrITwuymSjbOxWeqcGYG5M9GewgV7gMNCeRR4H1ZJIiwG8zAaYEht2Y7EqwB/I2wAOsIkxhEUwmqEc4CZQCpsCEG5NdCVyQm8CrBJMhQ5iwQFRpS/TgKnAhCcCViXQpnrIw/pjFUfVw0VELnE2/aJgMP6pi2maQAchrW11i8tJn8ClcRlR6lyjd8lCN0GGrJaXmrtQzlNJh4qhLGc0zWZTbIc6p0GQo3Qrnd2SYrXkZmCAwbgkDosxIT4geUY4rdIlQuz1HjGeTn31uDyYOQFXmBQZVmJaeMDcEGlHagXKBL8AoFs8zDVDqTCR7cgXoUKhK2FcIYUxhVu6ucswyOZIY+1ZRDqrwUU3eBCLMplpAl3KABUeyUIM5KPzcSWIziQRoFA9nRKlX4UfCXiYND58dFfkXKfLmU4eJ18pjfqOEpUHBlqezcnFTO07hGoeNLWrxEI9vEoxWs/57Dm4uUxAwkP4yviO2Yf5ZObupIn1hCiIW+rSS78l+uhvuvpu6lmjfTVMHdN9NnZ+CtKf1f3VTd0PZfhdc3fTeOsXRLSrEolkUn0AwHmdmoIavmYKm73UvcMjrpUmhToWYGkz581j5Be6YABCggJPNAAAAAElFTkSuQmCC"

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAXCAYAAAD3CERpAAAACXBIWXMAABYlAAAWJQFJUiTwAAACZ0lEQVRIiZ3VS2hWRxQH8F9iEN/ChxJQpC4UxVfrQqiKuItg8QG6UHBTcWs3tohCF25E3AR0b7EFUVAqPtCFKNhKDBE0aoQaEdGk2lYP1KpYicZFJsn1897vNXCZOXP+//OfM/fMTJN6WliH1ZiLyXiLXlzHCSUf6opXRWy5cF0YrPD1CptqCddUg+A2/JKZ+QOX8BjT0YYlGf8eJQdqTihHsC2Tyd/CxgLcauFOBru9UcEW4f8UpF+YXgOnIyM8owjWXCHEDoxN4zVK/qlhqW14k8Y/1oAva6E7rfhEnbz9ifdKaMmDVMp0cepP1yXKmdRPxJTaRMMEYY3Ryn5Wp2gPBtJ4vTCtWDS0CocMHYWLNSzsrDA/R3QAg2n8E54IR4WF5UEWCS8KDn1bjmhn8v0pyrYwTBHeF8T6BpqESejD1ETbhQ78hxY8UPIqE/R3rMzI9GKpktfJ38xIVuOxAAcZOXKLCPvSKt4JX+dsVzaLCwUZ3K7Cmyn8m7DHCTeS8XMV4pEqd+/5KvzdCfc4uxW/VSAcxLfJOoMLaXyZkXO8VjhWQfZ06mc242kyZhUIfo8fktWtZIOhGoC3SrbgXLK3Cu0FosOPwkupnAeFPmFMjugc4S9hIBUd4Wri3MvgnifMsoLF9yTOFcKXmf/SKXyVQ2gV5mXsSwl/KzP3hTAnhztb+DWjsX7YsbOsKHqEm+m5OpwT6HPRUd9e4W6Gn43bXg7eLDzMqcoXdYpey4nxXPhuGDL6CpScFE5hFVZgXPLc/yxw5bafkf/6Dl3o+OSCaaiFrpTBo0bolZ62Su2poWuyvxHyR3t0XI4+olDMAAAAAElFTkSuQmCC"

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.b0bfb71.png";

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(8)(
  /* script */
  null,
  /* template */
  __webpack_require__(681),
  /* scopeId */
  "data-v-d3c4bfe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(8)(
  /* script */
  null,
  /* template */
  __webpack_require__(680),
  /* scopeId */
  "data-v-d3a890e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(678),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(665),
  /* scopeId */
  "data-v-1eeb859f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(8)(
  /* script */
  null,
  /* template */
  __webpack_require__(669),
  /* scopeId */
  "data-v-55a484b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(667),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(677),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  "data-v-07d1be54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(676),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(662),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  "data-v-106868e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(674),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(584)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  "data-v-03514a1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(670),
  /* scopeId */
  "data-v-5a8b0e01",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(675),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(679),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(668),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(671),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(666),
  /* scopeId */
  "data-v-31bd2c16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(673),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(672),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 659:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item')], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "border-radius": "20px 20px 0 0",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "header-cell-style": _vm.headerStyle,
      "cell-style": _vm.cellStyle
    },
    on: {
      "row-click": _vm.toDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sTemplateName",
      "label": "Template  Name",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "align": "center",
      "label": "Create Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sName",
      "align": "center",
      "label": "Create User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTableName",
      "align": "center",
      "label": "Table Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.sSchema) + "." + _vm._s(scope.row.sTableName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nUploadCnt",
      "label": "Uploads",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "View Template",
      "visible": _vm.detailViewFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailViewFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "sTemplateName"
    }
  }, [_vm._v(_vm._s(_vm.form.sTemplateName))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema",
      "prop": "sSchemaName"
    }
  }, [_vm._v(_vm._s(_vm.form.sSchema))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name",
      "prop": "sTemplateName"
    }
  }, [_vm._v(_vm._s(_vm.form.sTableName))]), _vm._v(" "), _vm._l((_vm.form.ziduanList), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "sSchemaName"
      }
    }, [_c('label', [_vm._v(_vm._s(item.sFieldName))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v("\n              " + _vm._s(item.sFieldType) + "\n              "), (item.sLen) ? _c('label', [_vm._v("(" + _vm._s(item.sLen) + ")")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.nPrimaryKey == 1) ? _c('label', [_vm._v("Primary Key")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.toConvit1(item.sIfnull, _vm.options3)))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.sIfnull == 1) ? [_c('label', [_vm._v(_vm._s(_vm.toConvit3(item.sIfcheckValue, _vm.options4)))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.sIfcheckValue == 1) ? _c('label', [_vm._v(_vm._s(_vm.toConvit2(item.sValueRange, _vm.options5)))]) : _c('label', [_vm._v(_vm._s(item.sValueRange))])] : _vm._e()], 2)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.doDownLoad
    }
  }, [_vm._v("Download Template")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailViewFlag = false;
        _vm.addTemplateFlag = true;
        _vm.detail.nTemplateId = _vm.form.nTemplateId;
      }
    }
  }, [_vm._v("\n            Upload Data\n          ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Upload Setting",
      "visible": _vm.addTemplateFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTemplateFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.detail,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File Name",
      "prop": "sFileName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "readonly": "",
      "disabled": "",
      "placeholder": "Please select file"
    },
    model: {
      value: (_vm.detail.sFileName),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sFileName", $$v)
      },
      expression: "detail.sFileName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "upload-button"
  }, [_vm._v("\n                Select\n                "), _c('input', {
    attrs: {
      "id": "files",
      "type": "file"
    },
    on: {
      "change": _vm.changeFile
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "File Format",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.detail.sFileFormat),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sFileFormat", $$v)
      },
      expression: "detail.sFileFormat"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.detail.sFileFormat == 'csv') ? _c('el-form-item', {
    attrs: {
      "label": "Delimiters",
      "prop": "sSchemaName"
    }
  }, [_vm._l((_vm.options2), function(item) {
    return _c('el-radio', {
      key: item.id,
      attrs: {
        "label": item.id
      },
      model: {
        value: (_vm.detail.sRadio),
        callback: function($$v) {
          _vm.$set(_vm.detail, "sRadio", $$v)
        },
        expression: "detail.sRadio"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), (_vm.detail.sRadio == 5) ? _c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.detail.sDelimiters),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sDelimiters", $$v)
      },
      expression: "detail.sDelimiters"
    }
  }) : _vm._e()], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTemplateFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Confirm")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Template",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addTemplateFlag = true
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.toDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sTemplateName",
      "label": "Template  Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Create Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sName",
      "label": "Create User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTableName",
      "label": "Table Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.sSchema) + "." + _vm._s(scope.row.sTableName) + "\n\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nUploadCnt",
      "label": "Uploads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Template",
      "visible": _vm.addTemplateFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTemplateFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File Name",
      "prop": "sFileName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "readonly": "",
      "disabled": "",
      "placeholder": "Please select .csv"
    },
    model: {
      value: (_vm.form.sFileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sFileName", $$v)
      },
      expression: "form.sFileName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "upload-button"
  }, [_vm._v("\n\t\t\t\t\t\t\tSelect\n\t\t\t\t\t\t\t"), _c('input', {
    attrs: {
      "id": "files",
      "type": "file"
    },
    on: {
      "change": _vm.changeFile
    }
  })])], 1), _vm._v(" "), (_vm.form.sFileName) ? _c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "sTemplateName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sTemplateName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sTemplateName", $$v)
      },
      expression: "form.sTemplateName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.sFileName) ? _c('el-form-item', {
    attrs: {
      "label": "Schema",
      "prop": "sSchema"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchema", $$v)
      },
      expression: "form.sSchema"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.sFileName) ? _c('el-form-item', {
    attrs: {
      "label": "Table Name",
      "prop": "sTableName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sTableName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sTableName", $$v)
      },
      expression: "form.sTableName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.ziduanList), function(item, index) {
    return (_vm.form.sFileName && item.sFieldName !== 'LOAD_DT') ? _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "sColumnName"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "disabled": "",
        "readonly": "",
        "placeholder": ""
      },
      model: {
        value: (item.sFieldName),
        callback: function($$v) {
          _vm.$set(item, "sFieldName", $$v)
        },
        expression: "item.sFieldName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.changeSelect(item)
        }
      },
      model: {
        value: (item.sFieldType),
        callback: function($$v) {
          _vm.$set(item, "sFieldType", $$v)
        },
        expression: "item.sFieldType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (item.sFieldType == 'nvarchar' || item.sFieldType == 'decimal') ? _c('el-input', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "placeholder": "length"
      },
      model: {
        value: (item.sLen),
        callback: function($$v) {
          _vm.$set(item, "sLen", $$v)
        },
        expression: "item.sLen"
      }
    }) : _vm._e(), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.sIfnull),
        callback: function($$v) {
          _vm.$set(item, "sIfnull", $$v)
        },
        expression: "item.sIfnull"
      }
    }, _vm._l((_vm.options3), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (item.sIfnull == 1) ? [(item.typeF == 0) ? _c('el-button', {
      on: {
        "click": function($event) {
          item.typeF = 1
        }
      }
    }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (item.typeF == 1) ? [_c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.sIfcheckValue),
        callback: function($$v) {
          _vm.$set(item, "sIfcheckValue", $$v)
        },
        expression: "item.sIfcheckValue"
      }
    }, _vm._l((_vm.options4), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (item.sIfcheckValue == 1) ? _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.sValueRange),
        callback: function($$v) {
          _vm.$set(item, "sValueRange", $$v)
        },
        expression: "item.sValueRange"
      }
    }, _vm._l((_vm.options5), function(item) {
      return _c('el-option', {
        key: item.nId,
        attrs: {
          "label": item.sRuleName,
          "value": item.nId
        }
      })
    }), 1) : _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sValueRange),
        callback: function($$v) {
          _vm.$set(item, "sValueRange", $$v)
        },
        expression: "item.sValueRange"
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          item.typeF = 0;
          item.sIfcheckValue = '0';
          item.sValueRange = '';
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t")])] : _vm._e()] : _vm._e()], 2) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTemplateFlag = false;
        _vm.resetFrom();
      }
    }
  }, [_vm._v("\n\t\t\t\t\tCancel\n\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTemplate0
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "View Template",
      "visible": _vm.detailViewFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailViewFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "sTemplateName"
    }
  }, [_vm._v(_vm._s(_vm.detailForm.sTemplateName))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema",
      "prop": "sSchemaName"
    }
  }, [_vm._v(_vm._s(_vm.detailForm.sSchema))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name",
      "prop": "sTemplateName"
    }
  }, [_vm._v(_vm._s(_vm.detailForm.sTableName))]), _vm._v(" "), _vm._l((_vm.detailForm.ziduanList), function(item, index) {
    return (item.sFieldName !== 'LOAD_DT') ? _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "sSchemaName"
      }
    }, [_c('label', [_vm._v(_vm._s(item.sFieldName))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.sFieldType) + "\n\t\t\t\t\t\t"), (item.sLen) ? _c('label', [_vm._v("(" + _vm._s(item.sLen) + ")")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.nPrimaryKey == 1) ? _c('label', [_vm._v("Primary Key")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.toConvit1(item.sIfnull, _vm.options3)))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.sIfnull == 1) ? [_c('label', [_vm._v(_vm._s(_vm.toConvit3(item.sIfcheckValue, _vm.options4)))]), _vm._v(" "), _c('label', [_vm._v("   ")]), _vm._v(" "), (item.sIfcheckValue == 1) ? _c('label', [_vm._v(_vm._s(_vm.toConvit2(item.sValueRange, _vm.options5)))]) : _c('label', [_vm._v(_vm._s(item.sValueRange))])] : _vm._e()], 2) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailViewFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailViewFlag = false;
        _vm.EditTemplateFlag = true;
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEdit\n\t\t\t\t")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Template",
      "visible": _vm.EditTemplateFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.EditTemplateFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "sTemplateName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.detailForm.sTemplateName),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sTemplateName", $$v)
      },
      expression: "detailForm.sTemplateName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema",
      "prop": "sSchema"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.detailForm.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sSchema", $$v)
      },
      expression: "detailForm.sSchema"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name",
      "prop": "sTableName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.detailForm.sTableName),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sTableName", $$v)
      },
      expression: "detailForm.sTableName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.detailForm.ziduanList), function(item, index) {
    return (item.isDelete == 0 && item.sFieldName !== 'LOAD_DT') ? _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "sColumnName"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sFieldName),
        callback: function($$v) {
          _vm.$set(item, "sFieldName", $$v)
        },
        expression: "item.sFieldName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "disabled": item.nPrimaryKey,
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.changeSelect(item)
        }
      },
      model: {
        value: (item.sFieldType),
        callback: function($$v) {
          _vm.$set(item, "sFieldType", $$v)
        },
        expression: "item.sFieldType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (item.sFieldType == 'nvarchar' || item.sFieldType == 'decimal') ? _c('el-input', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "disabled": item.nPrimaryKey,
        "placeholder": "length"
      },
      model: {
        value: (item.sLen),
        callback: function($$v) {
          _vm.$set(item, "sLen", $$v)
        },
        expression: "item.sLen"
      }
    }) : _vm._e(), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.sIfnull),
        callback: function($$v) {
          _vm.$set(item, "sIfnull", $$v)
        },
        expression: "item.sIfnull"
      }
    }, _vm._l((_vm.options3), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (item.sIfnull == 1) ? [(item.typeF == 0) ? _c('el-button', {
      on: {
        "click": function($event) {
          item.typeF = 1
        }
      }
    }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (item.typeF == 1) ? [_c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.sIfcheckValue),
        callback: function($$v) {
          _vm.$set(item, "sIfcheckValue", $$v)
        },
        expression: "item.sIfcheckValue"
      }
    }, _vm._l((_vm.options4), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (item.sIfcheckValue == 1) ? _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.sValueRange),
        callback: function($$v) {
          _vm.$set(item, "sValueRange", $$v)
        },
        expression: "item.sValueRange"
      }
    }, _vm._l((_vm.options5), function(item) {
      return _c('el-option', {
        key: item.nId,
        attrs: {
          "label": item.sRuleName,
          "value": item.nId
        }
      })
    }), 1) : _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sValueRange),
        callback: function($$v) {
          _vm.$set(item, "sValueRange", $$v)
        },
        expression: "item.sValueRange"
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          item.typeF = 0;
          item.sIfcheckValue = '0';
          item.sValueRange = '';
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t")])] : _vm._e()] : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "disabled": item.nPrimaryKey
      },
      on: {
        "click": function($event) {
          return _vm.deleteOne(index)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), (index == 0) ? _c('el-button', {
      on: {
        "click": function($event) {
          return _vm.addOne(index)
        }
      }
    }, [_vm._v("Add")]) : _vm._e()], 2) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.EditTemplateFlag = false;
        _vm.resetFrom();
      }
    }
  }, [_vm._v("\n\t\t\t\t\tCancel\n\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateTemplate
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "View Log",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Log Type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.nType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "nType", $$v)
      },
      expression: "filters.nType"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.reGetList()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSearch\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sName",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Log Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nType",
      "label": "Log Type",
      "formatter": _vm.nType
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sObjectName",
      "label": "Object Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sBehaviorName",
      "label": "Behaviour_Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Check Rule",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAdd()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.toDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sRuleName",
      "label": "Rule Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sSchema",
      "label": "Schema"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTableName",
      "label": "Table"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sFieldName",
      "label": "Column"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Check Rule",
      "visible": _vm.addTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rule Name.",
      "prop": "sRuleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sRuleName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sRuleName", $$v)
      },
      expression: "form.sRuleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchema", $$v)
      },
      expression: "form.sSchema"
    }
  }, _vm._l((_vm.tableData1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name.",
      "prop": "sTableName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sTableName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sTableName", $$v)
      },
      expression: "form.sTableName"
    }
  }, _vm._l((_vm.tableData2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sName,
        "value": item.sSelectName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Column Name.",
      "prop": "sFieldName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sFieldName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sFieldName", $$v)
      },
      expression: "form.sFieldName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc.",
      "prop": "sDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "sDesc", $$v)
      },
      expression: "form.sDesc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTable
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "View Check Rule",
      "visible": _vm.viewTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rule Name.",
      "prop": "sRuleName"
    }
  }, [_vm._v(_vm._s(_vm.form.sRuleName))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_vm._v(_vm._s(_vm.form.sSchema))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name.",
      "prop": "sTableName"
    }
  }, [_vm._v(_vm._s(_vm.form.sTableName))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Column Name.",
      "prop": "sFieldName"
    }
  }, [_vm._v(_vm._s(_vm.form.sFieldName))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc.",
      "prop": "sDesc"
    }
  }, [_vm._v(_vm._s(_vm.form.sDesc))])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toEdit
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toDelete
    }
  }, [_vm._v("Delete")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Check Rule",
      "visible": _vm.editTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.editTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Rule Name.",
      "prop": "sRuleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sRuleName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sRuleName", $$v)
      },
      expression: "form.sRuleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchema", $$v)
      },
      expression: "form.sSchema"
    }
  }, _vm._l((_vm.tableData1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Table Name.",
      "prop": "sTableName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sTableName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sTableName", $$v)
      },
      expression: "form.sTableName"
    }
  }, _vm._l((_vm.tableData2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sName,
        "value": item.sSelectName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Column Name.",
      "prop": "sFieldName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sFieldName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sFieldName", $$v)
      },
      expression: "form.sFieldName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Desc.",
      "prop": "sDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "sDesc", $$v)
      },
      expression: "form.sDesc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEditTable
    }
  }, [_vm._v("Confirm")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Sign in to the  Portal")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Domain Account"
    },
    model: {
      value: (_vm.ruleForm.username),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "username", $$v)
      },
      expression: "ruleForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password*"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit($event)
      }
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("Sign in")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-select', {
    staticClass: "select-report",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "popper-class": "report-popper",
      "placeholder": "请选择报表"
    },
    on: {
      "change": _vm.handleSubmit
    },
    model: {
      value: (_vm.activeIndex),
      callback: function($$v) {
        _vm.activeIndex = $$v
      },
      expression: "activeIndex"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.link,
        "value": index
      }
    })
  }), 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-wrapper",
    attrs: {
      "title": "报告选择",
      "width": "25%",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleCancel
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        active: _vm.activeIndex === index, item: true
      },
      on: {
        "click": function($event) {
          return _vm.clickItem(item.link, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.link) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.handleCancel()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-tabs', {
    staticClass: "_tabs",
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "searchBox"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.form,
      "label-position": "left",
      "label-width": "100px",
      "align": "left"
    }
  }, [_vm._l((_vm.formItems), function(item, index) {
    return _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isShow == '1'),
        expression: "item.isShow == '1'"
      }],
      key: index + 'form1',
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "label": item['columnNameFilter']
      }
    }, [(!item[item['columnName'] + 'Multiple']) ? _c('el-select', {
      directives: [{
        name: "loadmore",
        rawName: "v-loadmore",
        value: (function (e) { return _vm.handleLoadmore(e, item); }),
        expression: "(e) => handleLoadmore(e, item)"
      }],
      attrs: {
        "remote": "",
        "size": "small",
        "collapse-tags": "",
        "placeholder": "Select",
        "filterable": "",
        "remote-method": function (e) { return _vm.remoteMethod(e, item); },
        "multiple": item['filterType'] == 'M'
      },
      on: {
        "focus": function($event) {
          return _vm.handleFoucus($event, item)
        }
      },
      model: {
        value: (_vm.form[item['columnName']]),
        callback: function($$v) {
          _vm.$set(_vm.form, item['columnName'], $$v)
        },
        expression: "form[item['columnName']]"
      }
    }, _vm._l((item[item['columnName'] + 'Options']), function(itemOp) {
      return _c('el-option', {
        key: itemOp.rowValue,
        attrs: {
          "label": itemOp.rowValue,
          "value": itemOp.rowValue
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), (item[item['columnName'] + 'Multiple']) ? _c('el-select', {
      directives: [{
        name: "loadmore",
        rawName: "v-loadmore",
        value: (function (e) { return _vm.handleLoadmore(e, item); }),
        expression: "(e) => handleLoadmore(e, item)"
      }],
      attrs: {
        "remote": "",
        "size": "small",
        "collapse-tags": "",
        "placeholder": "Select",
        "filterable": "",
        "remote-method": function (e) { return _vm.remoteMethod(e, item); },
        "reserve-keyword": "",
        "multiple": item['filterType'] == 'M'
      },
      on: {
        "change": function($event) {
          return _vm.changeSelect(
            item['columnName'] + 'Checked',
            item[item['columnName'] + 'Options'],
            item['columnName']
          )
        },
        "focus": function($event) {
          return _vm.handleFoucus($event, item)
        }
      },
      model: {
        value: (_vm.form[item['columnName']]),
        callback: function($$v) {
          _vm.$set(_vm.form, item['columnName'], $$v)
        },
        expression: "form[item['columnName']]"
      }
    }, [_c('el-checkbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item['filterType'] == 'M'),
        expression: "item['filterType']=='M'"
      }],
      on: {
        "change": function($event) {
          return _vm.handleCheckAll(
            item['columnName'] + 'Checked',
            item[item['columnName'] + 'Options'],
            item['columnName']
          )
        }
      },
      model: {
        value: (_vm.formData[item['columnName'] + 'Checked']),
        callback: function($$v) {
          _vm.$set(_vm.formData, item['columnName'] + 'Checked', $$v)
        },
        expression: "formData[item['columnName'] + 'Checked']"
      }
    }, [_vm._v("全选")]), _vm._v(" "), _vm._l((item[item['columnName'] + 'Options']), function(itemOp) {
      return _c('el-option', {
        key: itemOp.rowValue,
        attrs: {
          "label": itemOp.rowValue,
          "value": itemOp.rowValue
        }
      })
    })], 2) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.formItems), function(item, index) {
    return _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isShow == '0' && _vm.isShowAllFormItems),
        expression: "item.isShow == '0' && isShowAllFormItems"
      }],
      key: index + 'form2',
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "label": item['columnNameFilter']
      }
    }, [(!item[item['columnName'] + 'Multiple']) ? _c('el-select', {
      directives: [{
        name: "loadmore",
        rawName: "v-loadmore",
        value: (function (e) { return _vm.handleLoadmore(e, item); }),
        expression: "(e) => handleLoadmore(e, item)"
      }],
      attrs: {
        "remote": "",
        "size": "small",
        "collapse-tags": "",
        "placeholder": "Select",
        "filterable": "",
        "remote-method": function (e) { return _vm.remoteMethod(e, item); },
        "multiple": item['filterType'] == 'M'
      },
      on: {
        "focus": function($event) {
          return _vm.handleFoucus($event, item)
        }
      },
      model: {
        value: (_vm.form[item['columnName']]),
        callback: function($$v) {
          _vm.$set(_vm.form, item['columnName'], $$v)
        },
        expression: "form[item['columnName']]"
      }
    }, _vm._l((item[item['columnName'] + 'Options']), function(itemOp) {
      return _c('el-option', {
        key: itemOp.rowValue,
        attrs: {
          "label": itemOp.rowValue,
          "value": itemOp.rowValue
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), (item[item['columnName'] + 'Multiple']) ? _c('el-select', {
      directives: [{
        name: "loadmore",
        rawName: "v-loadmore",
        value: (function (e) { return _vm.handleLoadmore(e, item); }),
        expression: "(e) => handleLoadmore(e, item)"
      }],
      attrs: {
        "remote": "",
        "size": "small",
        "collapse-tags": "",
        "placeholder": "Select",
        "filterable": "",
        "remote-method": function (e) { return _vm.remoteMethod(e, item); },
        "reserve-keyword": "",
        "multiple": item['filterType'] == 'M'
      },
      on: {
        "change": function($event) {
          return _vm.changeSelect(
            item['columnName'] + 'Checked',
            item[item['columnName'] + 'Options'],
            item['columnName']
          )
        },
        "focus": function($event) {
          return _vm.handleFoucus($event, item)
        }
      },
      model: {
        value: (_vm.form[item['columnName']]),
        callback: function($$v) {
          _vm.$set(_vm.form, item['columnName'], $$v)
        },
        expression: "form[item['columnName']]"
      }
    }, [_c('el-checkbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item['filterType'] == 'M'),
        expression: "item['filterType']=='M'"
      }],
      on: {
        "change": function($event) {
          return _vm.handleCheckAll(
            item['columnName'] + 'Checked',
            item[item['columnName'] + 'Options'],
            item['columnName']
          )
        }
      },
      model: {
        value: (_vm.formData[item['columnName'] + 'Checked']),
        callback: function($$v) {
          _vm.$set(_vm.formData, item['columnName'] + 'Checked', $$v)
        },
        expression: "formData[item['columnName'] + 'Checked']"
      }
    }, [_vm._v("全选")]), _vm._v(" "), _vm._l((item[item['columnName'] + 'Options']), function(itemOp) {
      return _c('el-option', {
        key: itemOp.rowValue,
        attrs: {
          "label": itemOp.rowValue,
          "value": itemOp.rowValue
        }
      })
    })], 2) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.formData['tbl'] === 'portal_target_download') ? _c('el-form-item', [_c('el-radio-group', {
    model: {
      value: (_vm.formData['flex']),
      callback: function($$v) {
        _vm.$set(_vm.formData, 'flex', $$v)
      },
      expression: "formData['flex']"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    on: {
      "change": _vm.reFlex
    }
  }, [_vm._v("竖版")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    on: {
      "change": _vm.reFlex
    }
  }, [_vm._v("横版")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowAllFormItems) ? _c('div', {
    staticClass: "open",
    on: {
      "click": function () { return (_vm.isShowAllFormItems = !_vm.isShowAllFormItems); }
    }
  }, [_c('div', [_vm._v("展开更多")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(627),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowAllFormItems) ? _c('div', {
    staticClass: "open",
    on: {
      "click": function () { return (_vm.isShowAllFormItems = !_vm.isShowAllFormItems); }
    }
  }, [_c('div', [_vm._v("收起更多")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(632),
      "alt": ""
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "line"
  })], 1), _vm._v(" "), _c('el-col', [_c('el-button', {
    staticClass: "btn",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reGetList
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toData2
    }
  }, [_vm._v("下载")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "border-radius": "20px 20px 0 0",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.formData['tableData'],
      "tooltip-effect": "dark",
      "header-cell-style": _vm.headerStyle,
      "cell-style": _vm.cellStyle
    }
  }, _vm._l((_vm.formData['tableHeaders']), function(header, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "label": header,
        "align": "center",
        "width": "160px"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(scope.row[header]) + "\n            ")]
        }
      }], null, true)
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Table",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTable
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.tableData1), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "cursor": "pointer",
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "clearFix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(item)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px",
        "display": "block",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.sName))])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(item)
        }
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%",
        "font-size": "12px"
      },
      attrs: {
        "data": item.list,
        "show-header": false
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "sColumnCode",
        "label": ""
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sColumnName",
        "label": ""
      }
    })], 1)], 1)])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Table",
      "visible": _vm.addTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sName", $$v)
      },
      expression: "form.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchemaName", $$v)
      },
      expression: "form.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSelectName", $$v)
      },
      expression: "form.sSelectName"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.queryTableColumns
    }
  }, [_vm._v("Query")])], 1), _vm._v(" "), _vm._l((_vm.form.selectColumnList), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.adddisplayname(_vm.form.selectColumnList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletedisplayname(_vm.form.selectColumnList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTable
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Table",
      "visible": _vm.viewTableFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewTableFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.view.sName),
      callback: function($$v) {
        _vm.$set(_vm.view, "sName", $$v)
      },
      expression: "view.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.view.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view, "sSchemaName", $$v)
      },
      expression: "view.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.view.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.view, "sSelectName", $$v)
      },
      expression: "view.sSelectName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.view.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "list"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("DB Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.adddisplayname(_vm.view.list)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletedisplayname(_vm.view.list, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewTableFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteTable
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateTable
    }
  }, [_vm._v("Update")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Table Relation",
      "name": "second"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTableRelation
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.tableData2), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "cursor": "pointer",
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "clearFix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail2(item)
        }
      },
      slot: "header"
    }, [_c('div', [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.nSelect1Id.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-size": "16px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.nSelect1Id.sName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.nSelect2Id.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "font-size": "16px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.nSelect2Id.sName))])])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "padding": "0 0px"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail2(item)
        }
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%",
        "font-size": "12px"
      },
      attrs: {
        "data": item.list,
        "show-header": false
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "nSelect1Key",
        "label": "",
        "width": ""
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "nSelect1Key",
        "label": "",
        "width": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t=\n\t\t\t\t\t\t\t\t\t")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "nSelect2Key",
        "label": "",
        "width": ""
      }
    })], 1)], 1)])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Table Relation",
      "visible": _vm.addTableRelatiionFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTableRelatiionFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form2",
    attrs: {
      "model": _vm.form2,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Schema1",
      "prop": "sName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.change(1)
      }
    },
    model: {
      value: (_vm.form2.ku1),
      callback: function($$v) {
        _vm.$set(_vm.form2, "ku1", $$v)
      },
      expression: "form2.ku1"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name1",
      "prop": "nSelect1Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(1)
      }
    },
    model: {
      value: (_vm.form2.nSelect1Id),
      callback: function($$v) {
        _vm.$set(_vm.form2, "nSelect1Id", $$v)
      },
      expression: "form2.nSelect1Id"
    }
  }, _vm._l((_vm.biao1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema2",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        return _vm.change(2)
      }
    },
    model: {
      value: (_vm.form2.ku2),
      callback: function($$v) {
        _vm.$set(_vm.form2, "ku2", $$v)
      },
      expression: "form2.ku2"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name2",
      "prop": "nSelect2Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(2)
      }
    },
    model: {
      value: (_vm.form2.nSelect2Id),
      callback: function($$v) {
        _vm.$set(_vm.form2, "nSelect2Id", $$v)
      },
      expression: "form2.nSelect2Id"
    }
  }, _vm._l((_vm.biao2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.form2.selectColumnList), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Relation Colunm1.' + (index + 1),
        "prop": "selectColumnList"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect1Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect1Key", $$v)
        },
        expression: "item.nSelect1Key"
      }
    }, _vm._l((_vm.ziduan1), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("= Relation Colunm2." + _vm._s(index + 1))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect2Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect2Key", $$v)
        },
        expression: "item.nSelect2Key"
      }
    }, _vm._l((_vm.ziduan2), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addRelationCloumn(_vm.form2.selectColumnList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRelationCloumn(_vm.form2.selectColumnList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTableRelatiionFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.SaveTableRelation
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Table Relation",
      "visible": _vm.viewTableRelatiionFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewTableRelatiionFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Schema1",
      "prop": "sName"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.change(1)
      }
    },
    model: {
      value: (_vm.view2.nSelect1Id.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect1Id, "sSchemaName", $$v)
      },
      expression: "view2.nSelect1Id.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name1",
      "prop": "nSelect1Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(1)
      }
    },
    model: {
      value: (_vm.view2.nSelect1Id.nSelectId),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect1Id, "nSelectId", $$v)
      },
      expression: "view2.nSelect1Id.nSelectId"
    }
  }, _vm._l((_vm.biao1), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema2",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "Select"
    },
    on: {
      "change": function($event) {
        return _vm.change(2)
      }
    },
    model: {
      value: (_vm.view2.nSelect2Id.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect2Id, "sSchemaName", $$v)
      },
      expression: "view2.nSelect2Id.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name2",
      "prop": "nSelect2Id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.change2(2)
      }
    },
    model: {
      value: (_vm.view2.nSelect2Id.nSelectId),
      callback: function($$v) {
        _vm.$set(_vm.view2.nSelect2Id, "nSelectId", $$v)
      },
      expression: "view2.nSelect2Id.nSelectId"
    }
  }, _vm._l((_vm.biao2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSelectName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.view2.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Relation Colunm1.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect1Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect1Key", $$v)
        },
        expression: "item.nSelect1Key"
      }
    }, _vm._l((_vm.ziduan1), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("= Relation Colunm2." + _vm._s(index + 1))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.nSelect2Key),
        callback: function($$v) {
          _vm.$set(item, "nSelect2Key", $$v)
        },
        expression: "item.nSelect2Key"
      }
    }, _vm._l((_vm.ziduan2), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnCode,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addRelationCloumn(_vm.view2.list)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRelationCloumn(_vm.view2.list, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewTableRelatiionFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.DeleteTableRelation
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.UpdateTableRelation
    }
  }, [_vm._v("Update")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Stored Procedure",
      "name": "last"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSP
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.spData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "box-card",
      staticStyle: {
        "cursor": "pointer",
        "vertical-align": "top"
      }
    }, [_c('div', {
      staticClass: "clearFix",
      attrs: {
        "slot": "header"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail3(item)
        }
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.sSchemaSelectName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px",
        "display": "block",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(item.sName))])]), _vm._v(" "), _c('div', {
      staticClass: "text item",
      staticStyle: {
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail3(item)
        }
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%",
        "font-size": "12px"
      },
      attrs: {
        "data": item.list,
        "show-header": false
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "sColumnCode",
        "label": ""
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sColumnName",
        "label": ""
      }
    })], 1)], 1)])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Stored Procedure",
      "visible": _vm.addSPFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addSPFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form3",
    attrs: {
      "model": _vm.form3,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form3.sName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "sName", $$v)
      },
      expression: "form3.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form3.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "sSchemaName", $$v)
      },
      expression: "form3.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Stored Procedure Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form3.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "sSelectName", $$v)
      },
      expression: "form3.sSelectName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form3.spConditionList), function(item, index) {
    return _c('el-form-item', {
      key: 's1' + index,
      attrs: {
        "label": "SP Parameter Name.",
        "prop": "spConditionList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterName),
        callback: function($$v) {
          _vm.$set(item, "sParameterName", $$v)
        },
        expression: "item.sParameterName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Code.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterCode),
        callback: function($$v) {
          _vm.$set(item, "sParameterCode", $$v)
        },
        expression: "item.sParameterCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterType),
        callback: function($$v) {
          _vm.$set(item, "sParameterType", $$v)
        },
        expression: "item.sParameterType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("Required.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sRequired),
        callback: function($$v) {
          _vm.$set(item, "sRequired", $$v)
        },
        expression: "item.sRequired"
      }
    }, _vm._l((_vm.options3), function(a) {
      return _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addsppartyname(_vm.form3.spConditionList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletesppartyname(_vm.form3.spConditionList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.form3.selectColumnList), function(item, index) {
    return _c('el-form-item', {
      key: 's2' + index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addspname(_vm.form3.selectColumnList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletespname(_vm.form3.selectColumnList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addSPFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSP
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Stored Procedure",
      "visible": _vm.viewSPFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewSPFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name.",
      "prop": "sName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.view3.sName),
      callback: function($$v) {
        _vm.$set(_vm.view3, "sName", $$v)
      },
      expression: "view3.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchemaName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.view3.sSchemaName),
      callback: function($$v) {
        _vm.$set(_vm.view3, "sSchemaName", $$v)
      },
      expression: "view3.sSchemaName"
    }
  }, _vm._l((_vm.tableData3), function(item) {
    return _c('el-option', {
      key: item.sSchema,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "DB Table Name.",
      "prop": "sSelectName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.view3.sSelectName),
      callback: function($$v) {
        _vm.$set(_vm.view3, "sSelectName", $$v)
      },
      expression: "view3.sSelectName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.view3.spConditionList), function(item, index) {
    return _c('el-form-item', {
      key: 's1' + index,
      attrs: {
        "label": "SP Parameter Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterName),
        callback: function($$v) {
          _vm.$set(item, "sParameterName", $$v)
        },
        expression: "item.sParameterName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Code.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterCode),
        callback: function($$v) {
          _vm.$set(item, "sParameterCode", $$v)
        },
        expression: "item.sParameterCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Parameter Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sParameterType),
        callback: function($$v) {
          _vm.$set(item, "sParameterType", $$v)
        },
        expression: "item.sParameterType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("Required.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sRequired),
        callback: function($$v) {
          _vm.$set(item, "sRequired", $$v)
        },
        expression: "item.sRequired"
      }
    }, _vm._l((_vm.options3), function(a) {
      return _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addsppartyname(_vm.view3.spConditionList)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletesppartyname(_vm.view3.spConditionList, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.view3.list), function(item, index) {
    return _c('el-form-item', {
      key: 's2' + index,
      attrs: {
        "label": "Display Column Name.",
        "prop": "list"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnName),
        callback: function($$v) {
          _vm.$set(item, "sColumnName", $$v)
        },
        expression: "item.sColumnName"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Name.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }), _vm._v(" "), _c('label', [_vm._v("SP Column Type.")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnType),
        callback: function($$v) {
          _vm.$set(item, "sColumnType", $$v)
        },
        expression: "item.sColumnType"
      }
    }, _vm._l((_vm.options2), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.adddisplayname(_vm.view3.list)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletedisplayname(_vm.view3.list, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewSPFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteSpTable
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateSpTable
    }
  }, [_vm._v("Update")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Database",
      "name": "third"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addDataBaseFlag = true
      }
    }
  }, [_vm._v("Add Database")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData3,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.toDataDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sDatabaseIp",
      "label": "Host&Port"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sSchema",
      "label": "Schema"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sUsername",
      "label": "User Name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Database",
      "visible": _vm.addDataBaseFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addDataBaseFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "addDataBaseForm",
    attrs: {
      "model": _vm.addDataBaseForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Host&Port.",
      "prop": "sDatabaseIp"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Host&Port"
    },
    model: {
      value: (_vm.addDataBaseForm.sDatabaseIp),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sDatabaseIp", $$v)
      },
      expression: "addDataBaseForm.sDatabaseIp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Schema"
    },
    model: {
      value: (_vm.addDataBaseForm.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sSchema", $$v)
      },
      expression: "addDataBaseForm.sSchema"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Name.",
      "prop": "sUsername"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.addDataBaseForm.sUsername),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sUsername", $$v)
      },
      expression: "addDataBaseForm.sUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password.",
      "prop": "sPassword"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Password"
    },
    model: {
      value: (_vm.addDataBaseForm.sPassword),
      callback: function($$v) {
        _vm.$set(_vm.addDataBaseForm, "sPassword", $$v)
      },
      expression: "addDataBaseForm.sPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDataBaseFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAddDataBaseFlag
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Database",
      "visible": _vm.editDataBaseFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDataBaseFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "editDataBaseForm",
    attrs: {
      "model": _vm.editDataBaseForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Host&Port.",
      "prop": "sDatabaseIp"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": "disabled",
      "placeholder": "Host&Port"
    },
    model: {
      value: (_vm.editDataBaseForm.sDatabaseIp),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sDatabaseIp", $$v)
      },
      expression: "editDataBaseForm.sDatabaseIp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Schema.",
      "prop": "sSchema"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": "disabled",
      "placeholder": "Schema"
    },
    model: {
      value: (_vm.editDataBaseForm.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sSchema", $$v)
      },
      expression: "editDataBaseForm.sSchema"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Name.",
      "prop": "sUsername"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "User Name"
    },
    model: {
      value: (_vm.editDataBaseForm.sUsername),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sUsername", $$v)
      },
      expression: "editDataBaseForm.sUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password.",
      "prop": "sPassword"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "Password"
    },
    model: {
      value: (_vm.editDataBaseForm.sPassword),
      callback: function($$v) {
        _vm.$set(_vm.editDataBaseForm, "sPassword", $$v)
      },
      expression: "editDataBaseForm.sPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDataBaseFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEditDataBaseFlag
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "border-radius": "20px 20px 0 0",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.tableData1,
      "tooltip-effect": "dark",
      "header-cell-style": _vm.headerStyle,
      "cell-style": _vm.cellStyle
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DocumentName",
      "align": "center",
      "label": "文档名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下载地址",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "icon": "el-icon-download"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("No Role No Data")])
},staticRenderFns: []}

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "文件上传",
      "name": "first"
    }
  }, [_c('el-row', [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.detail,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File Name",
      "prop": "sFileName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "readonly": "",
      "disabled": "",
      "placeholder": "Please select file(excel)"
    },
    model: {
      value: (_vm.detail.sFileName),
      callback: function($$v) {
        _vm.$set(_vm.detail, "sFileName", $$v)
      },
      expression: "detail.sFileName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "upload-button"
  }, [_vm._v("\n                Select\n                "), _c('input', {
    attrs: {
      "id": "files",
      "type": "file"
    },
    on: {
      "change": _vm.changeFile
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结存版本号",
      "prop": "sVersion"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.sVersion),
      callback: function($$v) {
        _vm.sVersion = $$v
      },
      expression: "sVersion"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指标名称",
      "prop": "sName"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.sName),
      callback: function($$v) {
        _vm.sName = $$v
      },
      expression: "sName"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "prop": "nTemplateId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.nTemplateId),
      callback: function($$v) {
        _vm.nTemplateId = $$v
      },
      expression: "nTemplateId"
    }
  }, _vm._l((_vm.options3), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Multi Table",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "30px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.step
    }
  }, [_c('el-step', {
    attrs: {
      "title": "The First step",
      "description": "Select Object"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Second step",
      "description": "Select Keys"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Third step",
      "description": "Select Conditions"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Fourth step",
      "description": "Select Display Column"
    }
  })], 1)], 1), _vm._v(" "), (_vm.step == 0) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Schema"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.change1
    },
    model: {
      value: (_vm.form.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchema", $$v)
      },
      expression: "form.sSchema"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.form.table), function(item, index) {
    return (!!_vm.form.sSchema) ? _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Table"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "600px"
      },
      attrs: {
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.change2(item, index)
        }
      },
      model: {
        value: (item.nSelectId),
        callback: function($$v) {
          _vm.$set(item, "nSelectId", $$v)
        },
        expression: "item.nSelectId"
      }
    }, _vm._l((item.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.sName,
          "value": item.nSelectId
        }
      })
    }), 1), _vm._v(" "), (index == 0 && _vm.form.table.length < 3) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addTable(_vm.form.table)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTable(_vm.form.table, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toStep1
    }
  }, [_vm._v("The Next Step")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_vm._l((_vm.form.table), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v(_vm._s(item.sName) + " (" + _vm._s(item.sBie) + ")")])
  }), _vm._v(" "), _vm._l((_vm.form.keys), function(item, index) {
    return _c('el-form-item', {
      key: index
    }, [_c('span', [_vm._v("Table.1")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      on: {
        "change": function($event) {
          return _vm.change3(item, index)
        }
      },
      model: {
        value: (item.sBie1),
        callback: function($$v) {
          _vm.$set(item, "sBie1", $$v)
        },
        expression: "item.sBie1"
      }
    }, _vm._l((_vm.form.table), function(a, index) {
      return (_vm.panduanTable1(a, item)) ? _c('el-option', {
        key: index,
        attrs: {
          "label": a.sName + '(' + a.sBie + ')',
          "value": a.sBie
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), _c('span', [_vm._v("Table.2")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": ""
      },
      on: {
        "change": function($event) {
          return _vm.change3(item, index)
        }
      },
      model: {
        value: (item.sBie2),
        callback: function($$v) {
          _vm.$set(item, "sBie2", $$v)
        },
        expression: "item.sBie2"
      }
    }, _vm._l((_vm.form.table), function(a, index) {
      return (a.sBie != item.sBie1) ? _c('el-option', {
        key: index,
        attrs: {
          "label": a.sName + '(' + a.sBie + ')',
          "value": a.sBie
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), _c('span', [_vm._v("Condition")]), _vm._v(" "), _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "placeholder": ""
      },
      model: {
        value: (item.selectKey),
        callback: function($$v) {
          _vm.$set(item, "selectKey", $$v)
        },
        expression: "item.selectKey"
      }
    }, _vm._l((item.keys), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.nSelect1Key + '=' + item.nSelect2Key,
          "value": item.nSelect1Key + '=' + item.nSelect2Key
        }
      })
    }), 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addkey(_vm.form.keys)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deletekey(_vm.form.keys, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toStep0
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toStep2
    }
  }, [_vm._v("The Next Step")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_vm._l((_vm.form.table), function(item, index) {
    return _c('el-form-item', {
      key: 'table' + index,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.sName) + " (" + _vm._s(item.sBie) + ")\n\t\t\t\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.form.keys), function(item, index) {
    return _c('el-form-item', {
      key: 's1' + index,
      attrs: {
        "label": 'Keys' + (index + 1)
      }
    }, _vm._l((item.selectKey), function(a, index) {
      return _c('span', {
        key: 's2' + index
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.sName1) + "(" + _vm._s(item.sBie1) + ")." + _vm._s(_vm.stringArr(a, 0)) + "=" + _vm._s(item.sName2) + "(" + _vm._s(item.sBie2) + ")." + _vm._s(_vm.stringArr(a, 1)) + "\n\t\t\t\t\t\t\t\t"), (index != item.selectKey.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.form.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: 's3' + index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.change4(item, index)
        }
      },
      model: {
        value: (item.sBie),
        callback: function($$v) {
          _vm.$set(item, "sBie", $$v)
        },
        expression: "item.sBie"
      }
    }, _vm._l((_vm.form.table), function(a, index) {
      return _c('el-option', {
        key: 'table2' + index,
        attrs: {
          "label": a.sName + '(' + a.sBie + ')',
          "value": a.sBie
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.change5(item)
        }
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((item.codes), function(a, index) {
      return _c('el-option', {
        key: 's5' + index,
        attrs: {
          "label": a.sColumnName,
          "value": a.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.fuhao),
        callback: function($$v) {
          _vm.$set(item, "fuhao", $$v)
        },
        expression: "item.fuhao"
      }
    }, _vm._l((_vm.options4), function(a) {
      return (item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1) ? _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), (item.type != 'Datetime' && item.sSelectName != 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "multiple-limit": item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1,
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": item.type,
        "data-id": index,
        "remote-method": _vm.querySearchAsync,
        "loading": _vm.loading
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : (item.type != 'Datetime' && item.sSelectName == 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    }), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addList(_vm.form.sSelectFilter)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteList(_vm.form.sSelectFilter, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toStep1
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toStep3
    }
  }, [_vm._v("The Next Step")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 5) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "400px"
    }
  }, [_vm._l((_vm.form.table), function(item, index) {
    return _c('el-form-item', {
      key: 'aa1' + index,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v(_vm._s(item.sName) + " (" + _vm._s(item.sBie) + ")")])
  }), _vm._v(" "), _vm._l((_vm.form.keys), function(item, index) {
    return _c('el-form-item', {
      key: 'aa2' + index,
      attrs: {
        "label": 'Keys' + (index + 1)
      }
    }, _vm._l((item.selectKey), function(a, index) {
      return _c('span', {
        key: 'aa3' + index
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.sName1) + "(" + _vm._s(item.sBie1) + ")." + _vm._s(_vm.stringArr(a, 0)) + "=" + _vm._s(item.sName2) + "(" + _vm._s(item.sBie2) + ")." + _vm._s(_vm.stringArr(a, 1)) + "\n\t\t\t\t\t\t\t\t"), (index != item.selectKey.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.form.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: 'aa4' + index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")." + _vm._s(item.sColumnName))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.fuhao))]), _vm._v(" "), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _vm._l((_vm.form.sSelectFieldName), function(item, index) {
    return _c('el-form-item', {
      key: 'a1' + index,
      attrs: {
        "label": item.sNameAll + '(' + item.sBie + ')' + '.Columns'
      }
    }, [_c('el-checkbox', {
      attrs: {
        "indeterminate": item.isIndeterminate
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckAllChange(item)
        }
      },
      model: {
        value: (item.checkAll),
        callback: function($$v) {
          _vm.$set(item, "checkAll", $$v)
        },
        expression: "item.checkAll"
      }
    }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "15px 0"
      }
    }), _vm._v(" "), _c('el-checkbox-group', {
      on: {
        "change": _vm.handleCheckedCitiesChange
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(a, index2) {
      return _c('el-checkbox', {
        key: index + '-' + index2,
        attrs: {
          "label": a.sColumnCode
        }
      }, [_vm._v(_vm._s(a.sColumnName))])
    }), 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toStep2
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save2
    }
  }, [_vm._v("OK")])], 1)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Display result",
      "visible": _vm.dialogVisible,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'UnDisplay' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad
    }
  }, [_vm._v("\n\t\t\t\t\t\tDownload\n\t\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.displayArr), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t\t")])]) : _vm._e()])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Stored Procedure",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "30px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.step
    }
  }, [_c('el-step', {
    attrs: {
      "title": "The First step",
      "description": "Select Stored Procedure"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Second step",
      "description": "Select Conditions"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Third step",
      "description": "Select Display Column"
    }
  })], 1)], 1), _vm._v(" "), (_vm.step == 0) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Stored Procedure"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.nSelectId),
      callback: function($$v) {
        _vm.$set(_vm.form, "nSelectId", $$v)
      },
      expression: "form.nSelectId"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getNext
    }
  }, [_vm._v("The Next Step")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Stored Procedure"
    }
  }, [_vm._v(_vm._s(_vm.form.sName))]), _vm._v(" "), _vm._l((_vm.form.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticStyle: {
        "text-align": "right",
        "display": "inline-block",
        "width": "300px"
      }
    }, [(item.sRequired == 1) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.sParameterName) + "\n\t\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t\t=\n\t\t\t\t\t\t\t"), (item.sParameterType != 'Datetime') ? _c('el-select', {
      staticClass: "user-select-max-height",
      attrs: {
        "filterable": "",
        "clearable": "",
        "multiple": "",
        "placeholder": item.sParameterType
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSetp1
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toSetp2
    }
  }, [_vm._v("The Next Step")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Stored Procedure"
    }
  }, [_vm._v(_vm._s(_vm.form.sName))]), _vm._v(" "), _vm._l((_vm.form.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticStyle: {
        "text-align": "right",
        "display": "inline-block",
        "width": "300px"
      }
    }, [(item.sRequired == 1) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.sParameterName) + "\n\t\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t\t=\n\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Columns"
    }
  }, _vm._l((_vm.options3), function(a) {
    return _c('el-checkbox', {
      key: a.sColumnCode,
      attrs: {
        "disabled": ""
      },
      model: {
        value: (_vm.allCheck),
        callback: function($$v) {
          _vm.allCheck = $$v
        },
        expression: "allCheck"
      }
    }, [_vm._v(_vm._s(a.sColumnName))])
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSetp3
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toData
    }
  }, [_vm._v("OK")])], 1)], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Display result",
      "visible": _vm.dialogVisible,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad
    }
  }, [_vm._v("\n\t\t\t\t\t\tDownload\n\t\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.options3), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item.sColumnCode,
        "label": item.sColumnName
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t\t")])]) : _vm._e()])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Single Table",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "30px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.step
    }
  }, [_c('el-step', {
    attrs: {
      "title": "The First step",
      "description": "Select Object"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Second step",
      "description": "Select Conditions"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "The Third step",
      "description": "Select Display Column"
    }
  })], 1)], 1), _vm._v(" "), (_vm.step == 0) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Schema"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.change1
    },
    model: {
      value: (_vm.form.sSchema),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSchema", $$v)
      },
      expression: "form.sSchema"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sSchema,
        "value": item.sSchema
      }
    })
  }), 1)], 1), _vm._v(" "), (!!_vm.form.sSchema) ? _c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.form.nSelectId),
      callback: function($$v) {
        _vm.$set(_vm.form, "nSelectId", $$v)
      },
      expression: "form.nSelectId"
    }
  }, _vm._l((_vm.options2), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.sName,
        "value": item.nSelectId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.step2
    }
  }, [_vm._v("The Next Step")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.form.sName))]), _vm._v(" "), _vm._l((_vm.form.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.change2(item)
        }
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((_vm.options3), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnName,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.fuhao),
        callback: function($$v) {
          _vm.$set(item, "fuhao", $$v)
        },
        expression: "item.fuhao"
      }
    }, _vm._l((_vm.options4), function(a) {
      return (item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1) ? _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), (item.type != 'Datetime' && _vm.form.sSelectName != 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "multiple-limit": item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1,
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": item.type,
        "data-id": index,
        "remote-method": _vm.querySearchAsync,
        "loading": _vm.loading
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : (item.type != 'Datetime' && _vm.form.sSelectName == 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    }), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addList(_vm.form.sSelectFilter)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteList(_vm.form.sSelectFilter, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.step1
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("The Next Step")])], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.form.sName))]), _vm._v(" "), _vm._l((_vm.form.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sColumnName))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.fuhao))]), _vm._v(" "), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Columns"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.form.sSelectFieldName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sSelectFieldName", $$v)
      },
      expression: "form.sSelectFieldName"
    }
  }, _vm._l((_vm.options3), function(a) {
    return _c('el-checkbox', {
      key: a.sColumnCode,
      attrs: {
        "label": a.sColumnCode
      }
    }, [_vm._v(_vm._s(a.sColumnName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.step2
    }
  }, [_vm._v("The Prev Step")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toData2
    }
  }, [_vm._v("OK")])], 1)], 2)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Display result",
      "visible": _vm.dialogVisible,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad
    }
  }, [_vm._v("\n\t\t\t\tDownload\n\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.form.sSelectFieldName), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\tToo much data,unable to export!\n\t\t\t")])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item')], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "border-radius": "20px 20px 0 0",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "header-cell-style": _vm.headerStyle,
      "cell-style": _vm.cellStyle
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sOperationName",
      "label": "Operation  Name",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "align": "center",
      "label": "Upload Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTemplateName",
      "label": "Template Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTableName",
      "align": "center",
      "label": "Table Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.sSchema) + "." + _vm._s(scope.row.sTableName) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sStatus",
      "label": "Status",
      "align": "center",
      "formatter": _vm.formatterStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sTableName",
      "align": "center",
      "label": "Check Result"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.toDetail(scope.row)
            }
          }
        }, [_vm._v("Detail")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Result",
      "visible": _vm.dialogFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFlag = $event
      }
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableListData,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sFieldName",
      "label": "Field Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sFieldType",
      "label": "Field Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sResult",
      "label": "Result"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.sResult == 1 ? "不通过" : "通过") + "\n          ")]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "border-radius": "20px 20px 0 0",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.tableData1,
      "tooltip-effect": "dark",
      "header-cell-style": _vm.headerStyle,
      "cell-style": _vm.cellStyle
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sFileName",
      "align": "center",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "align": "center",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sStatus",
      "label": "Status",
      "align": "center",
      "formatter": _vm.sStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DownLoad",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sStatus == 1) ? _c('el-button', {
          attrs: {
            "icon": "el-icon-download"
          },
          on: {
            "click": function($event) {
              return _vm.download(scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.sStatus == 0) ? _c('el-button', {
          staticStyle: {
            "border": "none"
          },
          attrs: {
            "icon": "el-icon-loading"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.sStatus == 2) ? _c('el-button', {
          attrs: {
            "icon": "el-icon-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.refresh(scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "User Information",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.sName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sName", $$v)
      },
      expression: "filters.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.sState),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sState", $$v)
      },
      expression: "filters.sState"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reGetList
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addUserFlag = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdd User\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nUserId",
      "label": "User Id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sAccount",
      "label": "Domain Account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sName",
      "label": "User Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sRole",
      "label": "Role"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sState",
      "label": "Status",
      "formatter": _vm.sState
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dLastLogin",
      "label": "Last Sign in"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.tableData3.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    }
  }, [(_vm.filters.sState == 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.toggleSelection(0)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tInactive\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.filters.sState == 0) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.toggleSelection(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tActive\n\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add User",
      "visible": _vm.addUserFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addUserFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Name",
      "prop": "sName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sName", $$v)
      },
      expression: "form.sName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Domain Account",
      "prop": "sAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sAccount),
      callback: function($$v) {
        _vm.$set(_vm.form, "sAccount", $$v)
      },
      expression: "form.sAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addUserFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Role Information",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "RoleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.sRoleName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sRoleName", $$v)
      },
      expression: "filters.sRoleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.sState),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sState", $$v)
      },
      expression: "filters.sState"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.reGetList()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addRoleFlag = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdd Role\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.toDetailRole,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sRoleName",
      "label": "Role Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sRoleDescribe",
      "label": "Role Description"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sState",
      "label": "Status",
      "formatter": _vm.sState
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.tableData3.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    }
  }, [(_vm.filters.sState == 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.toggleSelection(0)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tInactive\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.filters.sState == 0) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.toggleSelection(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tActive\n\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Roles",
      "visible": _vm.addRoleFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addRoleFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "sRoleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sRoleName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sRoleName", $$v)
      },
      expression: "form.sRoleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.roles),
      callback: function($$v) {
        _vm.$set(_vm.form, "roles", $$v)
      },
      expression: "form.roles"
    }
  }, _vm._l((_vm.options3), function(a) {
    return _c('el-checkbox', {
      key: a.id,
      attrs: {
        "label": a.name
      }
    }, [_vm._v(_vm._s(a.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role Describe",
      "prop": "sRoleDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sRoleDescribe),
      callback: function($$v) {
        _vm.$set(_vm.form, "sRoleDescribe", $$v)
      },
      expression: "form.sRoleDescribe"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addRoleFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Roles",
      "visible": _vm.EditRoleFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.EditRoleFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "sRoleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.detailForm.sRoleName),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sRoleName", $$v)
      },
      expression: "detailForm.sRoleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.detailForm.roles),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "roles", $$v)
      },
      expression: "detailForm.roles"
    }
  }, _vm._l((_vm.options3), function(a) {
    return _c('el-checkbox', {
      key: a.id,
      attrs: {
        "label": a.name
      }
    }, [_vm._v(_vm._s(a.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role Describe",
      "prop": "sRoleDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ""
    },
    model: {
      value: (_vm.detailForm.sRoleDescribe),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sRoleDescribe", $$v)
      },
      expression: "detailForm.sRoleDescribe"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.EditRoleFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "User Related",
      "name": "second"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters2.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters2, "nRoleId", $$v)
      },
      expression: "filters2.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change2
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.filterMethod2,
      "titles": ['Unselect', 'Select'],
      "filter-placeholder": "Name",
      "data": _vm.leftRoleList2
    },
    model: {
      value: (_vm.filters2.nUserIds),
      callback: function($$v) {
        _vm.$set(_vm.filters2, "nUserIds", $$v)
      },
      expression: "filters2.nUserIds"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.save2
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Data Source Related",
      "name": "third"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters3,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters3.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters3, "nRoleId", $$v)
      },
      expression: "filters3.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return (item.nRoleId != 1) ? _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change3
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.filterMethod3,
      "titles": ['Unselect', 'Select'],
      "filter-placeholder": "Name",
      "data": _vm.leftRoleList3
    },
    model: {
      value: (_vm.filters3.nSelectIds),
      callback: function($$v) {
        _vm.$set(_vm.filters3, "nSelectIds", $$v)
      },
      expression: "filters3.nSelectIds"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.save3
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Table Management",
      "name": "fourth"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters4,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters4.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters4, "nRoleId", $$v)
      },
      expression: "filters4.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return (item.nRoleId != 1) ? _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change4
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData4
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sSchemaName",
      "label": "Schema"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sSelectName",
      "label": "SelectName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valueStatus",
      "label": "valueStatus",
      "formatter": _vm.valueStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fieldStatus",
      "label": "fieldStatus",
      "formatter": _vm.fieldStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operation"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "icon": "el-icon-date"
          },
          on: {
            "click": function($event) {
              return _vm.changeDetail1(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "icon": "el-icon-edit-outline"
          },
          on: {
            "click": function($event) {
              return _vm.changeDetail2(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.ViewFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ViewFlag = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticStyle: {
      "font-size": "20px",
      "margin-right": "30px"
    }
  }, [_vm._v("Value Management")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addView
    }
  }, [_vm._v("Add+")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, _vm._l((_vm.ViewForm.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((_vm.ViewOptions), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnName,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("Value.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnValue),
        callback: function($$v) {
          _vm.$set(item, "sColumnValue", $$v)
        },
        expression: "item.sColumnValue"
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteView(index)
        }
      }
    }, [_vm._v("Delete-")])], 1)
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ViewFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveViewFlag
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": " Field Management",
      "visible": _vm.ViewFieldFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ViewFieldFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "border": "",
      "size": "medium",
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.ViewFieldForm.list),
      callback: function($$v) {
        _vm.$set(_vm.ViewFieldForm, "list", $$v)
      },
      expression: "ViewFieldForm.list"
    }
  }, _vm._l((_vm.ViewOptions), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "border": "",
        "size": "medium",
        "label": item.sColumnCode
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ViewFieldFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveViewFieldFlag
    }
  }, [_vm._v("Confirm")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Template Related",
      "name": "fivth"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters5,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters5.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters5, "nRoleId", $$v)
      },
      expression: "filters5.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return (item.nRoleId != 1) ? _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change5
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.filterMethod5,
      "titles": ['Unselect', 'Select'],
      "filter-placeholder": "Name",
      "data": _vm.leftRoleList5
    },
    model: {
      value: (_vm.filters5.nTemplateIds),
      callback: function($$v) {
        _vm.$set(_vm.filters5, "nTemplateIds", $$v)
      },
      expression: "filters5.nTemplateIds"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.save5
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logoBox",
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": __webpack_require__(635)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Data Report Portal")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "menu",
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.routersList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "menuItem",
      on: {
        "click": function($event) {
          return _vm.clickMenuItem(index, item)
        }
      }
    }, [(item.id < 5) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentIndex == index),
        expression: "currentIndex == index"
      }],
      staticClass: "item active"
    }, [(item.name === '报告中心') ? _c('img', {
      staticClass: "icon-report",
      attrs: {
        "src": __webpack_require__(631),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'Admin') ? _c('img', {
      staticClass: "icon-admin",
      attrs: {
        "src": __webpack_require__(624),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.name === '上传中心') ? _c('img', {
      staticClass: "icon-upload",
      attrs: {
        "src": __webpack_require__(634),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item.id < 5) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentIndex !== index),
        expression: "currentIndex !== index"
      }],
      staticClass: "item"
    }, [(item.name === '报告中心') ? _c('img', {
      staticClass: "icon-report",
      attrs: {
        "src": __webpack_require__(630),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'Admin') ? _c('img', {
      staticClass: "icon-admin",
      attrs: {
        "src": __webpack_require__(623),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.name === '上传中心') ? _c('img', {
      staticClass: "icon-upload",
      attrs: {
        "src": __webpack_require__(633),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 6
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.sName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dLastLogin))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(636)
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.routersList), function(item, index) {
    return (_vm.$route.meta == item.id && item.id < 5) ? _c('el-col', {
      key: index,
      staticClass: "tabBox",
      attrs: {
        "span": 24
      }
    }, _vm._l((item.children), function(item2, index2) {
      return _c('div', {
        key: index2,
        staticClass: "tabItem",
        class: {
          first: index2 == 0,
            last: index2 == item.children.length - 1 && index2 > 0,
            active: index2 === _vm.tabIndex
        },
        on: {
          "click": function($event) {
            return _vm.clickTab(index2, item2)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item2.name === '报告查看' && index2 !== _vm.tabIndex),
          expression: "item2.name === '报告查看' && index2 !== tabIndex"
        }],
        staticClass: "check",
        attrs: {
          "src": __webpack_require__(625),
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item2.name === '报告查看' && index2 == _vm.tabIndex),
          expression: "item2.name === '报告查看' && index2 == tabIndex"
        }],
        staticClass: "check",
        attrs: {
          "src": __webpack_require__(626),
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item2.name === '报告下载' && index2 !== _vm.tabIndex),
          expression: "item2.name === '报告下载' && index2 !== tabIndex"
        }],
        staticClass: "download",
        attrs: {
          "src": __webpack_require__(628),
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item2.name === '报告下载' && index2 == _vm.tabIndex),
          expression: "item2.name === '报告下载' && index2 == tabIndex"
        }],
        staticClass: "download",
        attrs: {
          "src": __webpack_require__(629),
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item2.name))])])
    }), 0) : _vm._e()
  }), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": ">"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return (item.id < 3) ? _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Change Password",
      "visible": _vm.changeFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.changeFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Old Password",
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "oldPwd", $$v)
      },
      expression: "form.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPwd", $$v)
      },
      expression: "form.newPwd"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.changeFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Single Table",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.singleTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sViewName",
      "label": "Favorite"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nDownloads",
      "label": "Downloads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view1.sViewName,
      "visible": _vm.dialogVisible1,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible1 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view1.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view1.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sColumnName))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.fuhao))]), _vm._v(" "), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Columns"
    }
  }, _vm._l((_vm.view1.sContent.sSelectFieldName), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.zhuanhuanItem(item)))])
  }), 0)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doDownload1
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doEdit1
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delete1
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view1.sViewName + 'Edit',
      "visible": _vm.dialogVisible11,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible11 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view1.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view1.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.change2(item)
        }
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((_vm.options3), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnName,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.fuhao),
        callback: function($$v) {
          _vm.$set(item, "fuhao", $$v)
        },
        expression: "item.fuhao"
      }
    }, _vm._l((_vm.options4), function(a) {
      return (item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1) ? _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), (item.type != 'Datetime' && _vm.view1.sContent.sSelectName != 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "multiple-limit": item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1,
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": item.type,
        "data-id": index,
        "remote-method": _vm.querySearchAsync,
        "loading": _vm.loading
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : (item.type != 'Datetime' && _vm.view1.sContent.sSelectName == 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    }), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addList(_vm.view1.sContent.sSelectFilter)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteList(_vm.view1.sContent.sSelectFilter, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Columns"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.view1.sContent.sSelectFieldName),
      callback: function($$v) {
        _vm.$set(_vm.view1.sContent, "sSelectFieldName", $$v)
      },
      expression: "view1.sContent.sSelectFieldName"
    }
  }, _vm._l((_vm.options3), function(item) {
    return _c('el-checkbox', {
      key: item.sColumnCode,
      attrs: {
        "label": item.sColumnCode
      }
    }, [_vm._v(_vm._s(item.sColumnName))])
  }), 1)], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save1
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save11
    }
  }, [_vm._v("save as")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible11 = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view1.sViewName + 'Display result',
      "visible": _vm.dialogVisible2,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad
    }
  }, [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.view1.sContent.sSelectFieldName), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t")])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Multi Table",
      "name": "second"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData2,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.multiTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sViewName",
      "label": "Favorite"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nDownloads",
      "label": "Downloads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view2.sViewName,
      "visible": _vm.dialogVisible3,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible3 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_vm._l((_vm.view2.sContent.table), function(item, index) {
    return _c('el-form-item', {
      key: item.nSelectId,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")\n\t\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.keys), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Keys' + (index + 1)
      }
    }, _vm._l((item.selectKey), function(a, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.sName1) + "(" + _vm._s(item.sBie1) + ")." + _vm._s(_vm.stringArr(a, 0)) + "=" + _vm._s(item.sName2) + "(" + _vm._s(item.sBie2) + ")." + _vm._s(_vm.stringArr(a, 1)) + "\n\t\t\t\t\t\t"), (index != item.selectKey.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")." + _vm._s(item.sColumnName))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.fuhao))]), _vm._v(" "), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFieldName), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Columns"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.sNameAll + '(' + item.sBie + ')' + '.Columns'))]), _vm._v(" "), _vm._l((item.value), function(a) {
      return _c('span', {
        staticClass: "span-label"
      }, [_vm._v(_vm._s(_vm.zhuanhuanItem2(item.options, a)))])
    })], 2)
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doDownload2
    }
  }, [_vm._v("DownLoad")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doEdit2
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delete2
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view2.sViewName + 'Edit',
      "visible": _vm.dialogVisible31,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible31 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_vm._l((_vm.view2.sContent.table), function(item, index) {
    return _c('el-form-item', {
      key: item.nSelectId,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")\n\t\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.keys), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Keys' + (index + 1)
      }
    }, _vm._l((item.selectKey), function(a, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.sName1) + "(" + _vm._s(item.sBie1) + ")." + _vm._s(_vm.stringArr(a, 0)) + "=" + _vm._s(item.sName2) + "(" + _vm._s(item.sBie2) + ")." + _vm._s(_vm.stringArr(a, 1)) + "\n\t\t\t\t\t\t"), (index != item.selectKey.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.change4(item, index, _vm.view2.sContent.sSelectFilter)
        }
      },
      model: {
        value: (item.sBie),
        callback: function($$v) {
          _vm.$set(item, "sBie", $$v)
        },
        expression: "item.sBie"
      }
    }, _vm._l((_vm.view2.sContent.table), function(a) {
      return _c('el-option', {
        key: a.sBie,
        attrs: {
          "label": a.sName + '(' + a.sBie + ')',
          "value": a.sBie
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.change5(item)
        }
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((item.codes), function(a) {
      return _c('el-option', {
        key: a.sColumnCode,
        attrs: {
          "label": a.sColumnName,
          "value": a.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.fuhao),
        callback: function($$v) {
          _vm.$set(item, "fuhao", $$v)
        },
        expression: "item.fuhao"
      }
    }, _vm._l((_vm.options4), function(a) {
      return (item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1) ? _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), (item.type != 'Datetime' && item.sSelectName != 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "multiple-limit": item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1,
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": item.type,
        "data-id": index,
        "remote-method": _vm.querySearchAsync2,
        "loading": _vm.loading
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : (item.type != 'Datetime' && item.sSelectName == 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    }), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addList2(_vm.view2.sContent.sSelectFilter)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteList2(_vm.view2.sContent.sSelectFilter, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFieldName), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Columns"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "indeterminate": item.isIndeterminate
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckAllChange2(item)
        }
      },
      model: {
        value: (item.checkAll),
        callback: function($$v) {
          _vm.$set(item, "checkAll", $$v)
        },
        expression: "item.checkAll"
      }
    }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.sNameAll) + "(" + _vm._s(item.sBie) + ")")]), _vm._v(" "), _c('el-checkbox-group', {
      on: {
        "change": _vm.handleCheckedCitiesChange2
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(a) {
      return _c('el-checkbox', {
        key: a.sColumnCode,
        attrs: {
          "label": a.sColumnCode
        }
      }, [_vm._v(_vm._s(a.sColumnName))])
    }), 1)], 1)
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save3
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save31
    }
  }, [_vm._v("Save as")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible31 = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view2.sViewName + 'Display result',
      "visible": _vm.dialogVisible4,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible4 = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad2
    }
  }, [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.displayArr), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t")])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Stored Procedure",
      "name": "third"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData3,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.sp
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sViewName",
      "label": "Favorite"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nDownloads",
      "label": "Downloads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total3
    },
    on: {
      "current-change": _vm.handleCurrentChange3
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view3.sViewName,
      "visible": _vm.dialogVisible5,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible5 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view3.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view3.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label",
      staticStyle: {
        "text-align": "right",
        "display": "inline-block",
        "width": "300px"
      }
    }, [_vm._v(_vm._s(item.sParameterName))]), _vm._v(" "), _c('label', [_vm._v("=")]), _vm._v(" "), _c('span', {
      staticClass: "span-label",
      staticStyle: {
        "max-height": "100px",
        "overflow": "auto",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Columns"
    }
  }, _vm._l((_vm.view3.sContent.sSelectFieldName), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sColumnName))])
  }), 0)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doQuery3
    }
  }, [_vm._v("Query")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doEdit3
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delete3
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view3.sViewName + 'Edit',
      "visible": _vm.dialogVisible51,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible51 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view3.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view3.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticStyle: {
        "text-align": "right",
        "display": "inline-block",
        "width": "300px"
      }
    }, [(item.sRequired == 1) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.sParameterName) + "\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t=\n\t\t\t\t\t"), (item.sParameterType != 'Datetime') ? _c('el-select', {
      staticClass: "user-select-max-height",
      attrs: {
        "filterable": "",
        "clearable": "",
        "multiple": "",
        "placeholder": item.sParameterType
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Columns"
    }
  }, _vm._l((_vm.view3.sContent.sSelectFieldName), function(a) {
    return _c('el-checkbox', {
      key: a.sColumnCode,
      attrs: {
        "disabled": ""
      },
      model: {
        value: (_vm.allCheck),
        callback: function($$v) {
          _vm.allCheck = $$v
        },
        expression: "allCheck"
      }
    }, [_vm._v(_vm._s(a.sColumnName))])
  }), 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save5
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save51
    }
  }, [_vm._v("save as")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible51 = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view3.sViewName + 'Display result',
      "visible": _vm.dialogVisible6,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible6 = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad3
    }
  }, [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.view3.sContent.sSelectFieldName), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item.sColumnCode,
        "label": item.sColumnName
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t")])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("No permissions ,对不起，您没有权限访问该页面")])
},staticRenderFns: []}

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
	var len = len - (s + '').length;
	for (var i = 0; i < len; i++) {
		s = '0' + s;
	}
	return s;
};
Array.prototype.unique = function () {
	var res = [];
	var json = {};
	for (var i = 0; i < this.length; i++) {
		if (!json[this[i]]) {
			res.push(this[i]);
			json[this[i]] = 1;
		}
	}
	return res;
};
exports.default = {
	getQueryStringByName: function getQueryStringByName(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var r = window.location.search.substr(1).match(reg);
		var context = "";
		if (r != null) context = r[2];
		reg = null;
		r = null;
		return context == null || context == "" || context == "undefined" ? "" : context;
	},
	formatDate: {
		toString: function toString(dataObj) {
			if (!!dataObj) {
				var _str = dataObj['year'] + 1900 + "-" + (dataObj['month'] + 1) + "-" + dataObj['date'];
				return _str;
			} else {
				return "";
			}
		},
		toString2: function toString2(dataObj) {
			if (!!dataObj) {
				var _str = dataObj['year'] + 1900 + "年" + (dataObj['month'] + 1) + "月" + dataObj['date'] + "日" + dataObj['hours'] + ":" + dataObj['minutes'] + "";
				return _str;
			} else {
				return "";
			}
		},
		toString3: function toString3(dataObj) {
			if (!!dataObj) {
				var _str = dataObj['month'] + 1 + "-" + dataObj['date'] + " " + dataObj['hours'] + ":" + dataObj['minutes'] + " ";
				return _str;
			} else {
				return "";
			}
		},
		format: function format(date, pattern) {
			pattern = pattern || DEFAULT_PATTERN;
			return pattern.replace(SIGN_REGEXP, function ($0) {
				switch ($0.charAt(0)) {
					case 'y':
						return padding(date.getFullYear(), $0.length);
					case 'M':
						return padding(date.getMonth() + 1, $0.length);
					case 'd':
						return padding(date.getDate(), $0.length);
					case 'w':
						return date.getDay() + 1;
					case 'h':
						return padding(date.getHours(), $0.length);
					case 'm':
						return padding(date.getMinutes(), $0.length);
					case 's':
						return padding(date.getSeconds(), $0.length);
				}
			});
		},
		parse: function parse(dateString, pattern) {
			var matchs1 = pattern.match(SIGN_REGEXP);
			var matchs2 = dateString.match(/(\d)+/g);
			if (matchs1.length == matchs2.length) {
				var _date = new Date(1970, 0, 1);
				for (var i = 0; i < matchs1.length; i++) {
					var _int = parseInt(matchs2[i]);
					var sign = matchs1[i];
					switch (sign.charAt(0)) {
						case 'y':
							_date.setFullYear(_int);
							break;
						case 'M':
							_date.setMonth(_int - 1);
							break;
						case 'd':
							_date.setDate(_int);
							break;
						case 'h':
							_date.setHours(_int);
							break;
						case 'm':
							_date.setMinutes(_int);
							break;
						case 's':
							_date.setSeconds(_int);
							break;
					}
				}
				return _date;
			}
			return null;
		}

	}

};

/***/ })

},[306]);


// WEBPACK FOOTER //
// static/js/app.805ebd4fd980946cc47e.js